import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: any; output: any; }
};

export type Asset = {
  __typename?: 'Asset';
  balance: Scalars['String']['output'];
  mint: Mint;
  unconfirmedBalance: Scalars['String']['output'];
  usdBalance: Scalars['String']['output'];
};

export type BatchPayout = {
  __typename?: 'BatchPayout';
  chain: Chain;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  feeAmount?: Maybe<Scalars['String']['output']>;
  feeBps?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  idempotencyKey: Scalars['String']['output'];
  initiatedBy?: Maybe<BatchPayoutActor>;
  label?: Maybe<Scalars['String']['output']>;
  mintId: Scalars['Int']['output'];
  mode: BatchPayoutMode;
  networkFee?: Maybe<BatchPayoutNetworkFee>;
  organizationId: Scalars['String']['output'];
  phase: BatchPayoutPhase;
  recipientCount: Scalars['Int']['output'];
  recipients: Array<BatchPayoutRecipient>;
  status: BatchPayoutStatus;
  totalAmount: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type BatchPayoutActor = {
  __typename?: 'BatchPayoutActor';
  email: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export enum BatchPayoutMode {
  Bundled = 'BUNDLED',
  Separate = 'SEPARATE'
}

export type BatchPayoutNetworkFee = {
  __typename?: 'BatchPayoutNetworkFee';
  amount: Scalars['String']['output'];
  usdAmount?: Maybe<Scalars['String']['output']>;
};

export enum BatchPayoutPhase {
  AwaitingSplitConfirmation = 'AWAITING_SPLIT_CONFIRMATION',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  PartiallyFailed = 'PARTIALLY_FAILED',
  PayingRecipients = 'PAYING_RECIPIENTS',
  ProvisioningSplits = 'PROVISIONING_SPLITS'
}

export type BatchPayoutRecipient = {
  __typename?: 'BatchPayoutRecipient';
  address: Scalars['String']['output'];
  amount: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  legNetworkFee?: Maybe<BatchPayoutNetworkFee>;
  name?: Maybe<Scalars['String']['output']>;
  payoutBlockConfirmed?: Maybe<Scalars['Int']['output']>;
  payoutConfirmedAt?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  splitConfirmed?: Maybe<Scalars['Boolean']['output']>;
  splitTxid?: Maybe<Scalars['String']['output']>;
  splitVout?: Maybe<Scalars['Int']['output']>;
  status: BatchPayoutRecipientStatus;
  transactionReference?: Maybe<Scalars['String']['output']>;
  txHash?: Maybe<Scalars['String']['output']>;
};

export type BatchPayoutRecipientInput = {
  address: Scalars['String']['input'];
  amount: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

export enum BatchPayoutRecipientStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export enum BatchPayoutStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  PartiallyFailed = 'PARTIALLY_FAILED',
  Processing = 'PROCESSING',
  Submitted = 'SUBMITTED'
}

export type BatchPayoutTokenBalance = {
  __typename?: 'BatchPayoutTokenBalance';
  available: Scalars['String']['output'];
  mint: Mint;
  reserved: Scalars['String']['output'];
  total: Scalars['String']['output'];
};

export type BatchPayoutWallet = {
  __typename?: 'BatchPayoutWallet';
  address: Scalars['String']['output'];
  chain: Chain;
  isTestnet?: Maybe<Scalars['Boolean']['output']>;
  mainWalletId: Scalars['Int']['output'];
};

export enum Chain {
  Bitcoin = 'BITCOIN',
  BitcoinCash = 'BITCOIN_CASH',
  Bsc = 'BSC',
  Ethereum = 'ETHEREUM',
  Litecoin = 'LITECOIN',
  Polygon = 'POLYGON',
  Robinhood = 'ROBINHOOD',
  Solana = 'SOLANA',
  Tron = 'TRON'
}

export type ChainToken = {
  __typename?: 'ChainToken';
  chain: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type ChainTokenInput = {
  chain: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export enum CheckoutConversionIneligibility {
  ChainNotSupported = 'CHAIN_NOT_SUPPORTED',
  IsDestinationAsset = 'IS_DESTINATION_ASSET',
  NoSwapRoute = 'NO_SWAP_ROUTE',
  TestnetMint = 'TESTNET_MINT'
}

export type CheckoutConversionPolicy = {
  __typename?: 'CheckoutConversionPolicy';
  autoSwapCheckoutProceeds: Scalars['Boolean']['output'];
  eligible: Scalars['Boolean']['output'];
  ineligibilityCode?: Maybe<CheckoutConversionIneligibility>;
  ineligibilityReason?: Maybe<Scalars['String']['output']>;
  mint: Mint;
};

export type CheckoutDepositAddress = {
  __typename?: 'CheckoutDepositAddress';
  address: Scalars['String']['output'];
  chain: Scalars['String']['output'];
  checkoutId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  derivationPath: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  organizationId: Scalars['String']['output'];
  sessionId: Scalars['ID']['output'];
};

export type CheckoutDepositAddressList = {
  __typename?: 'CheckoutDepositAddressList';
  hasMore: Scalars['Boolean']['output'];
  items: Array<CheckoutDepositAddress>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type CheckoutFlagAcceptAttestationInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  reason: FlaggedCheckoutAcceptReason;
};

export type CheckoutFlagReview = {
  __typename?: 'CheckoutFlagReview';
  amountReceived: Scalars['String']['output'];
  checkoutId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  depositAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lineItems: Array<CheckoutLineItemSummary>;
  network: Scalars['String']['output'];
  priceUsdSnapshot: Scalars['String']['output'];
  productSnapshot: Scalars['JSON']['output'];
  quarantineDeadlineAt?: Maybe<Scalars['String']['output']>;
  refundAddress: Scalars['String']['output'];
  riskFlag: Scalars['JSON']['output'];
  sessionId: Scalars['ID']['output'];
  token: Scalars['String']['output'];
};

export type CheckoutFlagReviewList = {
  __typename?: 'CheckoutFlagReviewList';
  items: Array<CheckoutFlagReview>;
  total: Scalars['Int']['output'];
};

export type CheckoutLineItemSummary = {
  __typename?: 'CheckoutLineItemSummary';
  id: Scalars['ID']['output'];
  lineTotalUsdSnapshot: Scalars['String']['output'];
  productId: Scalars['ID']['output'];
  productSnapshot: Scalars['JSON']['output'];
  quantity: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
  unitPriceUsdSnapshot: Scalars['String']['output'];
};

export type CheckoutList = {
  __typename?: 'CheckoutList';
  hasMore: Scalars['Boolean']['output'];
  items: Array<CheckoutSummary>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type CheckoutPenaltyDetail = {
  __typename?: 'CheckoutPenaltyDetail';
  checkout: CheckoutSettlementCheckoutInfo;
  penalty: MainWalletTransaction;
  refund?: Maybe<CheckoutPenaltyRefund>;
  refundTxHash: Scalars['String']['output'];
  session: CheckoutSettlementSessionDetail;
};

export type CheckoutPenaltyRefund = {
  __typename?: 'CheckoutPenaltyRefund';
  amount: Scalars['String']['output'];
  confirmedAt?: Maybe<Scalars['String']['output']>;
  txHash: Scalars['String']['output'];
};

export type CheckoutSessionAmountSent = {
  __typename?: 'CheckoutSessionAmountSent';
  amountRequiredCrypto: Scalars['String']['output'];
  amountRequiredUsd: Scalars['String']['output'];
  amountSentCrypto: Scalars['String']['output'];
  amountSentUsd: Scalars['String']['output'];
  isTestnet: Scalars['Boolean']['output'];
  paymentIndicator?: Maybe<CheckoutSessionPaymentIndicator>;
  shortfallCrypto: Scalars['String']['output'];
  shortfallUsd: Scalars['String']['output'];
};

export enum CheckoutSessionPaymentIndicator {
  Expired = 'EXPIRED',
  Partial = 'PARTIAL'
}

export enum CheckoutSessionStatus {
  AwaitingPayment = 'AWAITING_PAYMENT',
  Canceled = 'CANCELED',
  Confirming = 'CONFIRMING',
  Expired = 'EXPIRED',
  FlaggedPendingReview = 'FLAGGED_PENDING_REVIEW',
  FlaggedPlatformHeld = 'FLAGGED_PLATFORM_HELD',
  Overpaid = 'OVERPAID',
  Paid = 'PAID',
  Partial = 'PARTIAL',
  Refunded = 'REFUNDED',
  Refunding = 'REFUNDING',
  RefundFailed = 'REFUND_FAILED',
  RiskScanPending = 'RISK_SCAN_PENDING'
}

export type CheckoutSessionSummary = {
  __typename?: 'CheckoutSessionSummary';
  amountReceived: Scalars['String']['output'];
  amountRequired: Scalars['String']['output'];
  amountSent: CheckoutSessionAmountSent;
  checkoutId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  depositAddress: Scalars['String']['output'];
  depositAddressPath: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mintChain: Scalars['String']['output'];
  mintId: Scalars['Int']['output'];
  mintSymbol: Scalars['String']['output'];
  rateLocked: Scalars['String']['output'];
  status: CheckoutSessionStatus;
  swap?: Maybe<CheckoutSessionSwap>;
  updatedAt: Scalars['String']['output'];
};

export type CheckoutSessionSwap = {
  __typename?: 'CheckoutSessionSwap';
  actualAmountOut?: Maybe<Scalars['String']['output']>;
  amountIn: Scalars['String']['output'];
  amountInUsd?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  destinationTxHashes: Array<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  intentId: Scalars['String']['output'];
  minAmountOut?: Maybe<Scalars['String']['output']>;
  originAssetId: Scalars['String']['output'];
  originBlockchain: Scalars['String']['output'];
  originSymbol: Scalars['String']['output'];
  originTxHashes: Array<Scalars['String']['output']>;
  quotedAmountOut?: Maybe<Scalars['String']['output']>;
  refundFee?: Maybe<Scalars['String']['output']>;
  slippageToleranceBps?: Maybe<Scalars['Int']['output']>;
  status: NearIntentStatus;
  timeEstimateSeconds?: Maybe<Scalars['Int']['output']>;
  withdrawFee?: Maybe<Scalars['String']['output']>;
};

export type CheckoutSettlementCheckoutInfo = {
  __typename?: 'CheckoutSettlementCheckoutInfo';
  id: Scalars['ID']['output'];
  lineItems: Array<CheckoutLineItemSummary>;
  priceUsdSnapshot: Scalars['String']['output'];
  productName: Scalars['String']['output'];
};

export type CheckoutSettlementDeposit = {
  __typename?: 'CheckoutSettlementDeposit';
  amount: Scalars['String']['output'];
  confirmedAt?: Maybe<Scalars['String']['output']>;
  fromAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  txHash: Scalars['String']['output'];
};

export type CheckoutSettlementDetail = {
  __typename?: 'CheckoutSettlementDetail';
  checkout: CheckoutSettlementCheckoutInfo;
  deposits: Array<CheckoutSettlementDeposit>;
  grossReceived: Scalars['String']['output'];
  netSettled: Scalars['String']['output'];
  networkFee?: Maybe<CheckoutSettlementNetworkFee>;
  platformFee?: Maybe<CheckoutSettlementPlatformFee>;
  session: CheckoutSettlementSessionDetail;
  settlement: MainWalletTransaction;
};

export type CheckoutSettlementNetworkFee = {
  __typename?: 'CheckoutSettlementNetworkFee';
  amount: Scalars['String']['output'];
  paidBy: CheckoutSettlementNetworkFeePayer;
  status: TransactionStatus;
  txHash: Scalars['String']['output'];
  uiAmount: Scalars['String']['output'];
  usdAmount: Scalars['String']['output'];
};

export enum CheckoutSettlementNetworkFeePayer {
  DepositWallet = 'DEPOSIT_WALLET',
  GasWallet = 'GAS_WALLET'
}

export type CheckoutSettlementPlatformFee = {
  __typename?: 'CheckoutSettlementPlatformFee';
  amount: Scalars['String']['output'];
  billStatus: PlatformBillStatus;
  uiAmount: Scalars['String']['output'];
  usdAmount: Scalars['String']['output'];
  yearMonth: Scalars['String']['output'];
};

export type CheckoutSettlementSessionDetail = {
  __typename?: 'CheckoutSettlementSessionDetail';
  amountReceived: Scalars['String']['output'];
  amountRequired: Scalars['String']['output'];
  checkoutId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  depositAddress: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isTestnet: Scalars['Boolean']['output'];
  mintChain: Scalars['String']['output'];
  mintId: Scalars['Int']['output'];
  mintSymbol: Scalars['String']['output'];
  rateLocked: Scalars['String']['output'];
  status: CheckoutSessionStatus;
  swap?: Maybe<CheckoutSessionSwap>;
  updatedAt: Scalars['String']['output'];
};

export enum CheckoutSettlementSource {
  Checkout = 'CHECKOUT',
  Invoice = 'INVOICE'
}

export enum CheckoutStatus {
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  FlaggedAutoReturned = 'FLAGGED_AUTO_RETURNED',
  FlaggedPendingReview = 'FLAGGED_PENDING_REVIEW',
  FlaggedPlatformHeld = 'FLAGGED_PLATFORM_HELD',
  Open = 'OPEN',
  Overpaid = 'OVERPAID',
  Paid = 'PAID',
  RiskScanPending = 'RISK_SCAN_PENDING',
  SessionActive = 'SESSION_ACTIVE',
  UnderpaidRefunded = 'UNDERPAID_REFUNDED'
}

export type CheckoutSummary = {
  __typename?: 'CheckoutSummary';
  createdAt: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  hostedUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lineItems: Array<CheckoutLineItemSummary>;
  organizationId: Scalars['String']['output'];
  priceUsdSnapshot: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  sessions: Array<CheckoutSessionSummary>;
  status: CheckoutStatus;
  updatedAt: Scalars['String']['output'];
};

export type CheckoutSwapEligibility = {
  __typename?: 'CheckoutSwapEligibility';
  eligible: Scalars['Boolean']['output'];
  minUsd: Scalars['Float']['output'];
  reason?: Maybe<CheckoutSwapIneligibleReason>;
};

export enum CheckoutSwapIneligibleReason {
  BelowMinUsd = 'BELOW_MIN_USD',
  OrgDisabled = 'ORG_DISABLED',
  SolanaUsdcNotAccepted = 'SOLANA_USDC_NOT_ACCEPTED'
}

export type CreateBatchPayoutInput = {
  chain: Chain;
  idempotencyKey: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  mintId: Scalars['Int']['input'];
  mode: BatchPayoutMode;
  organizationId: Scalars['String']['input'];
  recipients: Array<BatchPayoutRecipientInput>;
};

export type CreateInvoiceInput = {
  dueDate: Scalars['String']['input'];
  items: Array<CreateInvoiceLineItemInput>;
};

export type CreateInvoiceLineItemInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  priceUsd?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProductInput = {
  acceptedNetworksTokens?: InputMaybe<Array<ChainTokenInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  priceUsd: Scalars['String']['input'];
  sku: Scalars['String']['input'];
};

export type CreateSwapInput = {
  amount: Scalars['String']['input'];
  fromMint: Scalars['String']['input'];
  idempotencyKey: Scalars['String']['input'];
  nativeFeeCapPerGas?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  toMint: Scalars['String']['input'];
  whitelistedAddressId: Scalars['String']['input'];
};

export type CreateTerminalOperatorInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type Customer = {
  __typename?: 'Customer';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  organizationExternalEmail?: Maybe<Scalars['String']['output']>;
  organizationExternalId: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  requireDepositApproval: Scalars['Boolean']['output'];
};

export type CustomerDepositAddress = {
  __typename?: 'CustomerDepositAddress';
  active: Scalars['Boolean']['output'];
  address: Scalars['String']['output'];
  chain: Scalars['String']['output'];
  retiredAt?: Maybe<Scalars['String']['output']>;
};

export enum CustomerLedgerKind {
  All = 'ALL',
  Deposit = 'DEPOSIT',
  Withdraw = 'WITHDRAW'
}

export type CustomerLedgerPagination = {
  __typename?: 'CustomerLedgerPagination';
  totalCount: Scalars['Int']['output'];
  transactions: Array<CustomerLedgerTransaction>;
};

export type CustomerLedgerTransaction = {
  __typename?: 'CustomerLedgerTransaction';
  amount: Scalars['String']['output'];
  canUnflag: Scalars['Boolean']['output'];
  confirmedAt: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  customerSwap?: Maybe<CustomerSwapSummary>;
  failedReason?: Maybe<Scalars['String']['output']>;
  fromAddress: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  kind: CustomerLedgerKind;
  mint: Mint;
  status: TransactionStatus;
  toAddress: Scalars['String']['output'];
  transactionReference: Scalars['String']['output'];
  txHash: Scalars['String']['output'];
  type: Scalars['String']['output'];
  uiAmount: Scalars['String']['output'];
  usdAmount: Scalars['String']['output'];
};

export type CustomerLifetimeTotal = {
  __typename?: 'CustomerLifetimeTotal';
  depositAmount: Scalars['String']['output'];
  depositUsd: Scalars['String']['output'];
  mint: Mint;
  withdrawalAmount: Scalars['String']['output'];
  withdrawalUsd: Scalars['String']['output'];
};

export type CustomerSwap = {
  __typename?: 'CustomerSwap';
  amountIn: Scalars['String']['output'];
  amountOut?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  customerExternalId: Scalars['String']['output'];
  destinationTxHash?: Maybe<Scalars['String']['output']>;
  estimatedAmountOut: Scalars['String']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
  fromMint: Mint;
  id: Scalars['String']['output'];
  intentDeadline?: Maybe<Scalars['String']['output']>;
  intentStatus?: Maybe<NearIntentStatus>;
  minAmountOut: Scalars['String']['output'];
  nearIntentId?: Maybe<Scalars['String']['output']>;
  originTxHash?: Maybe<Scalars['String']['output']>;
  prefundNearIntentId?: Maybe<Scalars['String']['output']>;
  refundTxHash?: Maybe<Scalars['String']['output']>;
  status: CustomerSwapStatus;
  toMint: Mint;
};

export type CustomerSwapConnection = {
  __typename?: 'CustomerSwapConnection';
  items: Array<CustomerSwap>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type CustomerSwapFilter = {
  customerExternalId?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  mintId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<CustomerSwapStatus>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerSwapPagination = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export enum CustomerSwapStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Prefunding = 'PREFUNDING',
  Processing = 'PROCESSING'
}

export type CustomerSwapSummary = {
  __typename?: 'CustomerSwapSummary';
  amountIn: Scalars['String']['output'];
  amountOut?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  destinationTxHash?: Maybe<Scalars['String']['output']>;
  estimatedAmountOut: Scalars['String']['output'];
  fromMint: SwapMintRef;
  originTxHash?: Maybe<Scalars['String']['output']>;
  status: CustomerSwapStatus;
  swapId: Scalars['String']['output'];
  toMint: SwapMintRef;
};

export enum CustomerTransactionType {
  Deposit = 'DEPOSIT',
  GasReceived = 'GAS_RECEIVED',
  GasUsed = 'GAS_USED',
  InternalTransfer = 'INTERNAL_TRANSFER',
  Redirect = 'REDIRECT',
  Refund = 'REFUND',
  SwapRefund = 'SWAP_REFUND'
}

export type CustomerTransactions = {
  __typename?: 'CustomerTransactions';
  amount: Scalars['String']['output'];
  confirmedAt: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  customerSwap?: Maybe<CustomerSwapSummary>;
  failedReason?: Maybe<Scalars['String']['output']>;
  fromAddress: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  mint: Mint;
  nearIntent?: Maybe<NearIntent>;
  status: TransactionStatus;
  toAddress: Scalars['String']['output'];
  transactionReference: Scalars['String']['output'];
  txHash: Scalars['String']['output'];
  type: CustomerTransactionType;
  uiAmount: Scalars['String']['output'];
  usdAmount: Scalars['String']['output'];
};

export type CustomerTransactionsPagination = {
  __typename?: 'CustomerTransactionsPagination';
  totalCount: Scalars['Int']['output'];
  transactions: Array<CustomerTransactions>;
};

export type CustomerWallet = {
  __typename?: 'CustomerWallet';
  address: Scalars['String']['output'];
  addresses: Array<CustomerDepositAddress>;
  assets: Array<Asset>;
  chain?: Maybe<Scalars['String']['output']>;
  totalBalanceUSD: Scalars['String']['output'];
};

export type CustomerWallets = {
  __typename?: 'CustomerWallets';
  customerId: Scalars['String']['output'];
  wallets: Array<CustomerDepositAddress>;
};

export type CustomerWithdrawalPagination = {
  __typename?: 'CustomerWithdrawalPagination';
  totalCount: Scalars['Int']['output'];
  withdrawals: Array<MainWalletTransaction>;
};

export type CustomersPagination = {
  __typename?: 'CustomersPagination';
  customers: Array<Customer>;
  total: Scalars['Int']['output'];
};

export type DepositFlagReason = {
  __typename?: 'DepositFlagReason';
  entityName?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  severity?: Maybe<RiskScoreSeverity>;
};

export enum DepositResolution {
  Approved = 'APPROVED',
  Redirected = 'REDIRECTED',
  Refunded = 'REFUNDED'
}

export enum FilterMatchMode {
  All = 'ALL',
  Any = 'ANY'
}

export enum FlaggedCheckoutAcceptReason {
  BusinessRelationshipVerified = 'BUSINESS_RELATIONSHIP_VERIFIED',
  LowRiskAfterReview = 'LOW_RISK_AFTER_REVIEW',
  ManualDueDiligenceCompleted = 'MANUAL_DUE_DILIGENCE_COMPLETED'
}

export type FlaggedDeposit = {
  __typename?: 'FlaggedDeposit';
  amount: Scalars['String']['output'];
  canUnflag: Scalars['Boolean']['output'];
  confirmedAt: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  customerExternalEmail?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['String']['output'];
  failedAttempts: Array<FlaggedDepositFailedAttempt>;
  flagReason?: Maybe<DepositFlagReason>;
  fromAddress: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  mint: Mint;
  status: TransactionStatus;
  toAddress: Scalars['String']['output'];
  txHash: Scalars['String']['output'];
  uiAmount: Scalars['String']['output'];
  usdAmount: Scalars['String']['output'];
};

export type FlaggedDepositFailedAttempt = {
  __typename?: 'FlaggedDepositFailedAttempt';
  action: DepositResolution;
  actor?: Maybe<ResolutionActor>;
  destinationAddress?: Maybe<Scalars['String']['output']>;
  failedAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
};

export type FlaggedDepositResolution = {
  __typename?: 'FlaggedDepositResolution';
  actor?: Maybe<ResolutionActor>;
  amount: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  customerExternalEmail?: Maybe<Scalars['String']['output']>;
  customerExternalId: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  depositTxHash?: Maybe<Scalars['String']['output']>;
  destinationAddress?: Maybe<Scalars['String']['output']>;
  flagReason?: Maybe<DepositFlagReason>;
  flaggedAt?: Maybe<Scalars['String']['output']>;
  fromAddress: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  legStatus?: Maybe<TransactionStatus>;
  legTxHash?: Maybe<Scalars['String']['output']>;
  mint: Mint;
  resolution: DepositResolution;
  resolutionReason?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['String']['output']>;
  uiAmount: Scalars['String']['output'];
  usdAmount: Scalars['String']['output'];
};

export type FlaggedDepositResolutionsPagination = {
  __typename?: 'FlaggedDepositResolutionsPagination';
  resolutions: Array<FlaggedDepositResolution>;
  totalCount: Scalars['Int']['output'];
};

export type FlaggedDepositsPagination = {
  __typename?: 'FlaggedDepositsPagination';
  deposits: Array<FlaggedDeposit>;
  totalCount: Scalars['Int']['output'];
};

export type FundedCustomer = {
  __typename?: 'FundedCustomer';
  createdAt: Scalars['String']['output'];
  depositAmountUsd: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organizationExternalEmail?: Maybe<Scalars['String']['output']>;
  withdrawalAmountUsd: Scalars['String']['output'];
};

export type FundedCustomersPagination = {
  __typename?: 'FundedCustomersPagination';
  customers: Array<FundedCustomer>;
  total: Scalars['Int']['output'];
};

export type GasTopupQuote = {
  __typename?: 'GasTopupQuote';
  amountInSol?: Maybe<Scalars['String']['output']>;
  amountInUsd?: Maybe<Scalars['String']['output']>;
  amountOut?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  eligible: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type GasTopupRequestResult = {
  __typename?: 'GasTopupRequestResult';
  detail?: Maybe<Scalars['String']['output']>;
  nearIntentId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status: GasTopupRequestStatus;
};

export enum GasTopupRequestStatus {
  Skipped = 'SKIPPED',
  Started = 'STARTED'
}

export type GasTopupStatus = {
  __typename?: 'GasTopupStatus';
  autoTopupEnabled: Scalars['Boolean']['output'];
  effectiveBalance: Scalars['String']['output'];
  inFlightIntentId?: Maybe<Scalars['String']['output']>;
  lastResult?: Maybe<Scalars['String']['output']>;
  lastResultAt?: Maybe<Scalars['String']['output']>;
  paused: Scalars['Boolean']['output'];
  pausedAt?: Maybe<Scalars['String']['output']>;
  sourceReserve?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  trigger?: Maybe<Scalars['String']['output']>;
};

export type GasTransaction = {
  __typename?: 'GasTransaction';
  amount: Scalars['String']['output'];
  confirmedAt: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  fromAddress: Scalars['String']['output'];
  gasWalletId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  mint: Mint;
  status: TransactionStatus;
  toAddress: Scalars['String']['output'];
  transactionReference: Scalars['String']['output'];
  txHash: Scalars['String']['output'];
  type: GasTransactionType;
  uiAmount: Scalars['String']['output'];
  usdAmount: Scalars['String']['output'];
};

export enum GasTransactionType {
  BundleGas = 'BUNDLE_GAS',
  CustomerGasSent = 'CUSTOMER_GAS_SENT',
  Deposit = 'DEPOSIT',
  GasRefund = 'GAS_REFUND',
  GasSwapIn = 'GAS_SWAP_IN',
  GasSwapOut = 'GAS_SWAP_OUT',
  GasSwapRefund = 'GAS_SWAP_REFUND',
  GasUsed = 'GAS_USED',
  MainGasSent = 'MAIN_GAS_SENT',
  RevenueGasSent = 'REVENUE_GAS_SENT'
}

export type GasTransactionsPagination = {
  __typename?: 'GasTransactionsPagination';
  totalCount: Scalars['Int']['output'];
  transactions: Array<GasTransaction>;
};

export type GasWallet = {
  __typename?: 'GasWallet';
  address: Scalars['String']['output'];
  chain?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  mint?: Maybe<Mint>;
  pendingUiBalance: Scalars['String']['output'];
  topup?: Maybe<GasTopupStatus>;
  uiBalance: Scalars['String']['output'];
  usdBalance: Scalars['String']['output'];
};

export type GetWalletsCustomersResponse = {
  __typename?: 'GetWalletsCustomersResponse';
  customersWallets: Array<CustomerWallets>;
  total: Scalars['Int']['output'];
};

export type InputFiltersGasTransaction = {
  chains?: InputMaybe<Array<Chain>>;
  fromAddress?: InputMaybe<Scalars['String']['input']>;
  matchMode?: InputMaybe<FilterMatchMode>;
  statuses?: InputMaybe<Array<TransactionStatus>>;
  toAddress?: InputMaybe<Scalars['String']['input']>;
  txHash?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<GasTransactionType>>;
};

export type InputFiltersTransaction = {
  chains?: InputMaybe<Array<Chain>>;
  createdFrom?: InputMaybe<Scalars['String']['input']>;
  createdTo?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  fromAddress?: InputMaybe<Scalars['String']['input']>;
  matchMode?: InputMaybe<FilterMatchMode>;
  statuses?: InputMaybe<Array<TransactionStatus>>;
  toAddress?: InputMaybe<Scalars['String']['input']>;
  txHash?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InternalTransferThreshold = {
  __typename?: 'InternalTransferThreshold';
  amountInUSD: Scalars['Float']['output'];
  chain?: Maybe<Chain>;
  id: Scalars['Int']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  amountPaidUsd: Scalars['String']['output'];
  amountUsd: Scalars['String']['output'];
  checkoutId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  dueDate: Scalars['String']['output'];
  externalReference?: Maybe<Scalars['String']['output']>;
  externalSource?: Maybe<Scalars['String']['output']>;
  fundsReceivedOnVoid: Scalars['Boolean']['output'];
  hostedUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lineItems?: Maybe<Array<InvoiceLineItem>>;
  number: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  sessions?: Maybe<Array<InvoiceSessionSummary>>;
  status: InvoiceStatus;
  terminalCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  voidedAt?: Maybe<Scalars['String']['output']>;
};

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  id: Scalars['ID']['output'];
  lineTotalUsdSnapshot: Scalars['String']['output'];
  productId: Scalars['ID']['output'];
  productSnapshot?: Maybe<Scalars['JSON']['output']>;
  quantity: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
  unitPriceUsdSnapshot: Scalars['String']['output'];
};

export type InvoiceList = {
  __typename?: 'InvoiceList';
  hasMore: Scalars['Boolean']['output'];
  items: Array<Invoice>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type InvoiceSessionSummary = {
  __typename?: 'InvoiceSessionSummary';
  amountReceived: Scalars['String']['output'];
  amountRequired: Scalars['String']['output'];
  amountSent: CheckoutSessionAmountSent;
  createdAt: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mintChain: Scalars['String']['output'];
  mintSymbol: Scalars['String']['output'];
  rateLocked: Scalars['String']['output'];
  status: CheckoutSessionStatus;
};

export enum InvoiceStatus {
  Expired = 'EXPIRED',
  Open = 'OPEN',
  Paid = 'PAID',
  Partial = 'PARTIAL',
  Void = 'VOID'
}

export enum KpiFlowMetric {
  Deposit = 'DEPOSIT',
  Payment = 'PAYMENT',
  Payout = 'PAYOUT',
  Refund = 'REFUND',
  Withdrawal = 'WITHDRAWAL'
}

export type MainWallet = {
  __typename?: 'MainWallet';
  address: Scalars['String']['output'];
  chain?: Maybe<Scalars['String']['output']>;
  isTestnet?: Maybe<Scalars['Boolean']['output']>;
};

export type MainWalletFailedTransaction = {
  __typename?: 'MainWalletFailedTransaction';
  reason?: Maybe<Scalars['String']['output']>;
  retriedTransactionId?: Maybe<Scalars['Int']['output']>;
};

export enum MainWalletPurpose {
  BatchPayout = 'BATCH_PAYOUT',
  CheddarPay = 'CHEDDAR_PAY',
  Default = 'DEFAULT'
}

export type MainWalletPurposeBalance = {
  __typename?: 'MainWalletPurposeBalance';
  purpose: MainWalletPurpose;
  totalBalanceUSD: Scalars['String']['output'];
};

export type MainWalletTransaction = {
  __typename?: 'MainWalletTransaction';
  amount: Scalars['String']['output'];
  approvedAt?: Maybe<Scalars['String']['output']>;
  approvedBy?: Maybe<BatchPayoutActor>;
  confirmedAt: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  customerExternalEmail?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerSwap?: Maybe<CustomerSwapSummary>;
  failedReason?: Maybe<Scalars['String']['output']>;
  fromAddress: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  initiatedBy?: Maybe<BatchPayoutActor>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  mainWalletId: Scalars['Int']['output'];
  mint: Mint;
  nearIntent?: Maybe<NearIntent>;
  prefundIntent?: Maybe<NearIntent>;
  rejectedAt?: Maybe<Scalars['String']['output']>;
  rejectedBy?: Maybe<BatchPayoutActor>;
  settlementSource?: Maybe<CheckoutSettlementSource>;
  status: TransactionStatus;
  swap?: Maybe<WithdrawalSwapInfo>;
  swapOriginMint?: Maybe<Mint>;
  toAddress: Scalars['String']['output'];
  transactionReference: Scalars['String']['output'];
  txHash: Scalars['String']['output'];
  type: MainWalletTransactionType;
  uiAmount: Scalars['String']['output'];
  usdAmount: Scalars['String']['output'];
};

export enum MainWalletTransactionType {
  AtaRent = 'ATA_RENT',
  BatchPayout = 'BATCH_PAYOUT',
  BatchPayoutDeposit = 'BATCH_PAYOUT_DEPOSIT',
  CheckoutConversionIn = 'CHECKOUT_CONVERSION_IN',
  CheckoutConversionOut = 'CHECKOUT_CONVERSION_OUT',
  CheckoutConversionRefund = 'CHECKOUT_CONVERSION_REFUND',
  CheckoutPenalty = 'CHECKOUT_PENALTY',
  CheckoutRefund = 'CHECKOUT_REFUND',
  CheckoutSettlement = 'CHECKOUT_SETTLEMENT',
  CustomerSwapOut = 'CUSTOMER_SWAP_OUT',
  CustomerSwapRefund = 'CUSTOMER_SWAP_REFUND',
  CustomerWithdrawal = 'CUSTOMER_WITHDRAWAL',
  Deposit = 'DEPOSIT',
  GasReceived = 'GAS_RECEIVED',
  GasUsed = 'GAS_USED',
  InternalTransfer = 'INTERNAL_TRANSFER',
  MainWithdrawal = 'MAIN_WITHDRAWAL',
  PlatformFee = 'PLATFORM_FEE',
  PurposeTransferIn = 'PURPOSE_TRANSFER_IN',
  PurposeTransferOut = 'PURPOSE_TRANSFER_OUT',
  RevenueGasUsed = 'REVENUE_GAS_USED',
  SwapOutflow = 'SWAP_OUTFLOW',
  TreasurySwapIn = 'TREASURY_SWAP_IN',
  TreasurySwapOut = 'TREASURY_SWAP_OUT',
  WithdrawalSwapOut = 'WITHDRAWAL_SWAP_OUT',
  WithdrawalSwapRefund = 'WITHDRAWAL_SWAP_REFUND'
}

export type MainWalletTransactionsPagination = {
  __typename?: 'MainWalletTransactionsPagination';
  totalCount: Scalars['Int']['output'];
  transactions: Array<MainWalletTransaction>;
};

export type Mint = {
  __typename?: 'Mint';
  address?: Maybe<Scalars['String']['output']>;
  chain: Scalars['String']['output'];
  decimals: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  img?: Maybe<Scalars['String']['output']>;
  isNative: Scalars['Boolean']['output'];
  isTestnet: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  usdPrice: Scalars['String']['output'];
  withdrawalSwapSource?: Maybe<Scalars['Boolean']['output']>;
};

export enum MintSurface {
  Default = 'DEFAULT',
  Platform = 'PLATFORM'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptFlaggedCheckout: Scalars['Boolean']['output'];
  addWithdrawalApprovalEmail: WithdrawalApprovalEmail;
  approveTransaction: Scalars['String']['output'];
  archiveTerminalOperator: TerminalOperator;
  archiveWithdrawalApprovalEmail: Scalars['Boolean']['output'];
  createBatchPayout: BatchPayout;
  createInvoice: Invoice;
  createProduct: Product;
  createPurposeWalletTransfer: PurposeWalletTransferResult;
  createSwap: ValiantSwap;
  createTerminalOperator: TerminalOperator;
  createTerminalPairingCode: TerminalPairingCodeResult;
  deleteProduct: Scalars['Boolean']['output'];
  extendInvoice: Invoice;
  logout: Scalars['Boolean']['output'];
  payAllPlatformBills: PlatformBillPaymentResult;
  payPlatformBill: PlatformBillPaymentResult;
  refreshPlayerBalances: PlayerBalances;
  rejectFlaggedCheckout: Scalars['Boolean']['output'];
  rejectFlaggedDeposit: Scalars['Boolean']['output'];
  removeTransaction: Scalars['String']['output'];
  renameTerminalDevice: TerminalDevice;
  requestGasTopup: GasTopupRequestResult;
  requestTwoFactorAuth: Scalars['String']['output'];
  resetMyPassword: User;
  retryTransaction: Scalars['String']['output'];
  revokeTerminalDevice: TerminalDevice;
  rollApiKey: Scalars['String']['output'];
  rotatePlayerBalanceWebhookSecret: RotatePlayerBalanceWebhookSecretPayload;
  sendTestWebhookEvent: Scalars['Boolean']['output'];
  setCheckoutAutoConversion: Scalars['Boolean']['output'];
  setCustomerRequireDepositApproval: Scalars['Boolean']['output'];
  setDepositAddressRotationEnabled: Scalars['Boolean']['output'];
  setGasTopupAutoEnabled: GasWallet;
  setPlayerBalanceWebhook: Scalars['Boolean']['output'];
  setRiskScoreThreshold: Scalars['Boolean']['output'];
  setTreasuryMintAutoPrefund: Scalars['Boolean']['output'];
  setTreasuryMintAutoSwap: Scalars['Boolean']['output'];
  setupTwoFactorAuth: SetupTwoFactorAuthResponse;
  submitBatchPayout: BatchPayout;
  unflagDepositTransaction: Scalars['Boolean']['output'];
  updateBatchPayoutLabels: BatchPayout;
  updateEmail: User;
  updateMinimumThreshold: Scalars['Boolean']['output'];
  updatePassword: User;
  updateProduct: Product;
  updateReceiveNotifications: User;
  updateTerminalOperator: TerminalOperator;
  updateUsername: User;
  voidInvoice: Invoice;
  withdraw: Scalars['String']['output'];
};


export type MutationAcceptFlaggedCheckoutArgs = {
  attestation: CheckoutFlagAcceptAttestationInput;
  organizationId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};


export type MutationAddWithdrawalApprovalEmailArgs = {
  email: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationApproveTransactionArgs = {
  transactionId: Scalars['Int']['input'];
};


export type MutationArchiveTerminalOperatorArgs = {
  operatorId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationArchiveWithdrawalApprovalEmailArgs = {
  id: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationCreateBatchPayoutArgs = {
  input: CreateBatchPayoutInput;
};


export type MutationCreateInvoiceArgs = {
  input: CreateInvoiceInput;
  organizationId: Scalars['String']['input'];
};


export type MutationCreateProductArgs = {
  input: CreateProductInput;
  organizationId: Scalars['String']['input'];
};


export type MutationCreatePurposeWalletTransferArgs = {
  amount: Scalars['String']['input'];
  destPurpose: MainWalletPurpose;
  mintId: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  sourcePurpose: MainWalletPurpose;
};


export type MutationCreateSwapArgs = {
  input: CreateSwapInput;
};


export type MutationCreateTerminalOperatorArgs = {
  input: CreateTerminalOperatorInput;
  organizationId: Scalars['String']['input'];
};


export type MutationCreateTerminalPairingCodeArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationDeleteProductArgs = {
  organizationId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationExtendInvoiceArgs = {
  dueDate: Scalars['String']['input'];
  id: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationPayAllPlatformBillsArgs = {
  expectedUsdDueMicro?: InputMaybe<Scalars['String']['input']>;
  mainWalletPurpose: MainWalletPurpose;
  mintId: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationPayPlatformBillArgs = {
  expectedUsdDueMicro?: InputMaybe<Scalars['String']['input']>;
  mainWalletPurpose: MainWalletPurpose;
  mintId: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  platformBillId: Scalars['Int']['input'];
};


export type MutationRefreshPlayerBalancesArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationRejectFlaggedCheckoutArgs = {
  organizationId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};


export type MutationRejectFlaggedDepositArgs = {
  transactionId: Scalars['Int']['input'];
};


export type MutationRemoveTransactionArgs = {
  organizationId: Scalars['String']['input'];
  transactionId: Scalars['Int']['input'];
};


export type MutationRenameTerminalDeviceArgs = {
  deviceId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationRequestGasTopupArgs = {
  chain: Chain;
  organizationId: Scalars['String']['input'];
};


export type MutationRetryTransactionArgs = {
  transactionId: Scalars['Int']['input'];
};


export type MutationRevokeTerminalDeviceArgs = {
  deviceId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationRollApiKeyArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationRotatePlayerBalanceWebhookSecretArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationSendTestWebhookEventArgs = {
  eventType: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationSetCheckoutAutoConversionArgs = {
  enabled: Scalars['Boolean']['input'];
  mintId: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationSetCustomerRequireDepositApprovalArgs = {
  customerId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetDepositAddressRotationEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationSetGasTopupAutoEnabledArgs = {
  chain: Chain;
  enabled: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationSetPlayerBalanceWebhookArgs = {
  organizationId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type MutationSetRiskScoreThresholdArgs = {
  organizationId: Scalars['String']['input'];
  severityThreshold: RiskScoreSeverity;
  usdThreshold: Scalars['Float']['input'];
};


export type MutationSetTreasuryMintAutoPrefundArgs = {
  enabled: Scalars['Boolean']['input'];
  mintId: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationSetTreasuryMintAutoSwapArgs = {
  enabled: Scalars['Boolean']['input'];
  mintId: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationSetupTwoFactorAuthArgs = {
  secret: Scalars['String']['input'];
};


export type MutationSubmitBatchPayoutArgs = {
  id: Scalars['String']['input'];
  totpCode: Scalars['String']['input'];
};


export type MutationUnflagDepositTransactionArgs = {
  transactionId: Scalars['Int']['input'];
};


export type MutationUpdateBatchPayoutLabelsArgs = {
  input: UpdateBatchPayoutLabelsInput;
};


export type MutationUpdateEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationUpdateMinimumThresholdArgs = {
  amountInUSD: Scalars['Float']['input'];
  chain: Chain;
  organizationId: Scalars['String']['input'];
};


export type MutationUpdatePasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
  organizationId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationUpdateReceiveNotificationsArgs = {
  receiveNotifications: Scalars['Boolean']['input'];
};


export type MutationUpdateTerminalOperatorArgs = {
  input: UpdateTerminalOperatorInput;
  operatorId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationUpdateUsernameArgs = {
  username: Scalars['String']['input'];
};


export type MutationVoidInvoiceArgs = {
  id: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationWithdrawArgs = {
  amount: Scalars['String']['input'];
  destinationAssetId?: InputMaybe<Scalars['String']['input']>;
  maxSlippageBps?: InputMaybe<Scalars['Int']['input']>;
  mintId: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  purpose?: InputMaybe<MainWalletPurpose>;
  totpCode: Scalars['String']['input'];
  whitelistId: Scalars['Int']['input'];
};

export type NearIntent = {
  __typename?: 'NearIntent';
  actualAmountOut?: Maybe<Scalars['String']['output']>;
  amountIn: Scalars['String']['output'];
  amountInUsd?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  customerTransactionId?: Maybe<Scalars['Int']['output']>;
  deadline: Scalars['String']['output'];
  depositAddress: Scalars['String']['output'];
  depositMemo?: Maybe<Scalars['String']['output']>;
  destinationTxHashes: Array<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  minAmountOut?: Maybe<Scalars['String']['output']>;
  originAssetId: Scalars['String']['output'];
  originBlockchain: Scalars['String']['output'];
  originSymbol: Scalars['String']['output'];
  originTxHashes: Array<Scalars['String']['output']>;
  quotedAmountOut?: Maybe<Scalars['String']['output']>;
  recipientAddress: Scalars['String']['output'];
  refundFee?: Maybe<Scalars['String']['output']>;
  refundTo: Scalars['String']['output'];
  slippageToleranceBps?: Maybe<Scalars['Int']['output']>;
  status: NearIntentStatus;
  timeEstimateSeconds?: Maybe<Scalars['Int']['output']>;
  withdrawFee?: Maybe<Scalars['String']['output']>;
};

export enum NearIntentStatus {
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  IncompleteDeposit = 'INCOMPLETE_DEPOSIT',
  PendingDeposit = 'PENDING_DEPOSIT',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED',
  Success = 'SUCCESS'
}

export type Organization = {
  __typename?: 'Organization';
  batchPayoutsEnabled: Scalars['Boolean']['output'];
  canRollApiKey: Scalars['Boolean']['output'];
  canViewBilling: Scalars['Boolean']['output'];
  customerSwapsEnabled: Scalars['Boolean']['output'];
  depositAddressRotationEnabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  internalTransferThreshold: Array<InternalTransferThreshold>;
  name: Scalars['String']['output'];
  nearIntentsEnabled: Scalars['Boolean']['output'];
  platformFeeRates: Array<PlatformFeeRate>;
  playerBalanceWebhook: PlayerBalanceWebhookConfig;
  riskScoreSeverityThreshold?: Maybe<RiskScoreSeverity>;
  riskScoreUsdThreshold?: Maybe<Scalars['Float']['output']>;
  valiantEnabled: Scalars['Boolean']['output'];
  webhookAppId?: Maybe<Scalars['String']['output']>;
  whitelist: Array<Whitelist>;
};

export type OrganizationWallet = {
  __typename?: 'OrganizationWallet';
  address: Scalars['String']['output'];
  assets: Array<Asset>;
  chain?: Maybe<Scalars['String']['output']>;
  isTestnet?: Maybe<Scalars['Boolean']['output']>;
  totalBalanceUSD: Scalars['String']['output'];
};

export type PlatformBill = {
  __typename?: 'PlatformBill';
  dueAmount: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isClosed: Scalars['Boolean']['output'];
  kindUsage: Array<PlatformBillKindUsage>;
  lineItems: Array<PlatformBillLineItem>;
  mainWalletId: Scalars['Int']['output'];
  mainWalletPurpose: MainWalletPurpose;
  mintId: Scalars['Int']['output'];
  organizationId: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['String']['output']>;
  settledTxRef?: Maybe<Scalars['String']['output']>;
  status: PlatformBillStatus;
  successorOfId?: Maybe<Scalars['Int']['output']>;
  unpricedLineCount: Scalars['Int']['output'];
  usdDueAmount: Scalars['String']['output'];
  yearMonth: Scalars['String']['output'];
};

export type PlatformBillKindUsage = {
  __typename?: 'PlatformBillKindUsage';
  count: Scalars['Int']['output'];
  feeBps: Scalars['Int']['output'];
  kind: PlatformBillLineItemKind;
  totalFeeAmount: Scalars['String']['output'];
};

export type PlatformBillLineItem = {
  __typename?: 'PlatformBillLineItem';
  feeAmount: Scalars['String']['output'];
  feeBps: Scalars['Int']['output'];
  grossAmount: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  kind: PlatformBillLineItemKind;
  sourceTxRef?: Maybe<Scalars['String']['output']>;
};

export enum PlatformBillLineItemKind {
  BatchPayout = 'BATCH_PAYOUT',
  Checkout = 'CHECKOUT',
  Deposit = 'DEPOSIT',
  Legacy = 'LEGACY',
  Reversal = 'REVERSAL',
  Swap = 'SWAP',
  TreasuryConversion = 'TREASURY_CONVERSION',
  Withdrawal = 'WITHDRAWAL'
}

export type PlatformBillList = {
  __typename?: 'PlatformBillList';
  hasMore: Scalars['Boolean']['output'];
  items: Array<PlatformBill>;
  nextCursor?: Maybe<Scalars['Int']['output']>;
};

export type PlatformBillPayment = {
  __typename?: 'PlatformBillPayment';
  amount: Scalars['String']['output'];
  chain: Chain;
  coveredBills: Array<PlatformBillPaymentCoveredBill>;
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  mainWalletPurpose: MainWalletPurpose;
  mintId: Scalars['Int']['output'];
  mintSymbol: Scalars['String']['output'];
  settledTxRef?: Maybe<Scalars['String']['output']>;
  status: PlatformBillPaymentStatus;
  usdDueCovered: Scalars['String']['output'];
};

export type PlatformBillPaymentCoveredBill = {
  __typename?: 'PlatformBillPaymentCoveredBill';
  id: Scalars['Int']['output'];
  yearMonth: Scalars['String']['output'];
};

export type PlatformBillPaymentList = {
  __typename?: 'PlatformBillPaymentList';
  hasMore: Scalars['Boolean']['output'];
  items: Array<PlatformBillPayment>;
  nextCursor?: Maybe<Scalars['Int']['output']>;
};

export type PlatformBillPaymentResult = {
  __typename?: 'PlatformBillPaymentResult';
  amount: Scalars['String']['output'];
  billIds: Array<Scalars['Int']['output']>;
  mainWalletId: Scalars['Int']['output'];
  paymentId: Scalars['Int']['output'];
  usdDueCovered: Scalars['String']['output'];
};

export enum PlatformBillPaymentStatus {
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export enum PlatformBillStatus {
  Open = 'OPEN',
  Paid = 'PAID',
  Paying = 'PAYING'
}

export type PlatformBillSummaryBucket = {
  __typename?: 'PlatformBillSummaryBucket';
  dueAmount: Scalars['String']['output'];
  mainWalletPurpose: MainWalletPurpose;
  mintId: Scalars['Int']['output'];
};

export type PlatformBillUsdBreakdownRow = {
  __typename?: 'PlatformBillUsdBreakdownRow';
  cryptoFeeTotal: Scalars['String']['output'];
  mainWalletPurpose: MainWalletPurpose;
  mintId: Scalars['Int']['output'];
  period: PlatformBillUsdPeriod;
  snapshotUsd: Scalars['String']['output'];
  unpricedLineCount: Scalars['Int']['output'];
};

export type PlatformBillUsdDue = {
  __typename?: 'PlatformBillUsdDue';
  accruingUsd: Scalars['String']['output'];
  breakdown: Array<PlatformBillUsdBreakdownRow>;
  dueNowUsd: Scalars['String']['output'];
};

export enum PlatformBillUsdPeriod {
  Accruing = 'ACCRUING',
  DueNow = 'DUE_NOW'
}

export enum PlatformFeeKind {
  BatchPayout = 'BATCH_PAYOUT',
  Checkout = 'CHECKOUT',
  Deposit = 'DEPOSIT',
  Swap = 'SWAP',
  TreasuryConversion = 'TREASURY_CONVERSION',
  Withdrawal = 'WITHDRAWAL'
}

export type PlatformFeeRate = {
  __typename?: 'PlatformFeeRate';
  defaultBps: Scalars['Int']['output'];
  effectiveBps: Scalars['Int']['output'];
  kind: PlatformFeeKind;
  overrideBps?: Maybe<Scalars['Int']['output']>;
};

export enum PlayerBalanceSnapshotStatus {
  Failed = 'FAILED',
  Ok = 'OK'
}

export type PlayerBalanceToken = {
  __typename?: 'PlayerBalanceToken';
  amount: Scalars['String']['output'];
  chain?: Maybe<Chain>;
  isTestnet: Scalars['Boolean']['output'];
  mintId: Scalars['Int']['output'];
  symbol?: Maybe<Scalars['String']['output']>;
  usdValue?: Maybe<Scalars['String']['output']>;
};

export type PlayerBalanceWebhookConfig = {
  __typename?: 'PlayerBalanceWebhookConfig';
  hasSecret: Scalars['Boolean']['output'];
  isConfigured: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type PlayerBalances = {
  __typename?: 'PlayerBalances';
  fetchedAt?: Maybe<Scalars['String']['output']>;
  isStale: Scalars['Boolean']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PlayerBalanceSnapshotStatus>;
  tokens: Array<PlayerBalanceToken>;
  totalUsd?: Maybe<Scalars['String']['output']>;
};

export type Product = {
  __typename?: 'Product';
  acceptedNetworksTokens?: Maybe<Array<ChainToken>>;
  createdAt: Scalars['String']['output'];
  creationSource: ProductCreationSource;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  priceUsd: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  status: ProductStatus;
  updatedAt: Scalars['String']['output'];
};

export enum ProductCreationSource {
  Api = 'API',
  Checkout = 'CHECKOUT',
  Dashboard = 'DASHBOARD'
}

export type ProductList = {
  __typename?: 'ProductList';
  hasMore: Scalars['Boolean']['output'];
  items: Array<Product>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export enum ProductStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type PurposeTransferSpendable = {
  __typename?: 'PurposeTransferSpendable';
  confirmed: Scalars['String']['output'];
  networkFeeReserve: Scalars['String']['output'];
  spendable: Scalars['String']['output'];
};

export type PurposeWalletTransfer = {
  __typename?: 'PurposeWalletTransfer';
  amount: Scalars['String']['output'];
  confirmedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  destPurpose: MainWalletPurpose;
  failedReason?: Maybe<Scalars['String']['output']>;
  fromAddress: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mint: Mint;
  sourcePurpose: MainWalletPurpose;
  status: PurposeWalletTransferStatus;
  toAddress: Scalars['String']['output'];
  txHash: Scalars['String']['output'];
  uiAmount: Scalars['String']['output'];
  usdAmount: Scalars['String']['output'];
};

export type PurposeWalletTransferResult = {
  __typename?: 'PurposeWalletTransferResult';
  outTransactionId: Scalars['Int']['output'];
  transferId: Scalars['String']['output'];
};

export enum PurposeWalletTransferStatus {
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type PurposeWalletTransfersPagination = {
  __typename?: 'PurposeWalletTransfersPagination';
  totalCount: Scalars['Int']['output'];
  transfers: Array<PurposeWalletTransfer>;
};

export type Query = {
  __typename?: 'Query';
  batchPayout?: Maybe<BatchPayout>;
  batchPayouts: Array<BatchPayout>;
  checkoutConversionPolicies: Array<CheckoutConversionPolicy>;
  customerSwap?: Maybe<CustomerSwap>;
  customerSwaps: CustomerSwapConnection;
  customerSwapsExport: Array<CustomerSwap>;
  gasTopupQuote: GasTopupQuote;
  getBatchPayoutBalances: Array<BatchPayoutTokenBalance>;
  getBatchPayoutWallet: BatchPayoutWallet;
  getCheckoutDepositAddresses: CheckoutDepositAddressList;
  getCheckoutPenaltyDetail: CheckoutPenaltyDetail;
  getCheckoutSettlementDetail: CheckoutSettlementDetail;
  getCheckoutSwapEligibility: CheckoutSwapEligibility;
  getCheckoutsWithSessions: CheckoutList;
  getCustomer: Customer;
  getCustomerLedger: CustomerLedgerPagination;
  getCustomerLifetimeTotals: Array<CustomerLifetimeTotal>;
  getCustomerTransactions: CustomerTransactionsPagination;
  getCustomerWallets?: Maybe<Array<CustomerWallet>>;
  getCustomerWithdrawals: CustomerWithdrawalPagination;
  getCustomers: CustomersPagination;
  getCustomersTransactions: CustomerTransactionsPagination;
  getEthGasOwed: Scalars['String']['output'];
  getFlaggedCheckouts: CheckoutFlagReviewList;
  getFlaggedDepositResolutions: FlaggedDepositResolutionsPagination;
  getFlaggedDeposits: FlaggedDepositsPagination;
  getFundedCustomers: FundedCustomersPagination;
  getGasTransactions: GasTransactionsPagination;
  getGasWallets: Array<GasWallet>;
  getInvoice?: Maybe<Invoice>;
  getInvoices: InvoiceList;
  getMainWalletBalancesByPurpose: Array<MainWalletPurposeBalance>;
  getMainWalletTransactions: MainWalletTransactionsPagination;
  getMints: Array<Mint>;
  getOrganization: Organization;
  getPlatformBillSummary: Array<PlatformBillSummaryBucket>;
  getPlatformBillUsdDue: PlatformBillUsdDue;
  getPlayerBalances: PlayerBalances;
  getProduct?: Maybe<Product>;
  getProducts: ProductList;
  getPurposeWalletTransfers: PurposeWalletTransfersPagination;
  getTerminalDevices: Array<TerminalDevice>;
  getTerminalOperators: Array<TerminalOperator>;
  getTestWebhookEventTypes: Array<Scalars['String']['output']>;
  getTransactionsToApprove: MainWalletTransactionsPagination;
  getUser: User;
  getUsersOfOrganization: GetUsersOfOrganization;
  getWallets: Array<OrganizationWallet>;
  getWalletsCustomers: GetWalletsCustomersResponse;
  getWalletsGas: Array<WalletBasic>;
  getWalletsMain: Array<MainWallet>;
  getWebhookIFrameUrl: Scalars['String']['output'];
  getWhitelist: Array<Whitelist>;
  getWithdrawThreshold: WithdrawThreshold;
  listPlatformBillPayments: PlatformBillPaymentList;
  listPlatformBills: PlatformBillList;
  nearIntent?: Maybe<NearIntent>;
  nearIntents: Array<NearIntent>;
  platformFeeRecipient: Scalars['String']['output'];
  purposeTransferSpendable: PurposeTransferSpendable;
  reportingMonthlySummary: Array<ReportingMonthlySummary>;
  reportingSwaps: Array<SwapsReportingSwap>;
  reportingSwapsMonthlySummary: Array<SwapsReportingMonthlySummary>;
  reportingSwapsWindowedTotals: ReportingSwapsWindowedTotals;
  reportingTimeSeries: ReportingTimeSeries;
  reportingTransactions: Array<ReportingTransaction>;
  reportingWindowedTotals: ReportingWindowedTotals;
  treasuryMintPolicies: Array<TreasuryMintPolicy>;
  valiantMints: Array<ValiantMint>;
  valiantSwap?: Maybe<ValiantSwap>;
  valiantSwappableAssets: Array<ValiantSwappableAsset>;
  valiantSwaps: Array<ValiantSwap>;
  valiantWhitelistedAddresses: Array<ValiantWhitelistedAddress>;
  withdrawableBalance: WithdrawableBalance;
  withdrawalApprovalEmails: Array<WithdrawalApprovalEmail>;
  withdrawalSwapDestinations: Array<WithdrawalSwapDestination>;
  withdrawalSwapQuote: WithdrawalSwapQuote;
};


export type QueryBatchPayoutArgs = {
  id: Scalars['String']['input'];
};


export type QueryBatchPayoutsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryCheckoutConversionPoliciesArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryCustomerSwapArgs = {
  id: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type QueryCustomerSwapsArgs = {
  filter?: InputMaybe<CustomerSwapFilter>;
  organizationId: Scalars['String']['input'];
  pagination?: InputMaybe<CustomerSwapPagination>;
};


export type QueryCustomerSwapsExportArgs = {
  filter?: InputMaybe<CustomerSwapFilter>;
  organizationId: Scalars['String']['input'];
};


export type QueryGasTopupQuoteArgs = {
  chain: Chain;
  organizationId: Scalars['String']['input'];
};


export type QueryGetBatchPayoutBalancesArgs = {
  chain: Chain;
  isTestnet?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['String']['input'];
};


export type QueryGetBatchPayoutWalletArgs = {
  chain: Chain;
  isTestnet?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['String']['input'];
};


export type QueryGetCheckoutDepositAddressesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};


export type QueryGetCheckoutPenaltyDetailArgs = {
  mainWalletTransactionId: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
};


export type QueryGetCheckoutSettlementDetailArgs = {
  mainWalletTransactionId: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
};


export type QueryGetCheckoutSwapEligibilityArgs = {
  checkoutId: Scalars['ID']['input'];
  organizationId: Scalars['String']['input'];
};


export type QueryGetCheckoutsWithSessionsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};


export type QueryGetCustomerArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryGetCustomerLedgerArgs = {
  customerId: Scalars['String']['input'];
  hideSmall?: InputMaybe<Scalars['Boolean']['input']>;
  kind: CustomerLedgerKind;
  limit: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  smallUsdThreshold?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetCustomerLifetimeTotalsArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryGetCustomerTransactionsArgs = {
  customerId: Scalars['String']['input'];
  hideSmall?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  smallUsdThreshold?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetCustomerWalletsArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryGetCustomerWithdrawalsArgs = {
  customerId: Scalars['String']['input'];
  hideSmall?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  smallUsdThreshold?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetCustomersArgs = {
  limit: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCustomersTransactionsArgs = {
  filters?: InputMaybe<InputFiltersTransaction>;
  hideSmall?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  purpose?: InputMaybe<MainWalletPurpose>;
  smallUsdThreshold?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetEthGasOwedArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetFlaggedCheckoutsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetFlaggedDepositResolutionsArgs = {
  limit: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetFlaggedDepositsArgs = {
  limit: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFundedCustomersArgs = {
  limit: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetGasTransactionsArgs = {
  filters?: InputMaybe<InputFiltersGasTransaction>;
  hideSmall?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  smallUsdThreshold?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetGasWalletsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetInvoiceArgs = {
  id: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type QueryGetInvoicesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMainWalletBalancesByPurposeArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetMainWalletTransactionsArgs = {
  filters?: InputMaybe<InputFiltersTransaction>;
  hideSmall?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  purpose?: InputMaybe<MainWalletPurpose>;
  smallUsdThreshold?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetMintsArgs = {
  organizationId: Scalars['String']['input'];
  surface: MintSurface;
};


export type QueryGetOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetPlatformBillSummaryArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetPlatformBillUsdDueArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetPlayerBalancesArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetProductArgs = {
  organizationId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type QueryGetProductsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
  status?: InputMaybe<ProductStatus>;
};


export type QueryGetPurposeWalletTransfersArgs = {
  limit: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetTerminalDevicesArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetTerminalOperatorsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetTransactionsToApproveArgs = {
  limit: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  purpose?: InputMaybe<MainWalletPurpose>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUsersOfOrganizationArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
};


export type QueryGetWalletsArgs = {
  organizationId: Scalars['String']['input'];
  purpose?: InputMaybe<MainWalletPurpose>;
};


export type QueryGetWalletsCustomersArgs = {
  limit: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetWalletsGasArgs = {
  organizationId: Scalars['String']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetWalletsMainArgs = {
  organizationId: Scalars['String']['input'];
  purpose?: InputMaybe<MainWalletPurpose>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetWebhookIFrameUrlArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetWhitelistArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetWithdrawThresholdArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryListPlatformBillPaymentsArgs = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};


export type QueryListPlatformBillsArgs = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mintId?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
  status?: InputMaybe<PlatformBillStatus>;
  yearMonth?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNearIntentArgs = {
  intentId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type QueryNearIntentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<NearIntentStatus>;
  uncreditedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPlatformFeeRecipientArgs = {
  chain: Chain;
};


export type QueryPurposeTransferSpendableArgs = {
  mintId: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  purpose: MainWalletPurpose;
};


export type QueryReportingMonthlySummaryArgs = {
  organizationId: Scalars['String']['input'];
  purpose: MainWalletPurpose;
};


export type QueryReportingSwapsArgs = {
  from: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type QueryReportingSwapsMonthlySummaryArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryReportingSwapsWindowedTotalsArgs = {
  cacheDay?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};


export type QueryReportingTimeSeriesArgs = {
  from: Scalars['String']['input'];
  granularity: TimeSeriesGranularity;
  organizationId: Scalars['String']['input'];
  purpose: MainWalletPurpose;
  timezone: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type QueryReportingTransactionsArgs = {
  from: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  purpose: MainWalletPurpose;
  to: Scalars['String']['input'];
};


export type QueryReportingWindowedTotalsArgs = {
  cacheDay?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  purpose: MainWalletPurpose;
  timezone: Scalars['String']['input'];
};


export type QueryTreasuryMintPoliciesArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryValiantMintsArgs = {
  chain?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


export type QueryValiantSwapArgs = {
  organizationId: Scalars['String']['input'];
  swapId: Scalars['String']['input'];
};


export type QueryValiantSwappableAssetsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryValiantSwapsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryValiantWhitelistedAddressesArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryWithdrawableBalanceArgs = {
  mintId: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  purpose: MainWalletPurpose;
};


export type QueryWithdrawalApprovalEmailsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryWithdrawalSwapDestinationsArgs = {
  chain: Chain;
  organizationId: Scalars['String']['input'];
};


export type QueryWithdrawalSwapQuoteArgs = {
  amount: Scalars['String']['input'];
  destinationAssetId: Scalars['String']['input'];
  maxSlippageBps?: InputMaybe<Scalars['Int']['input']>;
  mintId: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  purpose: MainWalletPurpose;
  whitelistId: Scalars['Int']['input'];
};

export type ReportingCountUsd = {
  __typename?: 'ReportingCountUsd';
  count: Scalars['Int']['output'];
  usdValue: Scalars['String']['output'];
};

export type ReportingMetricStableWindows = {
  __typename?: 'ReportingMetricStableWindows';
  lifetimeToYesterday: ReportingCountUsd;
  monthToYesterday: ReportingCountUsd;
  priorSixDays: ReportingCountUsd;
  yesterday: ReportingCountUsd;
};

export type ReportingMetricTodayWindow = {
  __typename?: 'ReportingMetricTodayWindow';
  today: ReportingCountUsd;
};

export type ReportingMetricWindowedTotals = {
  __typename?: 'ReportingMetricWindowedTotals';
  metric: KpiFlowMetric;
  stable: ReportingMetricStableWindows;
  today: ReportingMetricTodayWindow;
};

export type ReportingMonthlySummary = {
  __typename?: 'ReportingMonthlySummary';
  depositsCount: Scalars['Int']['output'];
  depositsUsd: Scalars['String']['output'];
  fundingCount: Scalars['Int']['output'];
  fundingUsd: Scalars['String']['output'];
  paymentsCount: Scalars['Int']['output'];
  paymentsUsd: Scalars['String']['output'];
  payoutsCount: Scalars['Int']['output'];
  payoutsUsd: Scalars['String']['output'];
  refundsCount: Scalars['Int']['output'];
  refundsUsd: Scalars['String']['output'];
  withdrawalsCount: Scalars['Int']['output'];
  withdrawalsUsd: Scalars['String']['output'];
  yearMonth: Scalars['String']['output'];
};

export type ReportingSwapWindowBucket = {
  __typename?: 'ReportingSwapWindowBucket';
  swapsCount: Scalars['Int']['output'];
  volumeUsd: Scalars['String']['output'];
};

export type ReportingSwapsStableWindows = {
  __typename?: 'ReportingSwapsStableWindows';
  lifetimeToYesterday: ReportingSwapWindowBucket;
  monthToYesterday: ReportingSwapWindowBucket;
  priorSixDays: ReportingSwapWindowBucket;
  yesterday: ReportingSwapWindowBucket;
};

export type ReportingSwapsTodayWindow = {
  __typename?: 'ReportingSwapsTodayWindow';
  today: ReportingSwapWindowBucket;
};

export type ReportingSwapsWindowedTotals = {
  __typename?: 'ReportingSwapsWindowedTotals';
  stable: ReportingSwapsStableWindows;
  timezone: Scalars['String']['output'];
  today: ReportingSwapsTodayWindow;
};

export type ReportingTimeSeries = {
  __typename?: 'ReportingTimeSeries';
  buckets: Array<ReportingTimeSeriesBucket>;
  granularity: TimeSeriesGranularity;
  purpose: MainWalletPurpose;
  rangeTotals: ReportingTimeSeriesRangeTotals;
  timezone: Scalars['String']['output'];
};

export type ReportingTimeSeriesBucket = {
  __typename?: 'ReportingTimeSeriesBucket';
  bucketStart: Scalars['String']['output'];
  depositsUsd?: Maybe<Scalars['String']['output']>;
  salesUsd?: Maybe<Scalars['String']['output']>;
  uniqueBuyers?: Maybe<Scalars['Int']['output']>;
  uniqueDepositors?: Maybe<Scalars['Int']['output']>;
  uniqueWithdrawers?: Maybe<Scalars['Int']['output']>;
  withdrawalsUsd?: Maybe<Scalars['String']['output']>;
};

export type ReportingTimeSeriesRangeTotals = {
  __typename?: 'ReportingTimeSeriesRangeTotals';
  depositsUsd?: Maybe<Scalars['String']['output']>;
  salesUsd?: Maybe<Scalars['String']['output']>;
  uniqueBuyers?: Maybe<Scalars['Int']['output']>;
  uniqueDepositors?: Maybe<Scalars['Int']['output']>;
  uniqueWithdrawers?: Maybe<Scalars['Int']['output']>;
  withdrawalsUsd?: Maybe<Scalars['String']['output']>;
};

export type ReportingTransaction = {
  __typename?: 'ReportingTransaction';
  batchLabel?: Maybe<Scalars['String']['output']>;
  chain: Chain;
  confirmedAt: Scalars['String']['output'];
  counterparty: Scalars['String']['output'];
  explorerUrl?: Maybe<Scalars['String']['output']>;
  fromAddress: Scalars['String']['output'];
  metric: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  status: TransactionStatus;
  toAddress: Scalars['String']['output'];
  tokenAmount: Scalars['String']['output'];
  tokenSymbol: Scalars['String']['output'];
  txHash?: Maybe<Scalars['String']['output']>;
  typeLabel: Scalars['String']['output'];
  usdPrice?: Maybe<Scalars['String']['output']>;
  usdValue?: Maybe<Scalars['String']['output']>;
  usdValueMissing: Scalars['Boolean']['output'];
};

export type ReportingWindowedTotals = {
  __typename?: 'ReportingWindowedTotals';
  metrics: Array<ReportingMetricWindowedTotals>;
  purpose: MainWalletPurpose;
  timezone: Scalars['String']['output'];
};

export type ResolutionActor = {
  __typename?: 'ResolutionActor';
  id: Scalars['String']['output'];
  kind: ResolutionActorKind;
  username: Scalars['String']['output'];
};

export enum ResolutionActorKind {
  Admin = 'ADMIN',
  User = 'USER'
}

export enum RiskScoreSeverity {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  VeryLow = 'VERY_LOW'
}

export type RotatePlayerBalanceWebhookSecretPayload = {
  __typename?: 'RotatePlayerBalanceWebhookSecretPayload';
  secret: Scalars['String']['output'];
};

export type SetupTwoFactorAuthResponse = {
  __typename?: 'SetupTwoFactorAuthResponse';
  email: Scalars['String']['output'];
  has2fa: Scalars['Boolean']['output'];
  receiveNotifications: Scalars['Boolean']['output'];
  recoveryCodes: Array<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export enum SwapDepositStage {
  Confirming = 'CONFIRMING',
  Earmarked = 'EARMARKED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type SwapMintRef = {
  __typename?: 'SwapMintRef';
  chain: Chain;
  id: Scalars['Int']['output'];
  symbol: Scalars['String']['output'];
};

export enum SwapOverallStatus {
  AwaitingApproval = 'AWAITING_APPROVAL',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export enum SwapStage {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Idle = 'IDLE',
  PushOutCompleted = 'PUSH_OUT_COMPLETED',
  PushOutFailed = 'PUSH_OUT_FAILED',
  PushOutInitiated = 'PUSH_OUT_INITIATED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  TradeCompleted = 'TRADE_COMPLETED',
  TradeExecuting = 'TRADE_EXECUTING',
  TradeFailed = 'TRADE_FAILED',
  WithdrawalCompleted = 'WITHDRAWAL_COMPLETED',
  WithdrawalFailed = 'WITHDRAWAL_FAILED',
  WithdrawalInitiated = 'WITHDRAWAL_INITIATED'
}

export type SwapsReportingMonthlySummary = {
  __typename?: 'SwapsReportingMonthlySummary';
  feesUsd: Scalars['String']['output'];
  swapsCount: Scalars['Int']['output'];
  volumeUsd: Scalars['String']['output'];
  yearMonth: Scalars['String']['output'];
};

export type SwapsReportingSwap = {
  __typename?: 'SwapsReportingSwap';
  confirmedAt: Scalars['String']['output'];
  depositExplorerUrl?: Maybe<Scalars['String']['output']>;
  depositTxid?: Maybe<Scalars['String']['output']>;
  explorerUrls: Array<Scalars['String']['output']>;
  fee?: Maybe<Scalars['String']['output']>;
  feeBps?: Maybe<Scalars['Int']['output']>;
  feeUsd?: Maybe<Scalars['String']['output']>;
  fromAmount: Scalars['String']['output'];
  fromTokenSymbol: Scalars['String']['output'];
  rate?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  toAmountHuman?: Maybe<Scalars['String']['output']>;
  toTokenSymbol: Scalars['String']['output'];
  txHashes: Array<Scalars['String']['output']>;
  volumeUsd?: Maybe<Scalars['String']['output']>;
  volumeUsdMissing: Scalars['Boolean']['output'];
};

export type TerminalDevice = {
  __typename?: 'TerminalDevice';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastSeenAt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  pairedAt: Scalars['String']['output'];
  revokedAt?: Maybe<Scalars['String']['output']>;
  status: TerminalDeviceStatus;
};

export enum TerminalDeviceStatus {
  Active = 'ACTIVE',
  Revoked = 'REVOKED'
}

export type TerminalOperator = {
  __typename?: 'TerminalOperator';
  code: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  status: TerminalOperatorStatus;
  updatedAt: Scalars['String']['output'];
};

export enum TerminalOperatorStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type TerminalPairingCodeResult = {
  __typename?: 'TerminalPairingCodeResult';
  code: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export enum TimeSeriesGranularity {
  Day = 'DAY',
  Hour = 'HOUR'
}

export enum TransactionStatus {
  AwaitingConfirmation = 'AWAITING_CONFIRMATION',
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  Flagged = 'FLAGGED',
  Pending = 'PENDING',
  Prefunding = 'PREFUNDING',
  Rejected = 'REJECTED'
}

export type TreasuryMintPolicy = {
  __typename?: 'TreasuryMintPolicy';
  autoPrefundFromSolUsdc: Scalars['Boolean']['output'];
  autoSwapToSolUsdc: Scalars['Boolean']['output'];
  eligible: Scalars['Boolean']['output'];
  ineligibilityCode?: Maybe<TreasuryMintPolicyIneligibility>;
  ineligibilityReason?: Maybe<Scalars['String']['output']>;
  mint: Mint;
  prefundEligible: Scalars['Boolean']['output'];
  prefundIneligibilityCode?: Maybe<TreasuryMintPrefundIneligibility>;
  prefundIneligibilityReason?: Maybe<Scalars['String']['output']>;
};

export enum TreasuryMintPolicyIneligibility {
  IsDestinationAsset = 'IS_DESTINATION_ASSET',
  NoSolanaMainWallet = 'NO_SOLANA_MAIN_WALLET',
  NoSwapRoute = 'NO_SWAP_ROUTE',
  TestnetMint = 'TESTNET_MINT'
}

export enum TreasuryMintPrefundIneligibility {
  IsOriginAsset = 'IS_ORIGIN_ASSET',
  NoDestinationMainWallet = 'NO_DESTINATION_MAIN_WALLET',
  NoSolanaMainWallet = 'NO_SOLANA_MAIN_WALLET',
  NoSwapRoute = 'NO_SWAP_ROUTE',
  TestnetMint = 'TESTNET_MINT'
}

export type UpdateBatchPayoutLabelsInput = {
  id: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  recipients?: InputMaybe<Array<UpdateBatchPayoutRecipientReferenceInput>>;
};

export type UpdateBatchPayoutRecipientReferenceInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductInput = {
  acceptedNetworksTokens?: InputMaybe<Array<ChainTokenInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priceUsd?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTerminalOperatorInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  has2fa: Scalars['Boolean']['output'];
  organizations: Array<Organization>;
  receiveNotifications: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type ValiantMint = {
  __typename?: 'ValiantMint';
  address?: Maybe<Scalars['String']['output']>;
  chain: Scalars['String']['output'];
  decimals: Scalars['Int']['output'];
  displayDecimals: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type ValiantSwap = {
  __typename?: 'ValiantSwap';
  amount: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  depositRef?: Maybe<Scalars['String']['output']>;
  depositStage: SwapDepositStage;
  depositTxid?: Maybe<Scalars['String']['output']>;
  earmarkedAmount?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  fromMint: Scalars['String']['output'];
  id: Scalars['String']['output'];
  overallStatus: SwapOverallStatus;
  swapId?: Maybe<Scalars['String']['output']>;
  swapStage: SwapStage;
  toAmountHuman?: Maybe<Scalars['String']['output']>;
  toMint: Scalars['String']['output'];
  txHashes: Array<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  whitelistedAddress: Scalars['String']['output'];
  whitelistedAddressId: Scalars['String']['output'];
  whitelistedChain: Chain;
};

export type ValiantSwappableAsset = {
  __typename?: 'ValiantSwappableAsset';
  availableBalance: Scalars['String']['output'];
  availableBalanceHuman: Scalars['String']['output'];
  cheddarMint: Mint;
  nativeFeeCapPerGas?: Maybe<Scalars['String']['output']>;
  valiantMintId: Scalars['String']['output'];
};

export type ValiantWhitelistedAddress = {
  __typename?: 'ValiantWhitelistedAddress';
  address: Scalars['String']['output'];
  chain: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type WalletBasic = {
  __typename?: 'WalletBasic';
  address: Scalars['String']['output'];
  chain?: Maybe<Scalars['String']['output']>;
};

export type Whitelist = {
  __typename?: 'Whitelist';
  address: Scalars['String']['output'];
  chain: Chain;
  id: Scalars['Int']['output'];
};

export type WithdrawThreshold = {
  __typename?: 'WithdrawThreshold';
  customers?: Maybe<Scalars['Float']['output']>;
  main?: Maybe<Scalars['Float']['output']>;
};

export type WithdrawableBalance = {
  __typename?: 'WithdrawableBalance';
  balance: Scalars['String']['output'];
  maxWithdrawable: Scalars['String']['output'];
  networkFeeReserve: Scalars['String']['output'];
};

export type WithdrawalApprovalEmail = {
  __typename?: 'WithdrawalApprovalEmail';
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type WithdrawalSwapAsset = {
  __typename?: 'WithdrawalSwapAsset';
  assetId: Scalars['String']['output'];
  chain: Chain;
  decimals: Scalars['Int']['output'];
  symbol: Scalars['String']['output'];
};

export type WithdrawalSwapDestination = {
  __typename?: 'WithdrawalSwapDestination';
  assetId: Scalars['String']['output'];
  chain: Chain;
  cheddarMintId?: Maybe<Scalars['Int']['output']>;
  decimals: Scalars['Int']['output'];
  symbol: Scalars['String']['output'];
};

export type WithdrawalSwapFee = {
  __typename?: 'WithdrawalSwapFee';
  amount: Scalars['String']['output'];
  bps: Scalars['Int']['output'];
};

export type WithdrawalSwapInfo = {
  __typename?: 'WithdrawalSwapInfo';
  actualAmountOut?: Maybe<Scalars['String']['output']>;
  destinationAssetId: Scalars['String']['output'];
  destinationChain?: Maybe<Chain>;
  destinationDecimals?: Maybe<Scalars['Int']['output']>;
  destinationSymbol?: Maybe<Scalars['String']['output']>;
  destinationTxHash?: Maybe<Scalars['String']['output']>;
  maxSlippageBps: Scalars['Int']['output'];
  minAmountOut?: Maybe<Scalars['String']['output']>;
  quotedAmountOut?: Maybe<Scalars['String']['output']>;
  recipientAddress: Scalars['String']['output'];
  status: WithdrawalSwapStatus;
};

export type WithdrawalSwapQuote = {
  __typename?: 'WithdrawalSwapQuote';
  deadline: Scalars['String']['output'];
  destinationAsset: WithdrawalSwapAsset;
  minAmountOut: Scalars['String']['output'];
  quotedAmountOut: Scalars['String']['output'];
  quotedOutUsd?: Maybe<Scalars['String']['output']>;
  sourceUsd: Scalars['String']['output'];
  swapFee: WithdrawalSwapFee;
  withdrawalFee: WithdrawalSwapFee;
};

export enum WithdrawalSwapStatus {
  AwaitingApproval = 'AWAITING_APPROVAL',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED'
}

export type GetUsersOfOrganization = {
  __typename?: 'getUsersOfOrganization';
  cursor: Scalars['String']['output'];
  hasMore: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
  users: Array<User>;
};

export type UserFragment = { __typename?: 'User', userId: string, username: string, email: string, has2fa: boolean, receiveNotifications: boolean, organizations: Array<{ __typename?: 'Organization', id: string, name: string }> };

export type UserWithRecoveryCodesFragment = { __typename?: 'SetupTwoFactorAuthResponse', userId: string, username: string, email: string, has2fa: boolean, receiveNotifications: boolean, recoveryCodes: Array<string> };

export type AssetFragment = { __typename?: 'Asset', unconfirmedBalance: string, balance: string, usdBalance: string, mint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string } };

export type MintFragment = { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string };

export type WithdrawalSwapFieldsFragment = { __typename?: 'WithdrawalSwapInfo', destinationAssetId: string, destinationSymbol?: string | null, destinationChain?: Chain | null, destinationDecimals?: number | null, recipientAddress: string, quotedAmountOut?: string | null, minAmountOut?: string | null, actualAmountOut?: string | null, destinationTxHash?: string | null, maxSlippageBps: number, status: WithdrawalSwapStatus };

export type CustomerSwapSummaryFieldsFragment = { __typename?: 'CustomerSwapSummary', swapId: string, status: CustomerSwapStatus, amountIn: string, estimatedAmountOut: string, amountOut?: string | null, originTxHash?: string | null, destinationTxHash?: string | null, createdAt: string, fromMint: { __typename?: 'SwapMintRef', id: number, symbol: string, chain: Chain }, toMint: { __typename?: 'SwapMintRef', id: number, symbol: string, chain: Chain } };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', getUser: { __typename?: 'User', userId: string, username: string, email: string, has2fa: boolean, receiveNotifications: boolean, organizations: Array<{ __typename?: 'Organization', id: string, name: string }> } };

export type GetMintsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  surface: MintSurface;
}>;


export type GetMintsQuery = { __typename?: 'Query', getMints: Array<{ __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string }> };

export type GetWithdrawalSwapSourceMintsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  surface: MintSurface;
}>;


export type GetWithdrawalSwapSourceMintsQuery = { __typename?: 'Query', getMints: Array<{ __typename?: 'Mint', id: number, withdrawalSwapSource?: boolean | null }> };

export type WithdrawalSwapDestinationsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  chain: Chain;
}>;


export type WithdrawalSwapDestinationsQuery = { __typename?: 'Query', withdrawalSwapDestinations: Array<{ __typename?: 'WithdrawalSwapDestination', assetId: string, symbol: string, decimals: number, chain: Chain, cheddarMintId?: number | null }> };

export type GetWalletsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  purpose: MainWalletPurpose;
}>;


export type GetWalletsQuery = { __typename?: 'Query', getWallets: Array<{ __typename?: 'OrganizationWallet', address: string, chain?: string | null, isTestnet?: boolean | null, totalBalanceUSD: string, assets: Array<{ __typename?: 'Asset', unconfirmedBalance: string, balance: string, usdBalance: string, mint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string } }> }> };

export type GetGasWalletsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetGasWalletsQuery = { __typename?: 'Query', getGasWallets: Array<{ __typename?: 'GasWallet', id: number, address: string, chain?: string | null, uiBalance: string, pendingUiBalance: string, usdBalance: string, mint?: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string } | null, topup?: { __typename?: 'GasTopupStatus', autoTopupEnabled: boolean, trigger?: string | null, target?: string | null, effectiveBalance: string, sourceReserve?: string | null, paused: boolean, pausedAt?: string | null, inFlightIntentId?: string | null, lastResult?: string | null, lastResultAt?: string | null } | null }> };

export type GasTopupQuoteQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  chain: Chain;
}>;


export type GasTopupQuoteQuery = { __typename?: 'Query', gasTopupQuote: { __typename?: 'GasTopupQuote', eligible: boolean, reason?: string | null, detail?: string | null, amountInSol?: string | null, amountOut?: string | null, amountInUsd?: string | null } };

export type SetGasTopupAutoEnabledMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  chain: Chain;
  enabled: Scalars['Boolean']['input'];
}>;


export type SetGasTopupAutoEnabledMutation = { __typename?: 'Mutation', setGasTopupAutoEnabled: { __typename?: 'GasWallet', id: number, topup?: { __typename?: 'GasTopupStatus', autoTopupEnabled: boolean, paused: boolean } | null } };

export type RequestGasTopupMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  chain: Chain;
}>;


export type RequestGasTopupMutation = { __typename?: 'Mutation', requestGasTopup: { __typename?: 'GasTopupRequestResult', status: GasTopupRequestStatus, reason?: string | null, detail?: string | null, nearIntentId?: string | null } };

export type GetEthGasOwedQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetEthGasOwedQuery = { __typename?: 'Query', getEthGasOwed: string };

export type GetOrganizationQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetOrganizationQuery = { __typename?: 'Query', getOrganization: { __typename?: 'Organization', id: string, name: string, webhookAppId?: string | null, riskScoreSeverityThreshold?: RiskScoreSeverity | null, riskScoreUsdThreshold?: number | null, valiantEnabled: boolean, nearIntentsEnabled: boolean, depositAddressRotationEnabled: boolean, customerSwapsEnabled: boolean, batchPayoutsEnabled: boolean, canRollApiKey: boolean, canViewBilling: boolean, whitelist: Array<{ __typename?: 'Whitelist', id: number, chain: Chain, address: string }>, internalTransferThreshold: Array<{ __typename?: 'InternalTransferThreshold', id: number, amountInUSD: number, chain?: Chain | null }>, playerBalanceWebhook: { __typename?: 'PlayerBalanceWebhookConfig', url?: string | null, hasSecret: boolean, isConfigured: boolean } } };

export type GetBatchPayoutWalletQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  chain: Chain;
  isTestnet?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBatchPayoutWalletQuery = { __typename?: 'Query', getBatchPayoutWallet: { __typename?: 'BatchPayoutWallet', chain: Chain, address: string, isTestnet?: boolean | null, mainWalletId: number } };

export type GetBatchPayoutBalancesQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  chain: Chain;
  isTestnet?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBatchPayoutBalancesQuery = { __typename?: 'Query', getBatchPayoutBalances: Array<{ __typename?: 'BatchPayoutTokenBalance', total: string, reserved: string, available: string, mint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string } }> };

export type GetUsersOfOrganizationQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
}>;


export type GetUsersOfOrganizationQuery = { __typename?: 'Query', getUsersOfOrganization: { __typename?: 'getUsersOfOrganization', hasMore: boolean, cursor: string, totalCount: number, users: Array<{ __typename?: 'User', userId: string, username: string, email: string, has2fa: boolean, receiveNotifications: boolean, organizations: Array<{ __typename?: 'Organization', id: string, name: string }> }> } };

export type GetWithdrawThresholdQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetWithdrawThresholdQuery = { __typename?: 'Query', getWithdrawThreshold: { __typename?: 'WithdrawThreshold', customers?: number | null, main?: number | null } };

export type GetTransactionsToApproveQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  purpose: MainWalletPurpose;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetTransactionsToApproveQuery = { __typename?: 'Query', getTransactionsToApprove: { __typename?: 'MainWalletTransactionsPagination', totalCount: number, transactions: Array<{ __typename?: 'MainWalletTransaction', id: number, mainWalletId: number, txHash: string, amount: string, uiAmount: string, usdAmount: string, fromAddress: string, toAddress: string, transactionReference: string, createdAt: string, confirmedAt: string, type: MainWalletTransactionType, status: TransactionStatus, customerId?: string | null, customerExternalEmail?: string | null, mint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string }, prefundIntent?: { __typename?: 'NearIntent', id: string, status: NearIntentStatus, originAssetId: string, originBlockchain: string, originSymbol: string, recipientAddress: string, refundTo: string, depositAddress: string, depositMemo?: string | null, amountIn: string, minAmountOut?: string | null, slippageToleranceBps?: number | null, quotedAmountOut?: string | null, actualAmountOut?: string | null, timeEstimateSeconds?: number | null, amountInUsd?: string | null, deadline: string, failureReason?: string | null, originTxHashes: Array<string>, destinationTxHashes: Array<string>, customerTransactionId?: number | null, createdAt: string } | null }> } };

export type GetFlaggedDepositsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetFlaggedDepositsQuery = { __typename?: 'Query', getFlaggedDeposits: { __typename?: 'FlaggedDepositsPagination', totalCount: number, deposits: Array<{ __typename?: 'FlaggedDeposit', id: number, customerId: string, customerExternalEmail?: string | null, txHash: string, amount: string, uiAmount: string, usdAmount: string, fromAddress: string, toAddress: string, createdAt: string, confirmedAt: string, status: TransactionStatus, canUnflag: boolean, mint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string }, flagReason?: { __typename?: 'DepositFlagReason', score?: number | null, severity?: RiskScoreSeverity | null, entityType?: string | null, entityName?: string | null } | null, failedAttempts: Array<{ __typename?: 'FlaggedDepositFailedAttempt', id: number, action: DepositResolution, destinationAddress?: string | null, reason: string, failedAt: string }> }> } };

export type GetFlaggedDepositResolutionsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetFlaggedDepositResolutionsQuery = { __typename?: 'Query', getFlaggedDepositResolutions: { __typename?: 'FlaggedDepositResolutionsPagination', totalCount: number, resolutions: Array<{ __typename?: 'FlaggedDepositResolution', id: number, customerId: string, customerExternalId: string, customerExternalEmail?: string | null, amount: string, uiAmount: string, usdAmount: string, fromAddress: string, depositTxHash?: string | null, createdAt: string, flaggedAt?: string | null, resolution: DepositResolution, resolvedAt?: string | null, resolutionReason?: string | null, destinationAddress?: string | null, legTxHash?: string | null, legStatus?: TransactionStatus | null, mint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string }, flagReason?: { __typename?: 'DepositFlagReason', score?: number | null, severity?: RiskScoreSeverity | null, entityType?: string | null, entityName?: string | null } | null, actor?: { __typename?: 'ResolutionActor', kind: ResolutionActorKind, id: string, username: string } | null }> } };

export type GetTransactionsToApproveCountQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  purpose: MainWalletPurpose;
}>;


export type GetTransactionsToApproveCountQuery = { __typename?: 'Query', getTransactionsToApprove: { __typename?: 'MainWalletTransactionsPagination', totalCount: number } };

export type GetFlaggedDepositsCountQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetFlaggedDepositsCountQuery = { __typename?: 'Query', getFlaggedDeposits: { __typename?: 'FlaggedDepositsPagination', totalCount: number } };

export type GetWhitelistQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetWhitelistQuery = { __typename?: 'Query', getWhitelist: Array<{ __typename?: 'Whitelist', id: number, chain: Chain, address: string }> };

export type GetWebhookIFrameUrlQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetWebhookIFrameUrlQuery = { __typename?: 'Query', getWebhookIFrameUrl: string };

export type GetTestWebhookEventTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTestWebhookEventTypesQuery = { __typename?: 'Query', getTestWebhookEventTypes: Array<string> };

export type SendTestWebhookEventMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  eventType: Scalars['String']['input'];
}>;


export type SendTestWebhookEventMutation = { __typename?: 'Mutation', sendTestWebhookEvent: boolean };

export type GetCustomersQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetCustomersQuery = { __typename?: 'Query', getCustomers: { __typename?: 'CustomersPagination', total: number, customers: Array<{ __typename?: 'Customer', id: string, createdAt: string, isActive: boolean, organizationId: string, organizationExternalId: string, organizationExternalEmail?: string | null }> } };

export type GetFundedCustomersQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetFundedCustomersQuery = { __typename?: 'Query', getFundedCustomers: { __typename?: 'FundedCustomersPagination', total: number, customers: Array<{ __typename?: 'FundedCustomer', id: string, organizationExternalEmail?: string | null, createdAt: string, depositAmountUsd: string, withdrawalAmountUsd: string }> } };

export type GetCustomerQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type GetCustomerQuery = { __typename?: 'Query', getCustomer: { __typename?: 'Customer', id: string, createdAt: string, isActive: boolean, organizationId: string, organizationExternalId: string, organizationExternalEmail?: string | null, requireDepositApproval: boolean } };

export type SetCustomerRequireDepositApprovalMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type SetCustomerRequireDepositApprovalMutation = { __typename?: 'Mutation', setCustomerRequireDepositApproval: boolean };

export type GetCustomerLifetimeTotalsQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type GetCustomerLifetimeTotalsQuery = { __typename?: 'Query', getCustomerLifetimeTotals: Array<{ __typename?: 'CustomerLifetimeTotal', depositAmount: string, withdrawalAmount: string, depositUsd: string, withdrawalUsd: string, mint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string } }> };

export type GetCustomerWalletsQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type GetCustomerWalletsQuery = { __typename?: 'Query', getCustomerWallets?: Array<{ __typename?: 'CustomerWallet', address: string, chain?: string | null, totalBalanceUSD: string, assets: Array<{ __typename?: 'Asset', unconfirmedBalance: string, balance: string, usdBalance: string, mint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string } }>, addresses: Array<{ __typename?: 'CustomerDepositAddress', chain: string, address: string, active: boolean, retiredAt?: string | null }> }> | null };

export type GetCustomerTransactionsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  hideSmall: Scalars['Boolean']['input'];
  smallUsdThreshold?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetCustomerTransactionsQuery = { __typename?: 'Query', getCustomerTransactions: { __typename?: 'CustomerTransactionsPagination', totalCount: number, transactions: Array<{ __typename?: 'CustomerTransactions', id: number, customerId: string, txHash: string, amount: string, uiAmount: string, usdAmount: string, failedReason?: string | null, fromAddress: string, toAddress: string, transactionReference: string, createdAt: string, confirmedAt: string, type: CustomerTransactionType, status: TransactionStatus, mint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string } }> } };

export type GetCustomerLedgerQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  kind: CustomerLedgerKind;
  hideSmall: Scalars['Boolean']['input'];
  smallUsdThreshold?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetCustomerLedgerQuery = { __typename?: 'Query', getCustomerLedger: { __typename?: 'CustomerLedgerPagination', totalCount: number, transactions: Array<{ __typename?: 'CustomerLedgerTransaction', id: number, txHash: string, amount: string, uiAmount: string, usdAmount: string, failedReason?: string | null, fromAddress: string, toAddress: string, transactionReference: string, createdAt: string, confirmedAt: string, type: string, status: TransactionStatus, kind: CustomerLedgerKind, canUnflag: boolean, mint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string }, customerSwap?: { __typename?: 'CustomerSwapSummary', swapId: string, status: CustomerSwapStatus, amountIn: string, estimatedAmountOut: string, amountOut?: string | null, originTxHash?: string | null, destinationTxHash?: string | null, createdAt: string, fromMint: { __typename?: 'SwapMintRef', id: number, symbol: string, chain: Chain }, toMint: { __typename?: 'SwapMintRef', id: number, symbol: string, chain: Chain } } | null }> } };

export type GetCustomerWithdrawalsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  hideSmall: Scalars['Boolean']['input'];
  smallUsdThreshold?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetCustomerWithdrawalsQuery = { __typename?: 'Query', getCustomerWithdrawals: { __typename?: 'CustomerWithdrawalPagination', totalCount: number, withdrawals: Array<{ __typename?: 'MainWalletTransaction', id: number, mainWalletId: number, txHash: string, amount: string, uiAmount: string, usdAmount: string, fromAddress: string, toAddress: string, transactionReference: string, createdAt: string, confirmedAt: string, type: MainWalletTransactionType, status: TransactionStatus, mint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string } }> } };

export type GetMainWalletTransactionsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  purpose: MainWalletPurpose;
  filters?: InputMaybe<InputFiltersTransaction>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  hideSmall: Scalars['Boolean']['input'];
  smallUsdThreshold?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetMainWalletTransactionsQuery = { __typename?: 'Query', getMainWalletTransactions: { __typename?: 'MainWalletTransactionsPagination', totalCount: number, transactions: Array<{ __typename?: 'MainWalletTransaction', id: number, mainWalletId: number, txHash: string, amount: string, uiAmount: string, usdAmount: string, failedReason?: string | null, fromAddress: string, toAddress: string, transactionReference: string, createdAt: string, confirmedAt: string, type: MainWalletTransactionType, status: TransactionStatus, customerExternalEmail?: string | null, customerId?: string | null, settlementSource?: CheckoutSettlementSource | null, invoiceId?: string | null, invoiceNumber?: string | null, approvedAt?: string | null, rejectedAt?: string | null, mint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string }, initiatedBy?: { __typename?: 'BatchPayoutActor', userId: string, username: string, email: string } | null, approvedBy?: { __typename?: 'BatchPayoutActor', userId: string, username: string, email: string } | null, rejectedBy?: { __typename?: 'BatchPayoutActor', userId: string, username: string, email: string } | null, nearIntent?: { __typename?: 'NearIntent', id: string, status: NearIntentStatus, originAssetId: string, originBlockchain: string, originSymbol: string, recipientAddress: string, refundTo: string, depositAddress: string, depositMemo?: string | null, amountIn: string, minAmountOut?: string | null, slippageToleranceBps?: number | null, quotedAmountOut?: string | null, actualAmountOut?: string | null, timeEstimateSeconds?: number | null, amountInUsd?: string | null, deadline: string, failureReason?: string | null, originTxHashes: Array<string>, destinationTxHashes: Array<string>, customerTransactionId?: number | null, createdAt: string } | null, swapOriginMint?: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string } | null, prefundIntent?: { __typename?: 'NearIntent', id: string, status: NearIntentStatus, originAssetId: string, originBlockchain: string, originSymbol: string, recipientAddress: string, refundTo: string, depositAddress: string, depositMemo?: string | null, amountIn: string, minAmountOut?: string | null, slippageToleranceBps?: number | null, quotedAmountOut?: string | null, actualAmountOut?: string | null, timeEstimateSeconds?: number | null, amountInUsd?: string | null, deadline: string, failureReason?: string | null, originTxHashes: Array<string>, destinationTxHashes: Array<string>, customerTransactionId?: number | null, createdAt: string } | null, customerSwap?: { __typename?: 'CustomerSwapSummary', swapId: string, status: CustomerSwapStatus, amountIn: string, estimatedAmountOut: string, amountOut?: string | null, originTxHash?: string | null, destinationTxHash?: string | null, createdAt: string, fromMint: { __typename?: 'SwapMintRef', id: number, symbol: string, chain: Chain }, toMint: { __typename?: 'SwapMintRef', id: number, symbol: string, chain: Chain } } | null, swap?: { __typename?: 'WithdrawalSwapInfo', destinationAssetId: string, destinationSymbol?: string | null, destinationChain?: Chain | null, destinationDecimals?: number | null, recipientAddress: string, quotedAmountOut?: string | null, minAmountOut?: string | null, actualAmountOut?: string | null, destinationTxHash?: string | null, maxSlippageBps: number, status: WithdrawalSwapStatus } | null }> } };

export type GetMainWalletBalancesByPurposeQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetMainWalletBalancesByPurposeQuery = { __typename?: 'Query', getMainWalletBalancesByPurpose: Array<{ __typename?: 'MainWalletPurposeBalance', purpose: MainWalletPurpose, totalBalanceUSD: string }> };

export type GetGasTransactionsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  hideSmall: Scalars['Boolean']['input'];
  smallUsdThreshold?: InputMaybe<Scalars['Float']['input']>;
  filters?: InputMaybe<InputFiltersGasTransaction>;
}>;


export type GetGasTransactionsQuery = { __typename?: 'Query', getGasTransactions: { __typename?: 'GasTransactionsPagination', totalCount: number, transactions: Array<{ __typename?: 'GasTransaction', id: number, gasWalletId: number, txHash: string, amount: string, uiAmount: string, usdAmount: string, fromAddress: string, toAddress: string, transactionReference: string, createdAt: string, confirmedAt: string, type: GasTransactionType, status: TransactionStatus, mint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string } }> } };

export type GetWalletsMainQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  purpose: MainWalletPurpose;
}>;


export type GetWalletsMainQuery = { __typename?: 'Query', getWalletsMain: Array<{ __typename?: 'MainWallet', chain?: string | null, address: string, isTestnet?: boolean | null }> };

export type GetWalletsCustomersQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWalletsCustomersQuery = { __typename?: 'Query', getWalletsCustomers: { __typename?: 'GetWalletsCustomersResponse', total: number, customersWallets: Array<{ __typename?: 'CustomerWallets', customerId: string, wallets: Array<{ __typename?: 'CustomerDepositAddress', chain: string, address: string, active: boolean, retiredAt?: string | null }> }> } };

export type GetCustomersTransactionsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  purpose: MainWalletPurpose;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  filters?: InputMaybe<InputFiltersTransaction>;
  hideSmall: Scalars['Boolean']['input'];
  smallUsdThreshold?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetCustomersTransactionsQuery = { __typename?: 'Query', getCustomersTransactions: { __typename?: 'CustomerTransactionsPagination', totalCount: number, transactions: Array<{ __typename?: 'CustomerTransactions', id: number, customerId: string, txHash: string, amount: string, uiAmount: string, usdAmount: string, failedReason?: string | null, fromAddress: string, toAddress: string, transactionReference: string, createdAt: string, confirmedAt: string, type: CustomerTransactionType, status: TransactionStatus, mint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string }, nearIntent?: { __typename?: 'NearIntent', id: string, status: NearIntentStatus, originAssetId: string, originBlockchain: string, originSymbol: string, recipientAddress: string, refundTo: string, depositAddress: string, depositMemo?: string | null, amountIn: string, minAmountOut?: string | null, slippageToleranceBps?: number | null, quotedAmountOut?: string | null, actualAmountOut?: string | null, timeEstimateSeconds?: number | null, amountInUsd?: string | null, deadline: string, failureReason?: string | null, originTxHashes: Array<string>, destinationTxHashes: Array<string>, customerTransactionId?: number | null, createdAt: string } | null, customerSwap?: { __typename?: 'CustomerSwapSummary', swapId: string, status: CustomerSwapStatus, amountIn: string, estimatedAmountOut: string, amountOut?: string | null, originTxHash?: string | null, destinationTxHash?: string | null, createdAt: string, fromMint: { __typename?: 'SwapMintRef', id: number, symbol: string, chain: Chain }, toMint: { __typename?: 'SwapMintRef', id: number, symbol: string, chain: Chain } } | null }> } };

export type RollApiKeyMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type RollApiKeyMutation = { __typename?: 'Mutation', rollApiKey: string };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type UpdateUsernameMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type UpdateUsernameMutation = { __typename?: 'Mutation', updateUsername: { __typename?: 'User', userId: string, username: string, email: string, has2fa: boolean, receiveNotifications: boolean, organizations: Array<{ __typename?: 'Organization', id: string, name: string }> } };

export type UpdateEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type UpdateEmailMutation = { __typename?: 'Mutation', updateEmail: { __typename?: 'User', userId: string, username: string, email: string, has2fa: boolean, receiveNotifications: boolean, organizations: Array<{ __typename?: 'Organization', id: string, name: string }> } };

export type UpdatePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: { __typename?: 'User', userId: string, username: string, email: string } };

export type ResetMyPasswordMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetMyPasswordMutation = { __typename?: 'Mutation', resetMyPassword: { __typename?: 'User', userId: string, username: string, email: string, has2fa: boolean, receiveNotifications: boolean, organizations: Array<{ __typename?: 'Organization', id: string, name: string }> } };

export type RequestTwoFactorAuthMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestTwoFactorAuthMutation = { __typename?: 'Mutation', requestTwoFactorAuth: string };

export type SetupTwoFactorAuthMutationVariables = Exact<{
  secret: Scalars['String']['input'];
}>;


export type SetupTwoFactorAuthMutation = { __typename?: 'Mutation', setupTwoFactorAuth: { __typename?: 'SetupTwoFactorAuthResponse', userId: string, username: string, email: string, has2fa: boolean, receiveNotifications: boolean, recoveryCodes: Array<string> } };

export type WithdrawMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  amount: Scalars['String']['input'];
  whitelistId: Scalars['Int']['input'];
  mintId: Scalars['Int']['input'];
  purpose: MainWalletPurpose;
  totpCode: Scalars['String']['input'];
  destinationAssetId?: InputMaybe<Scalars['String']['input']>;
  maxSlippageBps?: InputMaybe<Scalars['Int']['input']>;
}>;


export type WithdrawMutation = { __typename?: 'Mutation', withdraw: string };

export type WithdrawalSwapQuoteQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  purpose: MainWalletPurpose;
  mintId: Scalars['Int']['input'];
  amount: Scalars['String']['input'];
  destinationAssetId: Scalars['String']['input'];
  whitelistId: Scalars['Int']['input'];
  maxSlippageBps?: InputMaybe<Scalars['Int']['input']>;
}>;


export type WithdrawalSwapQuoteQuery = { __typename?: 'Query', withdrawalSwapQuote: { __typename?: 'WithdrawalSwapQuote', quotedAmountOut: string, minAmountOut: string, sourceUsd: string, quotedOutUsd?: string | null, deadline: string, destinationAsset: { __typename?: 'WithdrawalSwapAsset', assetId: string, symbol: string, decimals: number, chain: Chain }, withdrawalFee: { __typename?: 'WithdrawalSwapFee', bps: number, amount: string }, swapFee: { __typename?: 'WithdrawalSwapFee', bps: number, amount: string } } };

export type UpdateMinimumThresholdMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  amountInUSD: Scalars['Float']['input'];
  chain: Chain;
}>;


export type UpdateMinimumThresholdMutation = { __typename?: 'Mutation', updateMinimumThreshold: boolean };

export type ApproveTransactionMutationVariables = Exact<{
  transactionId: Scalars['Int']['input'];
}>;


export type ApproveTransactionMutation = { __typename?: 'Mutation', approveTransaction: string };

export type RemoveTransactionMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  transactionId: Scalars['Int']['input'];
}>;


export type RemoveTransactionMutation = { __typename?: 'Mutation', removeTransaction: string };

export type RetryTransactionMutationVariables = Exact<{
  transactionId: Scalars['Int']['input'];
}>;


export type RetryTransactionMutation = { __typename?: 'Mutation', retryTransaction: string };

export type UpdateReceiveNotificationsMutationVariables = Exact<{
  receiveNotifications: Scalars['Boolean']['input'];
}>;


export type UpdateReceiveNotificationsMutation = { __typename?: 'Mutation', updateReceiveNotifications: { __typename?: 'User', userId: string, username: string, email: string, has2fa: boolean, receiveNotifications: boolean, organizations: Array<{ __typename?: 'Organization', id: string, name: string }> } };

export type UnflagDepositTransactionMutationVariables = Exact<{
  transactionId: Scalars['Int']['input'];
}>;


export type UnflagDepositTransactionMutation = { __typename?: 'Mutation', unflagDepositTransaction: boolean };

export type RejectFlaggedDepositMutationVariables = Exact<{
  transactionId: Scalars['Int']['input'];
}>;


export type RejectFlaggedDepositMutation = { __typename?: 'Mutation', rejectFlaggedDeposit: boolean };

export type SetRiskScoreThresholdMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  severityThreshold: RiskScoreSeverity;
  usdThreshold: Scalars['Float']['input'];
}>;


export type SetRiskScoreThresholdMutation = { __typename?: 'Mutation', setRiskScoreThreshold: boolean };

export type WithdrawalApprovalEmailsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type WithdrawalApprovalEmailsQuery = { __typename?: 'Query', withdrawalApprovalEmails: Array<{ __typename?: 'WithdrawalApprovalEmail', id: number, email: string, createdAt: string }> };

export type AddWithdrawalApprovalEmailMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type AddWithdrawalApprovalEmailMutation = { __typename?: 'Mutation', addWithdrawalApprovalEmail: { __typename?: 'WithdrawalApprovalEmail', id: number, email: string, createdAt: string } };

export type ArchiveWithdrawalApprovalEmailMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  id: Scalars['Int']['input'];
}>;


export type ArchiveWithdrawalApprovalEmailMutation = { __typename?: 'Mutation', archiveWithdrawalApprovalEmail: boolean };

export type SetPlayerBalanceWebhookMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  url: Scalars['String']['input'];
}>;


export type SetPlayerBalanceWebhookMutation = { __typename?: 'Mutation', setPlayerBalanceWebhook: boolean };

export type RotatePlayerBalanceWebhookSecretMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type RotatePlayerBalanceWebhookSecretMutation = { __typename?: 'Mutation', rotatePlayerBalanceWebhookSecret: { __typename?: 'RotatePlayerBalanceWebhookSecretPayload', secret: string } };

export type PlayerBalancesFieldsFragment = { __typename?: 'PlayerBalances', totalUsd?: string | null, fetchedAt?: string | null, status?: PlayerBalanceSnapshotStatus | null, lastError?: string | null, isStale: boolean, tokens: Array<{ __typename?: 'PlayerBalanceToken', mintId: number, symbol?: string | null, chain?: Chain | null, amount: string, usdValue?: string | null, isTestnet: boolean }> };

export type RefreshPlayerBalancesMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type RefreshPlayerBalancesMutation = { __typename?: 'Mutation', refreshPlayerBalances: { __typename?: 'PlayerBalances', totalUsd?: string | null, fetchedAt?: string | null, status?: PlayerBalanceSnapshotStatus | null, lastError?: string | null, isStale: boolean, tokens: Array<{ __typename?: 'PlayerBalanceToken', mintId: number, symbol?: string | null, chain?: Chain | null, amount: string, usdValue?: string | null, isTestnet: boolean }> } };

export type ProductFragment = { __typename?: 'Product', id: string, organizationId: string, name: string, description?: string | null, imageUrl?: string | null, priceUsd: string, sku: string, status: ProductStatus, metadata?: any | null, createdAt: string, updatedAt: string, acceptedNetworksTokens?: Array<{ __typename?: 'ChainToken', chain: string, token: string }> | null };

export type GetProductsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  status?: InputMaybe<ProductStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductsQuery = { __typename?: 'Query', getProducts: { __typename?: 'ProductList', hasMore: boolean, nextCursor?: string | null, items: Array<{ __typename?: 'Product', id: string, organizationId: string, name: string, description?: string | null, imageUrl?: string | null, priceUsd: string, sku: string, status: ProductStatus, metadata?: any | null, createdAt: string, updatedAt: string, acceptedNetworksTokens?: Array<{ __typename?: 'ChainToken', chain: string, token: string }> | null }> } };

export type GetProductQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type GetProductQuery = { __typename?: 'Query', getProduct?: { __typename?: 'Product', id: string, organizationId: string, name: string, description?: string | null, imageUrl?: string | null, priceUsd: string, sku: string, status: ProductStatus, metadata?: any | null, createdAt: string, updatedAt: string, acceptedNetworksTokens?: Array<{ __typename?: 'ChainToken', chain: string, token: string }> | null } | null };

export type CreateProductMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  input: CreateProductInput;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'Product', id: string, organizationId: string, name: string, description?: string | null, imageUrl?: string | null, priceUsd: string, sku: string, status: ProductStatus, metadata?: any | null, createdAt: string, updatedAt: string, acceptedNetworksTokens?: Array<{ __typename?: 'ChainToken', chain: string, token: string }> | null } };

export type UpdateProductMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  input: UpdateProductInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'Product', id: string, organizationId: string, name: string, description?: string | null, imageUrl?: string | null, priceUsd: string, sku: string, status: ProductStatus, metadata?: any | null, createdAt: string, updatedAt: string, acceptedNetworksTokens?: Array<{ __typename?: 'ChainToken', chain: string, token: string }> | null } };

export type CheckoutDepositAddressFragment = { __typename?: 'CheckoutDepositAddress', id: number, sessionId: string, checkoutId: string, organizationId: string, chain: string, address: string, derivationPath: string, createdAt: string };

export type CheckoutSessionSwapFieldsFragment = { __typename?: 'CheckoutSessionSwap', intentId: string, status: NearIntentStatus, originAssetId: string, originBlockchain: string, originSymbol: string, amountIn: string, amountInUsd?: string | null, minAmountOut?: string | null, quotedAmountOut?: string | null, actualAmountOut?: string | null, slippageToleranceBps?: number | null, timeEstimateSeconds?: number | null, originTxHashes: Array<string>, destinationTxHashes: Array<string>, failureReason?: string | null, createdAt: string };

export type CheckoutSessionSummaryFragment = { __typename?: 'CheckoutSessionSummary', id: string, checkoutId: string, status: CheckoutSessionStatus, depositAddress: string, depositAddressPath: string, mintId: number, mintSymbol: string, mintChain: string, rateLocked: string, amountRequired: string, amountReceived: string, expiresAt: string, createdAt: string, updatedAt: string, amountSent: { __typename?: 'CheckoutSessionAmountSent', amountSentCrypto: string, amountSentUsd: string, amountRequiredCrypto: string, amountRequiredUsd: string, shortfallCrypto: string, shortfallUsd: string, paymentIndicator?: CheckoutSessionPaymentIndicator | null, isTestnet: boolean }, swap?: { __typename?: 'CheckoutSessionSwap', intentId: string, status: NearIntentStatus, originAssetId: string, originBlockchain: string, originSymbol: string, amountIn: string, amountInUsd?: string | null, minAmountOut?: string | null, quotedAmountOut?: string | null, actualAmountOut?: string | null, slippageToleranceBps?: number | null, timeEstimateSeconds?: number | null, originTxHashes: Array<string>, destinationTxHashes: Array<string>, failureReason?: string | null, createdAt: string } | null };

export type CheckoutSummaryFragment = { __typename?: 'CheckoutSummary', id: string, organizationId: string, status: CheckoutStatus, priceUsdSnapshot: string, productName: string, hostedUrl: string, expiresAt: string, createdAt: string, updatedAt: string, sessions: Array<{ __typename?: 'CheckoutSessionSummary', id: string, checkoutId: string, status: CheckoutSessionStatus, depositAddress: string, depositAddressPath: string, mintId: number, mintSymbol: string, mintChain: string, rateLocked: string, amountRequired: string, amountReceived: string, expiresAt: string, createdAt: string, updatedAt: string, amountSent: { __typename?: 'CheckoutSessionAmountSent', amountSentCrypto: string, amountSentUsd: string, amountRequiredCrypto: string, amountRequiredUsd: string, shortfallCrypto: string, shortfallUsd: string, paymentIndicator?: CheckoutSessionPaymentIndicator | null, isTestnet: boolean }, swap?: { __typename?: 'CheckoutSessionSwap', intentId: string, status: NearIntentStatus, originAssetId: string, originBlockchain: string, originSymbol: string, amountIn: string, amountInUsd?: string | null, minAmountOut?: string | null, quotedAmountOut?: string | null, actualAmountOut?: string | null, slippageToleranceBps?: number | null, timeEstimateSeconds?: number | null, originTxHashes: Array<string>, destinationTxHashes: Array<string>, failureReason?: string | null, createdAt: string } | null }> };

export type GetCheckoutDepositAddressesQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCheckoutDepositAddressesQuery = { __typename?: 'Query', getCheckoutDepositAddresses: { __typename?: 'CheckoutDepositAddressList', hasMore: boolean, nextCursor?: string | null, items: Array<{ __typename?: 'CheckoutDepositAddress', id: number, sessionId: string, checkoutId: string, organizationId: string, chain: string, address: string, derivationPath: string, createdAt: string }> } };

export type GetCheckoutsWithSessionsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCheckoutsWithSessionsQuery = { __typename?: 'Query', getCheckoutsWithSessions: { __typename?: 'CheckoutList', hasMore: boolean, nextCursor?: string | null, items: Array<{ __typename?: 'CheckoutSummary', id: string, organizationId: string, status: CheckoutStatus, priceUsdSnapshot: string, productName: string, hostedUrl: string, expiresAt: string, createdAt: string, updatedAt: string, sessions: Array<{ __typename?: 'CheckoutSessionSummary', id: string, checkoutId: string, status: CheckoutSessionStatus, depositAddress: string, depositAddressPath: string, mintId: number, mintSymbol: string, mintChain: string, rateLocked: string, amountRequired: string, amountReceived: string, expiresAt: string, createdAt: string, updatedAt: string, amountSent: { __typename?: 'CheckoutSessionAmountSent', amountSentCrypto: string, amountSentUsd: string, amountRequiredCrypto: string, amountRequiredUsd: string, shortfallCrypto: string, shortfallUsd: string, paymentIndicator?: CheckoutSessionPaymentIndicator | null, isTestnet: boolean }, swap?: { __typename?: 'CheckoutSessionSwap', intentId: string, status: NearIntentStatus, originAssetId: string, originBlockchain: string, originSymbol: string, amountIn: string, amountInUsd?: string | null, minAmountOut?: string | null, quotedAmountOut?: string | null, actualAmountOut?: string | null, slippageToleranceBps?: number | null, timeEstimateSeconds?: number | null, originTxHashes: Array<string>, destinationTxHashes: Array<string>, failureReason?: string | null, createdAt: string } | null }> }> } };

export type GetCheckoutSwapEligibilityQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  checkoutId: Scalars['ID']['input'];
}>;


export type GetCheckoutSwapEligibilityQuery = { __typename?: 'Query', getCheckoutSwapEligibility: { __typename?: 'CheckoutSwapEligibility', eligible: boolean, reason?: CheckoutSwapIneligibleReason | null, minUsd: number } };

export type GetCheckoutSettlementDetailQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  mainWalletTransactionId: Scalars['Int']['input'];
}>;


export type GetCheckoutSettlementDetailQuery = { __typename?: 'Query', getCheckoutSettlementDetail: { __typename?: 'CheckoutSettlementDetail', grossReceived: string, netSettled: string, settlement: { __typename?: 'MainWalletTransaction', id: number, txHash: string, uiAmount: string, usdAmount: string, status: TransactionStatus, confirmedAt: string, mint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string } }, session: { __typename?: 'CheckoutSettlementSessionDetail', id: string, checkoutId: string, status: CheckoutSessionStatus, depositAddress: string, mintSymbol: string, mintChain: string, isTestnet: boolean, rateLocked: string, amountRequired: string, amountReceived: string, swap?: { __typename?: 'CheckoutSessionSwap', intentId: string, status: NearIntentStatus, originAssetId: string, originBlockchain: string, originSymbol: string, amountIn: string, amountInUsd?: string | null, minAmountOut?: string | null, quotedAmountOut?: string | null, actualAmountOut?: string | null, slippageToleranceBps?: number | null, timeEstimateSeconds?: number | null, originTxHashes: Array<string>, destinationTxHashes: Array<string>, failureReason?: string | null, createdAt: string } | null }, checkout: { __typename?: 'CheckoutSettlementCheckoutInfo', id: string, productName: string, priceUsdSnapshot: string }, deposits: Array<{ __typename?: 'CheckoutSettlementDeposit', id: string, txHash: string, fromAddress: string, amount: string, confirmedAt?: string | null }> } };

export type GetCheckoutPenaltyDetailQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  mainWalletTransactionId: Scalars['Int']['input'];
}>;


export type GetCheckoutPenaltyDetailQuery = { __typename?: 'Query', getCheckoutPenaltyDetail: { __typename?: 'CheckoutPenaltyDetail', refundTxHash: string, penalty: { __typename?: 'MainWalletTransaction', id: number, txHash: string, uiAmount: string, usdAmount: string, status: TransactionStatus, confirmedAt: string, mint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string } }, session: { __typename?: 'CheckoutSettlementSessionDetail', id: string, checkoutId: string, status: CheckoutSessionStatus, depositAddress: string, mintSymbol: string, mintChain: string, isTestnet: boolean, rateLocked: string, amountRequired: string, amountReceived: string }, checkout: { __typename?: 'CheckoutSettlementCheckoutInfo', id: string, productName: string, priceUsdSnapshot: string }, refund?: { __typename?: 'CheckoutPenaltyRefund', txHash: string, amount: string, confirmedAt?: string | null } | null } };

export type DeleteProductMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type DeleteProductMutation = { __typename?: 'Mutation', deleteProduct: boolean };

export type ValiantSwapFieldsFragment = { __typename?: 'ValiantSwap', id: string, fromMint: string, toMint: string, amount: string, earmarkedAmount?: string | null, toAmountHuman?: string | null, whitelistedAddressId: string, whitelistedAddress: string, whitelistedChain: Chain, depositTxid?: string | null, depositRef?: string | null, swapId?: string | null, txHashes: Array<string>, depositStage: SwapDepositStage, swapStage: SwapStage, overallStatus: SwapOverallStatus, failureReason?: string | null, createdAt: string, updatedAt: string };

export type GetValiantSwappableAssetsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetValiantSwappableAssetsQuery = { __typename?: 'Query', valiantSwappableAssets: Array<{ __typename?: 'ValiantSwappableAsset', valiantMintId: string, availableBalance: string, availableBalanceHuman: string, nativeFeeCapPerGas?: string | null, cheddarMint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string } }> };

export type GetValiantMintsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  chain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetValiantMintsQuery = { __typename?: 'Query', valiantMints: Array<{ __typename?: 'ValiantMint', id: string, symbol: string, name: string, decimals: number, displayDecimals: number, chain: string, address?: string | null }> };

export type GetValiantWhitelistedAddressesQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetValiantWhitelistedAddressesQuery = { __typename?: 'Query', valiantWhitelistedAddresses: Array<{ __typename?: 'ValiantWhitelistedAddress', id: string, chain: string, address: string, label?: string | null }> };

export type NearIntentFieldsFragment = { __typename?: 'NearIntent', id: string, status: NearIntentStatus, originAssetId: string, originBlockchain: string, originSymbol: string, recipientAddress: string, refundTo: string, depositAddress: string, depositMemo?: string | null, amountIn: string, minAmountOut?: string | null, slippageToleranceBps?: number | null, quotedAmountOut?: string | null, actualAmountOut?: string | null, timeEstimateSeconds?: number | null, amountInUsd?: string | null, deadline: string, failureReason?: string | null, originTxHashes: Array<string>, destinationTxHashes: Array<string>, customerTransactionId?: number | null, createdAt: string };

export type GetNearIntentsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<NearIntentStatus>;
}>;


export type GetNearIntentsQuery = { __typename?: 'Query', nearIntents: Array<{ __typename?: 'NearIntent', id: string, status: NearIntentStatus, originAssetId: string, originBlockchain: string, originSymbol: string, recipientAddress: string, refundTo: string, depositAddress: string, depositMemo?: string | null, amountIn: string, minAmountOut?: string | null, slippageToleranceBps?: number | null, quotedAmountOut?: string | null, actualAmountOut?: string | null, timeEstimateSeconds?: number | null, amountInUsd?: string | null, deadline: string, failureReason?: string | null, originTxHashes: Array<string>, destinationTxHashes: Array<string>, customerTransactionId?: number | null, createdAt: string }> };

export type GetNearIntentQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  intentId: Scalars['String']['input'];
}>;


export type GetNearIntentQuery = { __typename?: 'Query', nearIntent?: { __typename?: 'NearIntent', id: string, status: NearIntentStatus, originAssetId: string, originBlockchain: string, originSymbol: string, recipientAddress: string, refundTo: string, depositAddress: string, depositMemo?: string | null, amountIn: string, minAmountOut?: string | null, slippageToleranceBps?: number | null, quotedAmountOut?: string | null, actualAmountOut?: string | null, timeEstimateSeconds?: number | null, amountInUsd?: string | null, deadline: string, failureReason?: string | null, originTxHashes: Array<string>, destinationTxHashes: Array<string>, customerTransactionId?: number | null, createdAt: string } | null };

export type CustomerSwapFieldsFragment = { __typename?: 'CustomerSwap', id: string, status: CustomerSwapStatus, customerExternalId: string, amountIn: string, estimatedAmountOut: string, minAmountOut: string, amountOut?: string | null, failureReason?: string | null, originTxHash?: string | null, destinationTxHash?: string | null, refundTxHash?: string | null, nearIntentId?: string | null, prefundNearIntentId?: string | null, intentStatus?: NearIntentStatus | null, intentDeadline?: string | null, createdAt: string, completedAt?: string | null, fromMint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string }, toMint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string } };

export type GetCustomerSwapsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  filter?: InputMaybe<CustomerSwapFilter>;
  pagination?: InputMaybe<CustomerSwapPagination>;
}>;


export type GetCustomerSwapsQuery = { __typename?: 'Query', customerSwaps: { __typename?: 'CustomerSwapConnection', nextCursor?: string | null, items: Array<{ __typename?: 'CustomerSwap', id: string, status: CustomerSwapStatus, customerExternalId: string, amountIn: string, estimatedAmountOut: string, minAmountOut: string, amountOut?: string | null, failureReason?: string | null, originTxHash?: string | null, destinationTxHash?: string | null, refundTxHash?: string | null, nearIntentId?: string | null, prefundNearIntentId?: string | null, intentStatus?: NearIntentStatus | null, intentDeadline?: string | null, createdAt: string, completedAt?: string | null, fromMint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string }, toMint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string } }> } };

export type GetCustomerSwapQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type GetCustomerSwapQuery = { __typename?: 'Query', customerSwap?: { __typename?: 'CustomerSwap', id: string, status: CustomerSwapStatus, customerExternalId: string, amountIn: string, estimatedAmountOut: string, minAmountOut: string, amountOut?: string | null, failureReason?: string | null, originTxHash?: string | null, destinationTxHash?: string | null, refundTxHash?: string | null, nearIntentId?: string | null, prefundNearIntentId?: string | null, intentStatus?: NearIntentStatus | null, intentDeadline?: string | null, createdAt: string, completedAt?: string | null, fromMint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string }, toMint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string } } | null };

export type GetCustomerSwapsExportQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  filter?: InputMaybe<CustomerSwapFilter>;
}>;


export type GetCustomerSwapsExportQuery = { __typename?: 'Query', customerSwapsExport: Array<{ __typename?: 'CustomerSwap', id: string, status: CustomerSwapStatus, customerExternalId: string, amountIn: string, estimatedAmountOut: string, minAmountOut: string, amountOut?: string | null, failureReason?: string | null, originTxHash?: string | null, destinationTxHash?: string | null, refundTxHash?: string | null, nearIntentId?: string | null, prefundNearIntentId?: string | null, intentStatus?: NearIntentStatus | null, intentDeadline?: string | null, createdAt: string, completedAt?: string | null, fromMint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string }, toMint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string } }> };

export type GetValiantSwapsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetValiantSwapsQuery = { __typename?: 'Query', valiantSwaps: Array<{ __typename?: 'ValiantSwap', id: string, fromMint: string, toMint: string, amount: string, earmarkedAmount?: string | null, toAmountHuman?: string | null, whitelistedAddressId: string, whitelistedAddress: string, whitelistedChain: Chain, depositTxid?: string | null, depositRef?: string | null, swapId?: string | null, txHashes: Array<string>, depositStage: SwapDepositStage, swapStage: SwapStage, overallStatus: SwapOverallStatus, failureReason?: string | null, createdAt: string, updatedAt: string }> };

export type GetValiantSwapQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  swapId: Scalars['String']['input'];
}>;


export type GetValiantSwapQuery = { __typename?: 'Query', valiantSwap?: { __typename?: 'ValiantSwap', id: string, fromMint: string, toMint: string, amount: string, earmarkedAmount?: string | null, toAmountHuman?: string | null, whitelistedAddressId: string, whitelistedAddress: string, whitelistedChain: Chain, depositTxid?: string | null, depositRef?: string | null, swapId?: string | null, txHashes: Array<string>, depositStage: SwapDepositStage, swapStage: SwapStage, overallStatus: SwapOverallStatus, failureReason?: string | null, createdAt: string, updatedAt: string } | null };

export type CreateSwapMutationVariables = Exact<{
  input: CreateSwapInput;
}>;


export type CreateSwapMutation = { __typename?: 'Mutation', createSwap: { __typename?: 'ValiantSwap', id: string, fromMint: string, toMint: string, amount: string, earmarkedAmount?: string | null, toAmountHuman?: string | null, whitelistedAddressId: string, whitelistedAddress: string, whitelistedChain: Chain, depositTxid?: string | null, depositRef?: string | null, swapId?: string | null, txHashes: Array<string>, depositStage: SwapDepositStage, swapStage: SwapStage, overallStatus: SwapOverallStatus, failureReason?: string | null, createdAt: string, updatedAt: string } };

export type BatchPayoutRecipientFieldsFragment = { __typename?: 'BatchPayoutRecipient', id: string, address: string, amount: string, reference?: string | null, name?: string | null, status: BatchPayoutRecipientStatus, txHash?: string | null, error?: string | null, transactionReference?: string | null, splitTxid?: string | null, splitVout?: number | null, splitConfirmed?: boolean | null, payoutConfirmedAt?: string | null };

export type BatchPayoutFieldsFragment = { __typename?: 'BatchPayout', id: string, organizationId: string, chain: Chain, mintId: number, mode: BatchPayoutMode, status: BatchPayoutStatus, phase: BatchPayoutPhase, totalAmount: string, recipientCount: number, label?: string | null, idempotencyKey: string, createdBy: string, createdAt: string, updatedAt: string, initiatedBy?: { __typename?: 'BatchPayoutActor', userId: string, username: string, email: string } | null, recipients: Array<{ __typename?: 'BatchPayoutRecipient', id: string, address: string, amount: string, reference?: string | null, name?: string | null, status: BatchPayoutRecipientStatus, txHash?: string | null, error?: string | null, transactionReference?: string | null, splitTxid?: string | null, splitVout?: number | null, splitConfirmed?: boolean | null, payoutConfirmedAt?: string | null }> };

export type BatchPayoutActorFieldsFragment = { __typename?: 'BatchPayoutActor', userId: string, username: string, email: string };

export type BatchPayoutsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type BatchPayoutsQuery = { __typename?: 'Query', batchPayouts: Array<{ __typename?: 'BatchPayout', id: string, organizationId: string, chain: Chain, mintId: number, mode: BatchPayoutMode, status: BatchPayoutStatus, phase: BatchPayoutPhase, totalAmount: string, recipientCount: number, label?: string | null, idempotencyKey: string, createdBy: string, createdAt: string, updatedAt: string, initiatedBy?: { __typename?: 'BatchPayoutActor', userId: string, username: string, email: string } | null, recipients: Array<{ __typename?: 'BatchPayoutRecipient', id: string, address: string, amount: string, reference?: string | null, name?: string | null, status: BatchPayoutRecipientStatus, txHash?: string | null, error?: string | null, transactionReference?: string | null, splitTxid?: string | null, splitVout?: number | null, splitConfirmed?: boolean | null, payoutConfirmedAt?: string | null }> }> };

export type BatchPayoutQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type BatchPayoutQuery = { __typename?: 'Query', batchPayout?: { __typename?: 'BatchPayout', id: string, organizationId: string, chain: Chain, mintId: number, mode: BatchPayoutMode, status: BatchPayoutStatus, phase: BatchPayoutPhase, totalAmount: string, recipientCount: number, label?: string | null, idempotencyKey: string, createdBy: string, createdAt: string, updatedAt: string, initiatedBy?: { __typename?: 'BatchPayoutActor', userId: string, username: string, email: string } | null, recipients: Array<{ __typename?: 'BatchPayoutRecipient', id: string, address: string, amount: string, reference?: string | null, name?: string | null, status: BatchPayoutRecipientStatus, txHash?: string | null, error?: string | null, transactionReference?: string | null, splitTxid?: string | null, splitVout?: number | null, splitConfirmed?: boolean | null, payoutConfirmedAt?: string | null }> } | null };

export type CreateBatchPayoutMutationVariables = Exact<{
  input: CreateBatchPayoutInput;
}>;


export type CreateBatchPayoutMutation = { __typename?: 'Mutation', createBatchPayout: { __typename?: 'BatchPayout', id: string, organizationId: string, chain: Chain, mintId: number, mode: BatchPayoutMode, status: BatchPayoutStatus, phase: BatchPayoutPhase, totalAmount: string, recipientCount: number, label?: string | null, idempotencyKey: string, createdBy: string, createdAt: string, updatedAt: string, initiatedBy?: { __typename?: 'BatchPayoutActor', userId: string, username: string, email: string } | null, recipients: Array<{ __typename?: 'BatchPayoutRecipient', id: string, address: string, amount: string, reference?: string | null, name?: string | null, status: BatchPayoutRecipientStatus, txHash?: string | null, error?: string | null, transactionReference?: string | null, splitTxid?: string | null, splitVout?: number | null, splitConfirmed?: boolean | null, payoutConfirmedAt?: string | null }> } };

export type UpdateBatchPayoutLabelsMutationVariables = Exact<{
  input: UpdateBatchPayoutLabelsInput;
}>;


export type UpdateBatchPayoutLabelsMutation = { __typename?: 'Mutation', updateBatchPayoutLabels: { __typename?: 'BatchPayout', id: string, organizationId: string, chain: Chain, mintId: number, mode: BatchPayoutMode, status: BatchPayoutStatus, phase: BatchPayoutPhase, totalAmount: string, recipientCount: number, label?: string | null, idempotencyKey: string, createdBy: string, createdAt: string, updatedAt: string, initiatedBy?: { __typename?: 'BatchPayoutActor', userId: string, username: string, email: string } | null, recipients: Array<{ __typename?: 'BatchPayoutRecipient', id: string, address: string, amount: string, reference?: string | null, name?: string | null, status: BatchPayoutRecipientStatus, txHash?: string | null, error?: string | null, transactionReference?: string | null, splitTxid?: string | null, splitVout?: number | null, splitConfirmed?: boolean | null, payoutConfirmedAt?: string | null }> } };

export type SubmitBatchPayoutMutationVariables = Exact<{
  id: Scalars['String']['input'];
  totpCode: Scalars['String']['input'];
}>;


export type SubmitBatchPayoutMutation = { __typename?: 'Mutation', submitBatchPayout: { __typename?: 'BatchPayout', id: string, organizationId: string, chain: Chain, mintId: number, mode: BatchPayoutMode, status: BatchPayoutStatus, phase: BatchPayoutPhase, totalAmount: string, recipientCount: number, label?: string | null, idempotencyKey: string, createdBy: string, createdAt: string, updatedAt: string, initiatedBy?: { __typename?: 'BatchPayoutActor', userId: string, username: string, email: string } | null, recipients: Array<{ __typename?: 'BatchPayoutRecipient', id: string, address: string, amount: string, reference?: string | null, name?: string | null, status: BatchPayoutRecipientStatus, txHash?: string | null, error?: string | null, transactionReference?: string | null, splitTxid?: string | null, splitVout?: number | null, splitConfirmed?: boolean | null, payoutConfirmedAt?: string | null }> } };

export type InvoiceLineItemFragment = { __typename?: 'InvoiceLineItem', id: string, productId: string, quantity: number, unitPriceUsdSnapshot: string, lineTotalUsdSnapshot: string, productSnapshot?: any | null, sortOrder: number };

export type InvoiceSummaryFragment = { __typename?: 'Invoice', id: string, number: string, status: InvoiceStatus, amountUsd: string, amountPaidUsd: string, dueDate: string, createdAt: string, hostedUrl: string, terminalCode?: string | null, externalReference?: string | null, externalSource?: string | null };

export type InvoiceSessionSummaryFragment = { __typename?: 'InvoiceSessionSummary', id: string, status: CheckoutSessionStatus, mintSymbol: string, mintChain: string, rateLocked: string, amountRequired: string, amountReceived: string, expiresAt: string, createdAt: string, amountSent: { __typename?: 'CheckoutSessionAmountSent', amountSentCrypto: string, amountSentUsd: string, amountRequiredCrypto: string, amountRequiredUsd: string, shortfallCrypto: string, shortfallUsd: string, paymentIndicator?: CheckoutSessionPaymentIndicator | null, isTestnet: boolean } };

export type InvoiceDetailFragment = { __typename?: 'Invoice', organizationId: string, updatedAt: string, voidedAt?: string | null, fundsReceivedOnVoid: boolean, checkoutId: string, id: string, number: string, status: InvoiceStatus, amountUsd: string, amountPaidUsd: string, dueDate: string, createdAt: string, hostedUrl: string, terminalCode?: string | null, externalReference?: string | null, externalSource?: string | null, lineItems?: Array<{ __typename?: 'InvoiceLineItem', id: string, productId: string, quantity: number, unitPriceUsdSnapshot: string, lineTotalUsdSnapshot: string, productSnapshot?: any | null, sortOrder: number }> | null, sessions?: Array<{ __typename?: 'InvoiceSessionSummary', id: string, status: CheckoutSessionStatus, mintSymbol: string, mintChain: string, rateLocked: string, amountRequired: string, amountReceived: string, expiresAt: string, createdAt: string, amountSent: { __typename?: 'CheckoutSessionAmountSent', amountSentCrypto: string, amountSentUsd: string, amountRequiredCrypto: string, amountRequiredUsd: string, shortfallCrypto: string, shortfallUsd: string, paymentIndicator?: CheckoutSessionPaymentIndicator | null, isTestnet: boolean } }> | null };

export type GetInvoicesQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetInvoicesQuery = { __typename?: 'Query', getInvoices: { __typename?: 'InvoiceList', hasMore: boolean, nextCursor?: string | null, items: Array<{ __typename?: 'Invoice', id: string, number: string, status: InvoiceStatus, amountUsd: string, amountPaidUsd: string, dueDate: string, createdAt: string, hostedUrl: string, terminalCode?: string | null, externalReference?: string | null, externalSource?: string | null }> } };

export type GetInvoiceQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type GetInvoiceQuery = { __typename?: 'Query', getInvoice?: { __typename?: 'Invoice', organizationId: string, updatedAt: string, voidedAt?: string | null, fundsReceivedOnVoid: boolean, checkoutId: string, id: string, number: string, status: InvoiceStatus, amountUsd: string, amountPaidUsd: string, dueDate: string, createdAt: string, hostedUrl: string, terminalCode?: string | null, externalReference?: string | null, externalSource?: string | null, lineItems?: Array<{ __typename?: 'InvoiceLineItem', id: string, productId: string, quantity: number, unitPriceUsdSnapshot: string, lineTotalUsdSnapshot: string, productSnapshot?: any | null, sortOrder: number }> | null, sessions?: Array<{ __typename?: 'InvoiceSessionSummary', id: string, status: CheckoutSessionStatus, mintSymbol: string, mintChain: string, rateLocked: string, amountRequired: string, amountReceived: string, expiresAt: string, createdAt: string, amountSent: { __typename?: 'CheckoutSessionAmountSent', amountSentCrypto: string, amountSentUsd: string, amountRequiredCrypto: string, amountRequiredUsd: string, shortfallCrypto: string, shortfallUsd: string, paymentIndicator?: CheckoutSessionPaymentIndicator | null, isTestnet: boolean } }> | null } | null };

export type CreateInvoiceMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  input: CreateInvoiceInput;
}>;


export type CreateInvoiceMutation = { __typename?: 'Mutation', createInvoice: { __typename?: 'Invoice', organizationId: string, updatedAt: string, voidedAt?: string | null, fundsReceivedOnVoid: boolean, checkoutId: string, id: string, number: string, status: InvoiceStatus, amountUsd: string, amountPaidUsd: string, dueDate: string, createdAt: string, hostedUrl: string, terminalCode?: string | null, externalReference?: string | null, externalSource?: string | null, lineItems?: Array<{ __typename?: 'InvoiceLineItem', id: string, productId: string, quantity: number, unitPriceUsdSnapshot: string, lineTotalUsdSnapshot: string, productSnapshot?: any | null, sortOrder: number }> | null, sessions?: Array<{ __typename?: 'InvoiceSessionSummary', id: string, status: CheckoutSessionStatus, mintSymbol: string, mintChain: string, rateLocked: string, amountRequired: string, amountReceived: string, expiresAt: string, createdAt: string, amountSent: { __typename?: 'CheckoutSessionAmountSent', amountSentCrypto: string, amountSentUsd: string, amountRequiredCrypto: string, amountRequiredUsd: string, shortfallCrypto: string, shortfallUsd: string, paymentIndicator?: CheckoutSessionPaymentIndicator | null, isTestnet: boolean } }> | null } };

export type VoidInvoiceMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type VoidInvoiceMutation = { __typename?: 'Mutation', voidInvoice: { __typename?: 'Invoice', organizationId: string, updatedAt: string, voidedAt?: string | null, fundsReceivedOnVoid: boolean, checkoutId: string, id: string, number: string, status: InvoiceStatus, amountUsd: string, amountPaidUsd: string, dueDate: string, createdAt: string, hostedUrl: string, terminalCode?: string | null, externalReference?: string | null, externalSource?: string | null, lineItems?: Array<{ __typename?: 'InvoiceLineItem', id: string, productId: string, quantity: number, unitPriceUsdSnapshot: string, lineTotalUsdSnapshot: string, productSnapshot?: any | null, sortOrder: number }> | null, sessions?: Array<{ __typename?: 'InvoiceSessionSummary', id: string, status: CheckoutSessionStatus, mintSymbol: string, mintChain: string, rateLocked: string, amountRequired: string, amountReceived: string, expiresAt: string, createdAt: string, amountSent: { __typename?: 'CheckoutSessionAmountSent', amountSentCrypto: string, amountSentUsd: string, amountRequiredCrypto: string, amountRequiredUsd: string, shortfallCrypto: string, shortfallUsd: string, paymentIndicator?: CheckoutSessionPaymentIndicator | null, isTestnet: boolean } }> | null } };

export type ExtendInvoiceMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  dueDate: Scalars['String']['input'];
}>;


export type ExtendInvoiceMutation = { __typename?: 'Mutation', extendInvoice: { __typename?: 'Invoice', organizationId: string, updatedAt: string, voidedAt?: string | null, fundsReceivedOnVoid: boolean, checkoutId: string, id: string, number: string, status: InvoiceStatus, amountUsd: string, amountPaidUsd: string, dueDate: string, createdAt: string, hostedUrl: string, terminalCode?: string | null, externalReference?: string | null, externalSource?: string | null, lineItems?: Array<{ __typename?: 'InvoiceLineItem', id: string, productId: string, quantity: number, unitPriceUsdSnapshot: string, lineTotalUsdSnapshot: string, productSnapshot?: any | null, sortOrder: number }> | null, sessions?: Array<{ __typename?: 'InvoiceSessionSummary', id: string, status: CheckoutSessionStatus, mintSymbol: string, mintChain: string, rateLocked: string, amountRequired: string, amountReceived: string, expiresAt: string, createdAt: string, amountSent: { __typename?: 'CheckoutSessionAmountSent', amountSentCrypto: string, amountSentUsd: string, amountRequiredCrypto: string, amountRequiredUsd: string, shortfallCrypto: string, shortfallUsd: string, paymentIndicator?: CheckoutSessionPaymentIndicator | null, isTestnet: boolean } }> | null } };

export type PlatformBillKindUsageFragment = { __typename?: 'PlatformBillKindUsage', kind: PlatformBillLineItemKind, count: number, feeBps: number, totalFeeAmount: string };

export type PlatformBillLineItemFragment = { __typename?: 'PlatformBillLineItem', id: number, kind: PlatformBillLineItemKind, sourceTxRef?: string | null, grossAmount: string, feeBps: number, feeAmount: string };

export type PlatformBillFragment = { __typename?: 'PlatformBill', id: number, organizationId: string, yearMonth: string, mintId: number, mainWalletId: number, mainWalletPurpose: MainWalletPurpose, status: PlatformBillStatus, paidAt?: string | null, dueAmount: string, usdDueAmount: string, isClosed: boolean, unpricedLineCount: number, kindUsage: Array<{ __typename?: 'PlatformBillKindUsage', kind: PlatformBillLineItemKind, count: number, feeBps: number, totalFeeAmount: string }>, lineItems: Array<{ __typename?: 'PlatformBillLineItem', id: number, kind: PlatformBillLineItemKind, sourceTxRef?: string | null, grossAmount: string, feeBps: number, feeAmount: string }> };

export type PlatformBillUsdBreakdownRowFragment = { __typename?: 'PlatformBillUsdBreakdownRow', mintId: number, mainWalletPurpose: MainWalletPurpose, period: PlatformBillUsdPeriod, cryptoFeeTotal: string, snapshotUsd: string, unpricedLineCount: number };

export type GetPlatformBillUsdDueQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetPlatformBillUsdDueQuery = { __typename?: 'Query', getPlatformBillUsdDue: { __typename?: 'PlatformBillUsdDue', dueNowUsd: string, accruingUsd: string, breakdown: Array<{ __typename?: 'PlatformBillUsdBreakdownRow', mintId: number, mainWalletPurpose: MainWalletPurpose, period: PlatformBillUsdPeriod, cryptoFeeTotal: string, snapshotUsd: string, unpricedLineCount: number }> } };

export type GetPlayerBalancesQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetPlayerBalancesQuery = { __typename?: 'Query', getPlayerBalances: { __typename?: 'PlayerBalances', totalUsd?: string | null, fetchedAt?: string | null, status?: PlayerBalanceSnapshotStatus | null, lastError?: string | null, isStale: boolean, tokens: Array<{ __typename?: 'PlayerBalanceToken', mintId: number, symbol?: string | null, chain?: Chain | null, amount: string, usdValue?: string | null, isTestnet: boolean }> } };

export type ListPlatformBillsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  status?: InputMaybe<PlatformBillStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListPlatformBillsQuery = { __typename?: 'Query', listPlatformBills: { __typename?: 'PlatformBillList', hasMore: boolean, nextCursor?: number | null, items: Array<{ __typename?: 'PlatformBill', id: number, organizationId: string, yearMonth: string, mintId: number, mainWalletId: number, mainWalletPurpose: MainWalletPurpose, status: PlatformBillStatus, paidAt?: string | null, dueAmount: string, usdDueAmount: string, isClosed: boolean, unpricedLineCount: number, kindUsage: Array<{ __typename?: 'PlatformBillKindUsage', kind: PlatformBillLineItemKind, count: number, feeBps: number, totalFeeAmount: string }>, lineItems: Array<{ __typename?: 'PlatformBillLineItem', id: number, kind: PlatformBillLineItemKind, sourceTxRef?: string | null, grossAmount: string, feeBps: number, feeAmount: string }> }> } };

export type ListPlatformBillPaymentsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListPlatformBillPaymentsQuery = { __typename?: 'Query', listPlatformBillPayments: { __typename?: 'PlatformBillPaymentList', hasMore: boolean, nextCursor?: number | null, items: Array<{ __typename?: 'PlatformBillPayment', id: number, createdAt: string, amount: string, usdDueCovered: string, mintId: number, mintSymbol: string, chain: Chain, mainWalletPurpose: MainWalletPurpose, status: PlatformBillPaymentStatus, settledTxRef?: string | null, coveredBills: Array<{ __typename?: 'PlatformBillPaymentCoveredBill', id: number, yearMonth: string }> }> } };

export type PlatformFeeRecipientQueryVariables = Exact<{
  chain: Chain;
}>;


export type PlatformFeeRecipientQuery = { __typename?: 'Query', platformFeeRecipient: string };

export type PayAllPlatformBillsMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  mintId: Scalars['Int']['input'];
  mainWalletPurpose: MainWalletPurpose;
  expectedUsdDueMicro?: InputMaybe<Scalars['String']['input']>;
}>;


export type PayAllPlatformBillsMutation = { __typename?: 'Mutation', payAllPlatformBills: { __typename?: 'PlatformBillPaymentResult', paymentId: number, amount: string, usdDueCovered: string, billIds: Array<number>, mainWalletId: number } };

export type PayPlatformBillMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  platformBillId: Scalars['Int']['input'];
  mintId: Scalars['Int']['input'];
  mainWalletPurpose: MainWalletPurpose;
  expectedUsdDueMicro?: InputMaybe<Scalars['String']['input']>;
}>;


export type PayPlatformBillMutation = { __typename?: 'Mutation', payPlatformBill: { __typename?: 'PlatformBillPaymentResult', paymentId: number, amount: string, usdDueCovered: string, billIds: Array<number>, mainWalletId: number } };

export type ReportingTransactionFieldsFragment = { __typename?: 'ReportingTransaction', confirmedAt: string, metric: string, typeLabel: string, tokenSymbol: string, chain: Chain, tokenAmount: string, usdValue?: string | null, usdPrice?: string | null, usdValueMissing: boolean, status: TransactionStatus, txHash?: string | null, fromAddress: string, toAddress: string, counterparty: string, reference?: string | null, name?: string | null, batchLabel?: string | null, explorerUrl?: string | null };

export type ReportingMonthlySummaryFieldsFragment = { __typename?: 'ReportingMonthlySummary', yearMonth: string, depositsUsd: string, depositsCount: number, withdrawalsUsd: string, withdrawalsCount: number, paymentsUsd: string, paymentsCount: number, refundsUsd: string, refundsCount: number, payoutsUsd: string, payoutsCount: number, fundingUsd: string, fundingCount: number };

export type ReportingMonthlySummaryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  purpose: MainWalletPurpose;
}>;


export type ReportingMonthlySummaryQuery = { __typename?: 'Query', reportingMonthlySummary: Array<{ __typename?: 'ReportingMonthlySummary', yearMonth: string, depositsUsd: string, depositsCount: number, withdrawalsUsd: string, withdrawalsCount: number, paymentsUsd: string, paymentsCount: number, refundsUsd: string, refundsCount: number, payoutsUsd: string, payoutsCount: number, fundingUsd: string, fundingCount: number }> };

export type ReportingTransactionsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  purpose: MainWalletPurpose;
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
}>;


export type ReportingTransactionsQuery = { __typename?: 'Query', reportingTransactions: Array<{ __typename?: 'ReportingTransaction', confirmedAt: string, metric: string, typeLabel: string, tokenSymbol: string, chain: Chain, tokenAmount: string, usdValue?: string | null, usdPrice?: string | null, usdValueMissing: boolean, status: TransactionStatus, txHash?: string | null, fromAddress: string, toAddress: string, counterparty: string, reference?: string | null, name?: string | null, batchLabel?: string | null, explorerUrl?: string | null }> };

export type SwapsReportingMonthlySummaryFieldsFragment = { __typename?: 'SwapsReportingMonthlySummary', yearMonth: string, volumeUsd: string, swapsCount: number };

export type SwapsReportingSwapFieldsFragment = { __typename?: 'SwapsReportingSwap', confirmedAt: string, fromTokenSymbol: string, fromAmount: string, toTokenSymbol: string, toAmountHuman?: string | null, rate?: string | null, fee?: string | null, feeUsd?: string | null, feeBps?: number | null, volumeUsd?: string | null, volumeUsdMissing: boolean, status: string, txHashes: Array<string>, explorerUrls: Array<string>, depositTxid?: string | null, depositExplorerUrl?: string | null };

export type ReportingSwapsMonthlySummaryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ReportingSwapsMonthlySummaryQuery = { __typename?: 'Query', reportingSwapsMonthlySummary: Array<{ __typename?: 'SwapsReportingMonthlySummary', yearMonth: string, volumeUsd: string, swapsCount: number }> };

export type ReportingSwapsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
}>;


export type ReportingSwapsQuery = { __typename?: 'Query', reportingSwaps: Array<{ __typename?: 'SwapsReportingSwap', confirmedAt: string, fromTokenSymbol: string, fromAmount: string, toTokenSymbol: string, toAmountHuman?: string | null, rate?: string | null, fee?: string | null, feeUsd?: string | null, feeBps?: number | null, volumeUsd?: string | null, volumeUsdMissing: boolean, status: string, txHashes: Array<string>, explorerUrls: Array<string>, depositTxid?: string | null, depositExplorerUrl?: string | null }> };

export type ReportingCountUsdFieldsFragment = { __typename?: 'ReportingCountUsd', usdValue: string, count: number };

export type ReportingMetricStableWindowsFieldsFragment = { __typename?: 'ReportingMetricStableWindows', yesterday: { __typename?: 'ReportingCountUsd', usdValue: string, count: number }, priorSixDays: { __typename?: 'ReportingCountUsd', usdValue: string, count: number }, monthToYesterday: { __typename?: 'ReportingCountUsd', usdValue: string, count: number }, lifetimeToYesterday: { __typename?: 'ReportingCountUsd', usdValue: string, count: number } };

export type ReportingSwapWindowBucketFieldsFragment = { __typename?: 'ReportingSwapWindowBucket', volumeUsd: string, swapsCount: number };

export type ReportingWindowedStableQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  purpose: MainWalletPurpose;
  timezone: Scalars['String']['input'];
  cacheDay: Scalars['String']['input'];
}>;


export type ReportingWindowedStableQuery = { __typename?: 'Query', reportingWindowedTotals: { __typename?: 'ReportingWindowedTotals', purpose: MainWalletPurpose, timezone: string, metrics: Array<{ __typename?: 'ReportingMetricWindowedTotals', metric: KpiFlowMetric, stable: { __typename?: 'ReportingMetricStableWindows', yesterday: { __typename?: 'ReportingCountUsd', usdValue: string, count: number }, priorSixDays: { __typename?: 'ReportingCountUsd', usdValue: string, count: number }, monthToYesterday: { __typename?: 'ReportingCountUsd', usdValue: string, count: number }, lifetimeToYesterday: { __typename?: 'ReportingCountUsd', usdValue: string, count: number } } }> } };

export type ReportingWindowedTodayQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  purpose: MainWalletPurpose;
  timezone: Scalars['String']['input'];
  cacheDay: Scalars['String']['input'];
}>;


export type ReportingWindowedTodayQuery = { __typename?: 'Query', reportingWindowedTotals: { __typename?: 'ReportingWindowedTotals', purpose: MainWalletPurpose, timezone: string, metrics: Array<{ __typename?: 'ReportingMetricWindowedTotals', metric: KpiFlowMetric, today: { __typename?: 'ReportingMetricTodayWindow', today: { __typename?: 'ReportingCountUsd', usdValue: string, count: number } } }> } };

export type ReportingSwapsWindowedStableQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  cacheDay: Scalars['String']['input'];
}>;


export type ReportingSwapsWindowedStableQuery = { __typename?: 'Query', reportingSwapsWindowedTotals: { __typename?: 'ReportingSwapsWindowedTotals', timezone: string, stable: { __typename?: 'ReportingSwapsStableWindows', yesterday: { __typename?: 'ReportingSwapWindowBucket', volumeUsd: string, swapsCount: number }, priorSixDays: { __typename?: 'ReportingSwapWindowBucket', volumeUsd: string, swapsCount: number }, monthToYesterday: { __typename?: 'ReportingSwapWindowBucket', volumeUsd: string, swapsCount: number }, lifetimeToYesterday: { __typename?: 'ReportingSwapWindowBucket', volumeUsd: string, swapsCount: number } } } };

export type ReportingSwapsWindowedTodayQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  cacheDay: Scalars['String']['input'];
}>;


export type ReportingSwapsWindowedTodayQuery = { __typename?: 'Query', reportingSwapsWindowedTotals: { __typename?: 'ReportingSwapsWindowedTotals', timezone: string, today: { __typename?: 'ReportingSwapsTodayWindow', today: { __typename?: 'ReportingSwapWindowBucket', volumeUsd: string, swapsCount: number } } } };

export type ReportingTimeSeriesAmountsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  purpose: MainWalletPurpose;
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
  granularity: TimeSeriesGranularity;
  timezone: Scalars['String']['input'];
}>;


export type ReportingTimeSeriesAmountsQuery = { __typename?: 'Query', reportingTimeSeries: { __typename?: 'ReportingTimeSeries', purpose: MainWalletPurpose, granularity: TimeSeriesGranularity, timezone: string, buckets: Array<{ __typename?: 'ReportingTimeSeriesBucket', bucketStart: string, depositsUsd?: string | null, withdrawalsUsd?: string | null, salesUsd?: string | null }>, rangeTotals: { __typename?: 'ReportingTimeSeriesRangeTotals', depositsUsd?: string | null, withdrawalsUsd?: string | null, salesUsd?: string | null } } };

export type ReportingTimeSeriesUniquesQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  purpose: MainWalletPurpose;
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
  granularity: TimeSeriesGranularity;
  timezone: Scalars['String']['input'];
}>;


export type ReportingTimeSeriesUniquesQuery = { __typename?: 'Query', reportingTimeSeries: { __typename?: 'ReportingTimeSeries', purpose: MainWalletPurpose, granularity: TimeSeriesGranularity, timezone: string, buckets: Array<{ __typename?: 'ReportingTimeSeriesBucket', bucketStart: string, uniqueDepositors?: number | null, uniqueWithdrawers?: number | null, uniqueBuyers?: number | null }>, rangeTotals: { __typename?: 'ReportingTimeSeriesRangeTotals', uniqueDepositors?: number | null, uniqueWithdrawers?: number | null, uniqueBuyers?: number | null } } };

export type GetTerminalDevicesQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetTerminalDevicesQuery = { __typename?: 'Query', getTerminalDevices: Array<{ __typename?: 'TerminalDevice', id: string, organizationId: string, name: string, status: TerminalDeviceStatus, lastSeenAt?: string | null, revokedAt?: string | null, pairedAt: string, createdAt: string }> };

export type GetTerminalOperatorsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetTerminalOperatorsQuery = { __typename?: 'Query', getTerminalOperators: Array<{ __typename?: 'TerminalOperator', id: string, organizationId: string, name: string, code: string, status: TerminalOperatorStatus, createdAt: string, updatedAt: string }> };

export type CreateTerminalPairingCodeMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type CreateTerminalPairingCodeMutation = { __typename?: 'Mutation', createTerminalPairingCode: { __typename?: 'TerminalPairingCodeResult', id: string, code: string, expiresAt: string } };

export type RenameTerminalDeviceMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type RenameTerminalDeviceMutation = { __typename?: 'Mutation', renameTerminalDevice: { __typename?: 'TerminalDevice', id: string, name: string, status: TerminalDeviceStatus, lastSeenAt?: string | null, pairedAt: string } };

export type RevokeTerminalDeviceMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
}>;


export type RevokeTerminalDeviceMutation = { __typename?: 'Mutation', revokeTerminalDevice: { __typename?: 'TerminalDevice', id: string, status: TerminalDeviceStatus, revokedAt?: string | null } };

export type CreateTerminalOperatorMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  input: CreateTerminalOperatorInput;
}>;


export type CreateTerminalOperatorMutation = { __typename?: 'Mutation', createTerminalOperator: { __typename?: 'TerminalOperator', id: string, name: string, code: string, status: TerminalOperatorStatus } };

export type UpdateTerminalOperatorMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  operatorId: Scalars['String']['input'];
  input: UpdateTerminalOperatorInput;
}>;


export type UpdateTerminalOperatorMutation = { __typename?: 'Mutation', updateTerminalOperator: { __typename?: 'TerminalOperator', id: string, name: string, code: string, status: TerminalOperatorStatus } };

export type ArchiveTerminalOperatorMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  operatorId: Scalars['String']['input'];
}>;


export type ArchiveTerminalOperatorMutation = { __typename?: 'Mutation', archiveTerminalOperator: { __typename?: 'TerminalOperator', id: string, status: TerminalOperatorStatus } };

export type CreatePurposeWalletTransferMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  sourcePurpose: MainWalletPurpose;
  destPurpose: MainWalletPurpose;
  mintId: Scalars['Int']['input'];
  amount: Scalars['String']['input'];
}>;


export type CreatePurposeWalletTransferMutation = { __typename?: 'Mutation', createPurposeWalletTransfer: { __typename?: 'PurposeWalletTransferResult', transferId: string, outTransactionId: number } };

export type PurposeTransferSpendableQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  purpose: MainWalletPurpose;
  mintId: Scalars['Int']['input'];
}>;


export type PurposeTransferSpendableQuery = { __typename?: 'Query', purposeTransferSpendable: { __typename?: 'PurposeTransferSpendable', spendable: string, confirmed: string, networkFeeReserve: string } };

export type WithdrawableBalanceQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  purpose: MainWalletPurpose;
  mintId: Scalars['Int']['input'];
}>;


export type WithdrawableBalanceQuery = { __typename?: 'Query', withdrawableBalance: { __typename?: 'WithdrawableBalance', balance: string, networkFeeReserve: string, maxWithdrawable: string } };

export type GetPurposeWalletTransfersQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetPurposeWalletTransfersQuery = { __typename?: 'Query', getPurposeWalletTransfers: { __typename?: 'PurposeWalletTransfersPagination', totalCount: number, transfers: Array<{ __typename?: 'PurposeWalletTransfer', id: string, sourcePurpose: MainWalletPurpose, destPurpose: MainWalletPurpose, status: PurposeWalletTransferStatus, amount: string, uiAmount: string, usdAmount: string, txHash: string, fromAddress: string, toAddress: string, createdAt: string, confirmedAt?: string | null, failedReason?: string | null, mint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, isNative: boolean, isTestnet: boolean, symbol: string, decimals: number, address?: string | null, usdPrice: string } }> } };

export type TreasuryMintPoliciesQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type TreasuryMintPoliciesQuery = { __typename?: 'Query', treasuryMintPolicies: Array<{ __typename?: 'TreasuryMintPolicy', autoSwapToSolUsdc: boolean, eligible: boolean, ineligibilityCode?: TreasuryMintPolicyIneligibility | null, ineligibilityReason?: string | null, autoPrefundFromSolUsdc: boolean, prefundEligible: boolean, prefundIneligibilityCode?: TreasuryMintPrefundIneligibility | null, prefundIneligibilityReason?: string | null, mint: { __typename?: 'Mint', id: number, name: string, symbol: string, chain: string, img?: string | null, decimals: number, address?: string | null, isNative: boolean, isTestnet: boolean } }> };

export type SetTreasuryMintAutoSwapMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  mintId: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type SetTreasuryMintAutoSwapMutation = { __typename?: 'Mutation', setTreasuryMintAutoSwap: boolean };

export type SetTreasuryMintAutoPrefundMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  mintId: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type SetTreasuryMintAutoPrefundMutation = { __typename?: 'Mutation', setTreasuryMintAutoPrefund: boolean };

export type SetDepositAddressRotationEnabledMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type SetDepositAddressRotationEnabledMutation = { __typename?: 'Mutation', setDepositAddressRotationEnabled: boolean };

export type CheckoutConversionPoliciesQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type CheckoutConversionPoliciesQuery = { __typename?: 'Query', checkoutConversionPolicies: Array<{ __typename?: 'CheckoutConversionPolicy', autoSwapCheckoutProceeds: boolean, eligible: boolean, ineligibilityCode?: CheckoutConversionIneligibility | null, ineligibilityReason?: string | null, mint: { __typename?: 'Mint', id: number, name: string, symbol: string, chain: string, img?: string | null, decimals: number, address?: string | null, isNative: boolean, isTestnet: boolean } }> };

export type SetCheckoutAutoConversionMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  mintId: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type SetCheckoutAutoConversionMutation = { __typename?: 'Mutation', setCheckoutAutoConversion: boolean };

export const UserFragmentDoc = gql`
    fragment User on User {
  userId
  username
  email
  has2fa
  organizations {
    id
    name
  }
  receiveNotifications
}
    `;
export const UserWithRecoveryCodesFragmentDoc = gql`
    fragment UserWithRecoveryCodes on SetupTwoFactorAuthResponse {
  userId
  username
  email
  has2fa
  receiveNotifications
  recoveryCodes
}
    `;
export const MintFragmentDoc = gql`
    fragment Mint on Mint {
  id
  name
  chain
  img
  isNative
  isTestnet
  symbol
  decimals
  address
  usdPrice
}
    `;
export const AssetFragmentDoc = gql`
    fragment Asset on Asset {
  unconfirmedBalance
  balance
  usdBalance
  mint {
    ...Mint
  }
}
    ${MintFragmentDoc}`;
export const WithdrawalSwapFieldsFragmentDoc = gql`
    fragment WithdrawalSwapFields on WithdrawalSwapInfo {
  destinationAssetId
  destinationSymbol
  destinationChain
  destinationDecimals
  recipientAddress
  quotedAmountOut
  minAmountOut
  actualAmountOut
  destinationTxHash
  maxSlippageBps
  status
}
    `;
export const CustomerSwapSummaryFieldsFragmentDoc = gql`
    fragment CustomerSwapSummaryFields on CustomerSwapSummary {
  swapId
  status
  fromMint {
    id
    symbol
    chain
  }
  toMint {
    id
    symbol
    chain
  }
  amountIn
  estimatedAmountOut
  amountOut
  originTxHash
  destinationTxHash
  createdAt
}
    `;
export const PlayerBalancesFieldsFragmentDoc = gql`
    fragment PlayerBalancesFields on PlayerBalances {
  tokens {
    mintId
    symbol
    chain
    amount
    usdValue
    isTestnet
  }
  totalUsd
  fetchedAt
  status
  lastError
  isStale
}
    `;
export const ProductFragmentDoc = gql`
    fragment Product on Product {
  id
  organizationId
  name
  description
  imageUrl
  priceUsd
  sku
  acceptedNetworksTokens {
    chain
    token
  }
  status
  metadata
  createdAt
  updatedAt
}
    `;
export const CheckoutDepositAddressFragmentDoc = gql`
    fragment CheckoutDepositAddress on CheckoutDepositAddress {
  id
  sessionId
  checkoutId
  organizationId
  chain
  address
  derivationPath
  createdAt
}
    `;
export const CheckoutSessionSwapFieldsFragmentDoc = gql`
    fragment CheckoutSessionSwapFields on CheckoutSessionSwap {
  intentId
  status
  originAssetId
  originBlockchain
  originSymbol
  amountIn
  amountInUsd
  minAmountOut
  quotedAmountOut
  actualAmountOut
  slippageToleranceBps
  timeEstimateSeconds
  originTxHashes
  destinationTxHashes
  failureReason
  createdAt
}
    `;
export const CheckoutSessionSummaryFragmentDoc = gql`
    fragment CheckoutSessionSummary on CheckoutSessionSummary {
  id
  checkoutId
  status
  depositAddress
  depositAddressPath
  mintId
  mintSymbol
  mintChain
  rateLocked
  amountRequired
  amountReceived
  amountSent {
    amountSentCrypto
    amountSentUsd
    amountRequiredCrypto
    amountRequiredUsd
    shortfallCrypto
    shortfallUsd
    paymentIndicator
    isTestnet
  }
  swap {
    ...CheckoutSessionSwapFields
  }
  expiresAt
  createdAt
  updatedAt
}
    ${CheckoutSessionSwapFieldsFragmentDoc}`;
export const CheckoutSummaryFragmentDoc = gql`
    fragment CheckoutSummary on CheckoutSummary {
  id
  organizationId
  status
  priceUsdSnapshot
  productName
  hostedUrl
  expiresAt
  createdAt
  updatedAt
  sessions {
    ...CheckoutSessionSummary
  }
}
    ${CheckoutSessionSummaryFragmentDoc}`;
export const ValiantSwapFieldsFragmentDoc = gql`
    fragment ValiantSwapFields on ValiantSwap {
  id
  fromMint
  toMint
  amount
  earmarkedAmount
  toAmountHuman
  whitelistedAddressId
  whitelistedAddress
  whitelistedChain
  depositTxid
  depositRef
  swapId
  txHashes
  depositStage
  swapStage
  overallStatus
  failureReason
  createdAt
  updatedAt
}
    `;
export const NearIntentFieldsFragmentDoc = gql`
    fragment NearIntentFields on NearIntent {
  id
  status
  originAssetId
  originBlockchain
  originSymbol
  recipientAddress
  refundTo
  depositAddress
  depositMemo
  amountIn
  minAmountOut
  slippageToleranceBps
  quotedAmountOut
  actualAmountOut
  timeEstimateSeconds
  amountInUsd
  deadline
  failureReason
  originTxHashes
  destinationTxHashes
  customerTransactionId
  createdAt
}
    `;
export const CustomerSwapFieldsFragmentDoc = gql`
    fragment CustomerSwapFields on CustomerSwap {
  id
  status
  customerExternalId
  fromMint {
    ...Mint
  }
  toMint {
    ...Mint
  }
  amountIn
  estimatedAmountOut
  minAmountOut
  amountOut
  failureReason
  originTxHash
  destinationTxHash
  refundTxHash
  nearIntentId
  prefundNearIntentId
  intentStatus
  intentDeadline
  createdAt
  completedAt
}
    ${MintFragmentDoc}`;
export const BatchPayoutActorFieldsFragmentDoc = gql`
    fragment BatchPayoutActorFields on BatchPayoutActor {
  userId
  username
  email
}
    `;
export const BatchPayoutRecipientFieldsFragmentDoc = gql`
    fragment BatchPayoutRecipientFields on BatchPayoutRecipient {
  id
  address
  amount
  reference
  name
  status
  txHash
  error
  transactionReference
  splitTxid
  splitVout
  splitConfirmed
  payoutConfirmedAt
}
    `;
export const BatchPayoutFieldsFragmentDoc = gql`
    fragment BatchPayoutFields on BatchPayout {
  id
  organizationId
  chain
  mintId
  mode
  status
  phase
  totalAmount
  recipientCount
  label
  idempotencyKey
  createdBy
  initiatedBy {
    ...BatchPayoutActorFields
  }
  createdAt
  updatedAt
  recipients {
    ...BatchPayoutRecipientFields
  }
}
    ${BatchPayoutActorFieldsFragmentDoc}
${BatchPayoutRecipientFieldsFragmentDoc}`;
export const InvoiceSummaryFragmentDoc = gql`
    fragment InvoiceSummary on Invoice {
  id
  number
  status
  amountUsd
  amountPaidUsd
  dueDate
  createdAt
  hostedUrl
  terminalCode
  externalReference
  externalSource
}
    `;
export const InvoiceLineItemFragmentDoc = gql`
    fragment InvoiceLineItem on InvoiceLineItem {
  id
  productId
  quantity
  unitPriceUsdSnapshot
  lineTotalUsdSnapshot
  productSnapshot
  sortOrder
}
    `;
export const InvoiceSessionSummaryFragmentDoc = gql`
    fragment InvoiceSessionSummary on InvoiceSessionSummary {
  id
  status
  mintSymbol
  mintChain
  rateLocked
  amountRequired
  amountReceived
  amountSent {
    amountSentCrypto
    amountSentUsd
    amountRequiredCrypto
    amountRequiredUsd
    shortfallCrypto
    shortfallUsd
    paymentIndicator
    isTestnet
  }
  expiresAt
  createdAt
}
    `;
export const InvoiceDetailFragmentDoc = gql`
    fragment InvoiceDetail on Invoice {
  ...InvoiceSummary
  organizationId
  updatedAt
  voidedAt
  fundsReceivedOnVoid
  checkoutId
  lineItems {
    ...InvoiceLineItem
  }
  sessions {
    ...InvoiceSessionSummary
  }
}
    ${InvoiceSummaryFragmentDoc}
${InvoiceLineItemFragmentDoc}
${InvoiceSessionSummaryFragmentDoc}`;
export const PlatformBillKindUsageFragmentDoc = gql`
    fragment PlatformBillKindUsage on PlatformBillKindUsage {
  kind
  count
  feeBps
  totalFeeAmount
}
    `;
export const PlatformBillLineItemFragmentDoc = gql`
    fragment PlatformBillLineItem on PlatformBillLineItem {
  id
  kind
  sourceTxRef
  grossAmount
  feeBps
  feeAmount
}
    `;
export const PlatformBillFragmentDoc = gql`
    fragment PlatformBill on PlatformBill {
  id
  organizationId
  yearMonth
  mintId
  mainWalletId
  mainWalletPurpose
  status
  paidAt
  dueAmount
  usdDueAmount
  isClosed
  unpricedLineCount
  kindUsage {
    ...PlatformBillKindUsage
  }
  lineItems {
    ...PlatformBillLineItem
  }
}
    ${PlatformBillKindUsageFragmentDoc}
${PlatformBillLineItemFragmentDoc}`;
export const PlatformBillUsdBreakdownRowFragmentDoc = gql`
    fragment PlatformBillUsdBreakdownRow on PlatformBillUsdBreakdownRow {
  mintId
  mainWalletPurpose
  period
  cryptoFeeTotal
  snapshotUsd
  unpricedLineCount
}
    `;
export const ReportingTransactionFieldsFragmentDoc = gql`
    fragment ReportingTransactionFields on ReportingTransaction {
  confirmedAt
  metric
  typeLabel
  tokenSymbol
  chain
  tokenAmount
  usdValue
  usdPrice
  usdValueMissing
  status
  txHash
  fromAddress
  toAddress
  counterparty
  reference
  name
  batchLabel
  explorerUrl
}
    `;
export const ReportingMonthlySummaryFieldsFragmentDoc = gql`
    fragment ReportingMonthlySummaryFields on ReportingMonthlySummary {
  yearMonth
  depositsUsd
  depositsCount
  withdrawalsUsd
  withdrawalsCount
  paymentsUsd
  paymentsCount
  refundsUsd
  refundsCount
  payoutsUsd
  payoutsCount
  fundingUsd
  fundingCount
}
    `;
export const SwapsReportingMonthlySummaryFieldsFragmentDoc = gql`
    fragment SwapsReportingMonthlySummaryFields on SwapsReportingMonthlySummary {
  yearMonth
  volumeUsd
  swapsCount
}
    `;
export const SwapsReportingSwapFieldsFragmentDoc = gql`
    fragment SwapsReportingSwapFields on SwapsReportingSwap {
  confirmedAt
  fromTokenSymbol
  fromAmount
  toTokenSymbol
  toAmountHuman
  rate
  fee
  feeUsd
  feeBps
  volumeUsd
  volumeUsdMissing
  status
  txHashes
  explorerUrls
  depositTxid
  depositExplorerUrl
}
    `;
export const ReportingCountUsdFieldsFragmentDoc = gql`
    fragment ReportingCountUsdFields on ReportingCountUsd {
  usdValue
  count
}
    `;
export const ReportingMetricStableWindowsFieldsFragmentDoc = gql`
    fragment ReportingMetricStableWindowsFields on ReportingMetricStableWindows {
  yesterday {
    ...ReportingCountUsdFields
  }
  priorSixDays {
    ...ReportingCountUsdFields
  }
  monthToYesterday {
    ...ReportingCountUsdFields
  }
  lifetimeToYesterday {
    ...ReportingCountUsdFields
  }
}
    ${ReportingCountUsdFieldsFragmentDoc}`;
export const ReportingSwapWindowBucketFieldsFragmentDoc = gql`
    fragment ReportingSwapWindowBucketFields on ReportingSwapWindowBucket {
  volumeUsd
  swapsCount
}
    `;
export const GetUserDocument = gql`
    query getUser {
  getUser {
    ...User
  }
}
    ${UserFragmentDoc}`;

export function useGetUserQuery(options?: Omit<Urql.UseQueryArgs<GetUserQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserQuery, GetUserQueryVariables>({ query: GetUserDocument, ...options });
};
export const GetMintsDocument = gql`
    query getMints($organizationId: String!, $surface: MintSurface!) {
  getMints(organizationId: $organizationId, surface: $surface) {
    ...Mint
  }
}
    ${MintFragmentDoc}`;

export function useGetMintsQuery(options: Omit<Urql.UseQueryArgs<GetMintsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMintsQuery, GetMintsQueryVariables>({ query: GetMintsDocument, ...options });
};
export const GetWithdrawalSwapSourceMintsDocument = gql`
    query getWithdrawalSwapSourceMints($organizationId: String!, $surface: MintSurface!) {
  getMints(organizationId: $organizationId, surface: $surface) {
    id
    withdrawalSwapSource
  }
}
    `;

export function useGetWithdrawalSwapSourceMintsQuery(options: Omit<Urql.UseQueryArgs<GetWithdrawalSwapSourceMintsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetWithdrawalSwapSourceMintsQuery, GetWithdrawalSwapSourceMintsQueryVariables>({ query: GetWithdrawalSwapSourceMintsDocument, ...options });
};
export const WithdrawalSwapDestinationsDocument = gql`
    query withdrawalSwapDestinations($organizationId: String!, $chain: Chain!) {
  withdrawalSwapDestinations(organizationId: $organizationId, chain: $chain) {
    assetId
    symbol
    decimals
    chain
    cheddarMintId
  }
}
    `;

export function useWithdrawalSwapDestinationsQuery(options: Omit<Urql.UseQueryArgs<WithdrawalSwapDestinationsQueryVariables>, 'query'>) {
  return Urql.useQuery<WithdrawalSwapDestinationsQuery, WithdrawalSwapDestinationsQueryVariables>({ query: WithdrawalSwapDestinationsDocument, ...options });
};
export const GetWalletsDocument = gql`
    query getWallets($organizationId: String!, $purpose: MainWalletPurpose!) {
  getWallets(organizationId: $organizationId, purpose: $purpose) {
    address
    chain
    isTestnet
    totalBalanceUSD
    assets {
      ...Asset
    }
  }
}
    ${AssetFragmentDoc}`;

export function useGetWalletsQuery(options: Omit<Urql.UseQueryArgs<GetWalletsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetWalletsQuery, GetWalletsQueryVariables>({ query: GetWalletsDocument, ...options });
};
export const GetGasWalletsDocument = gql`
    query getGasWallets($organizationId: String!) {
  getGasWallets(organizationId: $organizationId) {
    id
    address
    chain
    uiBalance
    pendingUiBalance
    usdBalance
    mint {
      ...Mint
    }
    topup {
      autoTopupEnabled
      trigger
      target
      effectiveBalance
      sourceReserve
      paused
      pausedAt
      inFlightIntentId
      lastResult
      lastResultAt
    }
  }
}
    ${MintFragmentDoc}`;

export function useGetGasWalletsQuery(options: Omit<Urql.UseQueryArgs<GetGasWalletsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetGasWalletsQuery, GetGasWalletsQueryVariables>({ query: GetGasWalletsDocument, ...options });
};
export const GasTopupQuoteDocument = gql`
    query gasTopupQuote($organizationId: String!, $chain: Chain!) {
  gasTopupQuote(organizationId: $organizationId, chain: $chain) {
    eligible
    reason
    detail
    amountInSol
    amountOut
    amountInUsd
  }
}
    `;

export function useGasTopupQuoteQuery(options: Omit<Urql.UseQueryArgs<GasTopupQuoteQueryVariables>, 'query'>) {
  return Urql.useQuery<GasTopupQuoteQuery, GasTopupQuoteQueryVariables>({ query: GasTopupQuoteDocument, ...options });
};
export const SetGasTopupAutoEnabledDocument = gql`
    mutation setGasTopupAutoEnabled($organizationId: String!, $chain: Chain!, $enabled: Boolean!) {
  setGasTopupAutoEnabled(
    organizationId: $organizationId
    chain: $chain
    enabled: $enabled
  ) {
    id
    topup {
      autoTopupEnabled
      paused
    }
  }
}
    `;

export function useSetGasTopupAutoEnabledMutation() {
  return Urql.useMutation<SetGasTopupAutoEnabledMutation, SetGasTopupAutoEnabledMutationVariables>(SetGasTopupAutoEnabledDocument);
};
export const RequestGasTopupDocument = gql`
    mutation requestGasTopup($organizationId: String!, $chain: Chain!) {
  requestGasTopup(organizationId: $organizationId, chain: $chain) {
    status
    reason
    detail
    nearIntentId
  }
}
    `;

export function useRequestGasTopupMutation() {
  return Urql.useMutation<RequestGasTopupMutation, RequestGasTopupMutationVariables>(RequestGasTopupDocument);
};
export const GetEthGasOwedDocument = gql`
    query getEthGasOwed($organizationId: String!) {
  getEthGasOwed(organizationId: $organizationId)
}
    `;

export function useGetEthGasOwedQuery(options: Omit<Urql.UseQueryArgs<GetEthGasOwedQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEthGasOwedQuery, GetEthGasOwedQueryVariables>({ query: GetEthGasOwedDocument, ...options });
};
export const GetOrganizationDocument = gql`
    query getOrganization($organizationId: String!) {
  getOrganization(organizationId: $organizationId) {
    id
    name
    webhookAppId
    whitelist {
      id
      chain
      address
    }
    internalTransferThreshold {
      id
      amountInUSD
      chain
    }
    riskScoreSeverityThreshold
    riskScoreUsdThreshold
    valiantEnabled
    nearIntentsEnabled
    depositAddressRotationEnabled
    customerSwapsEnabled
    batchPayoutsEnabled
    canRollApiKey
    playerBalanceWebhook {
      url
      hasSecret
      isConfigured
    }
    canViewBilling
  }
}
    `;

export function useGetOrganizationQuery(options: Omit<Urql.UseQueryArgs<GetOrganizationQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>({ query: GetOrganizationDocument, ...options });
};
export const GetBatchPayoutWalletDocument = gql`
    query getBatchPayoutWallet($organizationId: String!, $chain: Chain!, $isTestnet: Boolean = false) {
  getBatchPayoutWallet(
    organizationId: $organizationId
    chain: $chain
    isTestnet: $isTestnet
  ) {
    chain
    address
    isTestnet
    mainWalletId
  }
}
    `;

export function useGetBatchPayoutWalletQuery(options: Omit<Urql.UseQueryArgs<GetBatchPayoutWalletQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBatchPayoutWalletQuery, GetBatchPayoutWalletQueryVariables>({ query: GetBatchPayoutWalletDocument, ...options });
};
export const GetBatchPayoutBalancesDocument = gql`
    query getBatchPayoutBalances($organizationId: String!, $chain: Chain!, $isTestnet: Boolean = false) {
  getBatchPayoutBalances(
    organizationId: $organizationId
    chain: $chain
    isTestnet: $isTestnet
  ) {
    total
    reserved
    available
    mint {
      id
      name
      chain
      img
      isNative
      isTestnet
      symbol
      decimals
      address
      usdPrice
    }
  }
}
    `;

export function useGetBatchPayoutBalancesQuery(options: Omit<Urql.UseQueryArgs<GetBatchPayoutBalancesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBatchPayoutBalancesQuery, GetBatchPayoutBalancesQueryVariables>({ query: GetBatchPayoutBalancesDocument, ...options });
};
export const GetUsersOfOrganizationDocument = gql`
    query getUsersOfOrganization($organizationId: String!, $cursor: String, $limit: Int!) {
  getUsersOfOrganization(
    organizationId: $organizationId
    cursor: $cursor
    limit: $limit
  ) {
    users {
      ...User
    }
    hasMore
    cursor
    totalCount
  }
}
    ${UserFragmentDoc}`;

export function useGetUsersOfOrganizationQuery(options: Omit<Urql.UseQueryArgs<GetUsersOfOrganizationQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUsersOfOrganizationQuery, GetUsersOfOrganizationQueryVariables>({ query: GetUsersOfOrganizationDocument, ...options });
};
export const GetWithdrawThresholdDocument = gql`
    query getWithdrawThreshold($organizationId: String!) {
  getWithdrawThreshold(organizationId: $organizationId) {
    customers
    main
  }
}
    `;

export function useGetWithdrawThresholdQuery(options: Omit<Urql.UseQueryArgs<GetWithdrawThresholdQueryVariables>, 'query'>) {
  return Urql.useQuery<GetWithdrawThresholdQuery, GetWithdrawThresholdQueryVariables>({ query: GetWithdrawThresholdDocument, ...options });
};
export const GetTransactionsToApproveDocument = gql`
    query getTransactionsToApprove($organizationId: String!, $purpose: MainWalletPurpose!, $searchQuery: String, $page: Int!, $limit: Int!) {
  getTransactionsToApprove(
    organizationId: $organizationId
    purpose: $purpose
    searchQuery: $searchQuery
    page: $page
    limit: $limit
  ) {
    transactions {
      id
      mainWalletId
      txHash
      amount
      uiAmount
      usdAmount
      fromAddress
      toAddress
      mint {
        ...Mint
      }
      transactionReference
      createdAt
      confirmedAt
      type
      status
      customerId
      customerExternalEmail
      prefundIntent {
        ...NearIntentFields
      }
    }
    totalCount
  }
}
    ${MintFragmentDoc}
${NearIntentFieldsFragmentDoc}`;

export function useGetTransactionsToApproveQuery(options: Omit<Urql.UseQueryArgs<GetTransactionsToApproveQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTransactionsToApproveQuery, GetTransactionsToApproveQueryVariables>({ query: GetTransactionsToApproveDocument, ...options });
};
export const GetFlaggedDepositsDocument = gql`
    query getFlaggedDeposits($organizationId: String!, $searchQuery: String, $page: Int!, $limit: Int!) {
  getFlaggedDeposits(
    organizationId: $organizationId
    searchQuery: $searchQuery
    page: $page
    limit: $limit
  ) {
    totalCount
    deposits {
      id
      customerId
      customerExternalEmail
      txHash
      amount
      uiAmount
      usdAmount
      fromAddress
      toAddress
      mint {
        ...Mint
      }
      createdAt
      confirmedAt
      status
      canUnflag
      flagReason {
        score
        severity
        entityType
        entityName
      }
      failedAttempts {
        id
        action
        destinationAddress
        reason
        failedAt
      }
    }
  }
}
    ${MintFragmentDoc}`;

export function useGetFlaggedDepositsQuery(options: Omit<Urql.UseQueryArgs<GetFlaggedDepositsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetFlaggedDepositsQuery, GetFlaggedDepositsQueryVariables>({ query: GetFlaggedDepositsDocument, ...options });
};
export const GetFlaggedDepositResolutionsDocument = gql`
    query getFlaggedDepositResolutions($organizationId: String!, $page: Int!, $limit: Int!) {
  getFlaggedDepositResolutions(
    organizationId: $organizationId
    page: $page
    limit: $limit
  ) {
    totalCount
    resolutions {
      id
      customerId
      customerExternalId
      customerExternalEmail
      amount
      uiAmount
      usdAmount
      mint {
        ...Mint
      }
      fromAddress
      depositTxHash
      createdAt
      flaggedAt
      flagReason {
        score
        severity
        entityType
        entityName
      }
      resolution
      resolvedAt
      resolutionReason
      actor {
        kind
        id
        username
      }
      destinationAddress
      legTxHash
      legStatus
    }
  }
}
    ${MintFragmentDoc}`;

export function useGetFlaggedDepositResolutionsQuery(options: Omit<Urql.UseQueryArgs<GetFlaggedDepositResolutionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetFlaggedDepositResolutionsQuery, GetFlaggedDepositResolutionsQueryVariables>({ query: GetFlaggedDepositResolutionsDocument, ...options });
};
export const GetTransactionsToApproveCountDocument = gql`
    query getTransactionsToApproveCount($organizationId: String!, $purpose: MainWalletPurpose!) {
  getTransactionsToApprove(
    organizationId: $organizationId
    purpose: $purpose
    page: 1
    limit: 1
  ) {
    totalCount
  }
}
    `;

export function useGetTransactionsToApproveCountQuery(options: Omit<Urql.UseQueryArgs<GetTransactionsToApproveCountQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTransactionsToApproveCountQuery, GetTransactionsToApproveCountQueryVariables>({ query: GetTransactionsToApproveCountDocument, ...options });
};
export const GetFlaggedDepositsCountDocument = gql`
    query getFlaggedDepositsCount($organizationId: String!) {
  getFlaggedDeposits(organizationId: $organizationId, page: 1, limit: 1) {
    totalCount
  }
}
    `;

export function useGetFlaggedDepositsCountQuery(options: Omit<Urql.UseQueryArgs<GetFlaggedDepositsCountQueryVariables>, 'query'>) {
  return Urql.useQuery<GetFlaggedDepositsCountQuery, GetFlaggedDepositsCountQueryVariables>({ query: GetFlaggedDepositsCountDocument, ...options });
};
export const GetWhitelistDocument = gql`
    query getWhitelist($organizationId: String!) {
  getWhitelist(organizationId: $organizationId) {
    id
    chain
    address
  }
}
    `;

export function useGetWhitelistQuery(options: Omit<Urql.UseQueryArgs<GetWhitelistQueryVariables>, 'query'>) {
  return Urql.useQuery<GetWhitelistQuery, GetWhitelistQueryVariables>({ query: GetWhitelistDocument, ...options });
};
export const GetWebhookIFrameUrlDocument = gql`
    query getWebhookIFrameUrl($organizationId: String!) {
  getWebhookIFrameUrl(organizationId: $organizationId)
}
    `;

export function useGetWebhookIFrameUrlQuery(options: Omit<Urql.UseQueryArgs<GetWebhookIFrameUrlQueryVariables>, 'query'>) {
  return Urql.useQuery<GetWebhookIFrameUrlQuery, GetWebhookIFrameUrlQueryVariables>({ query: GetWebhookIFrameUrlDocument, ...options });
};
export const GetTestWebhookEventTypesDocument = gql`
    query getTestWebhookEventTypes {
  getTestWebhookEventTypes
}
    `;

export function useGetTestWebhookEventTypesQuery(options?: Omit<Urql.UseQueryArgs<GetTestWebhookEventTypesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTestWebhookEventTypesQuery, GetTestWebhookEventTypesQueryVariables>({ query: GetTestWebhookEventTypesDocument, ...options });
};
export const SendTestWebhookEventDocument = gql`
    mutation sendTestWebhookEvent($organizationId: String!, $eventType: String!) {
  sendTestWebhookEvent(organizationId: $organizationId, eventType: $eventType)
}
    `;

export function useSendTestWebhookEventMutation() {
  return Urql.useMutation<SendTestWebhookEventMutation, SendTestWebhookEventMutationVariables>(SendTestWebhookEventDocument);
};
export const GetCustomersDocument = gql`
    query getCustomers($organizationId: String!, $searchQuery: String, $page: Int!, $limit: Int!) {
  getCustomers(
    organizationId: $organizationId
    searchQuery: $searchQuery
    page: $page
    limit: $limit
  ) {
    total
    customers {
      id
      createdAt
      isActive
      organizationId
      organizationExternalId
      organizationExternalEmail
    }
  }
}
    `;

export function useGetCustomersQuery(options: Omit<Urql.UseQueryArgs<GetCustomersQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCustomersQuery, GetCustomersQueryVariables>({ query: GetCustomersDocument, ...options });
};
export const GetFundedCustomersDocument = gql`
    query getFundedCustomers($organizationId: String!, $searchQuery: String, $page: Int!, $limit: Int!) {
  getFundedCustomers(
    organizationId: $organizationId
    searchQuery: $searchQuery
    page: $page
    limit: $limit
  ) {
    total
    customers {
      id
      organizationExternalEmail
      createdAt
      depositAmountUsd
      withdrawalAmountUsd
    }
  }
}
    `;

export function useGetFundedCustomersQuery(options: Omit<Urql.UseQueryArgs<GetFundedCustomersQueryVariables>, 'query'>) {
  return Urql.useQuery<GetFundedCustomersQuery, GetFundedCustomersQueryVariables>({ query: GetFundedCustomersDocument, ...options });
};
export const GetCustomerDocument = gql`
    query getCustomer($customerId: String!) {
  getCustomer(customerId: $customerId) {
    id
    createdAt
    isActive
    organizationId
    organizationExternalId
    organizationExternalEmail
    requireDepositApproval
  }
}
    `;

export function useGetCustomerQuery(options: Omit<Urql.UseQueryArgs<GetCustomerQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCustomerQuery, GetCustomerQueryVariables>({ query: GetCustomerDocument, ...options });
};
export const SetCustomerRequireDepositApprovalDocument = gql`
    mutation setCustomerRequireDepositApproval($customerId: String!, $enabled: Boolean!) {
  setCustomerRequireDepositApproval(customerId: $customerId, enabled: $enabled)
}
    `;

export function useSetCustomerRequireDepositApprovalMutation() {
  return Urql.useMutation<SetCustomerRequireDepositApprovalMutation, SetCustomerRequireDepositApprovalMutationVariables>(SetCustomerRequireDepositApprovalDocument);
};
export const GetCustomerLifetimeTotalsDocument = gql`
    query getCustomerLifetimeTotals($customerId: String!) {
  getCustomerLifetimeTotals(customerId: $customerId) {
    mint {
      ...Mint
    }
    depositAmount
    withdrawalAmount
    depositUsd
    withdrawalUsd
  }
}
    ${MintFragmentDoc}`;

export function useGetCustomerLifetimeTotalsQuery(options: Omit<Urql.UseQueryArgs<GetCustomerLifetimeTotalsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCustomerLifetimeTotalsQuery, GetCustomerLifetimeTotalsQueryVariables>({ query: GetCustomerLifetimeTotalsDocument, ...options });
};
export const GetCustomerWalletsDocument = gql`
    query getCustomerWallets($customerId: String!) {
  getCustomerWallets(customerId: $customerId) {
    address
    chain
    totalBalanceUSD
    assets {
      ...Asset
    }
    addresses {
      chain
      address
      active
      retiredAt
    }
  }
}
    ${AssetFragmentDoc}`;

export function useGetCustomerWalletsQuery(options: Omit<Urql.UseQueryArgs<GetCustomerWalletsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCustomerWalletsQuery, GetCustomerWalletsQueryVariables>({ query: GetCustomerWalletsDocument, ...options });
};
export const GetCustomerTransactionsDocument = gql`
    query getCustomerTransactions($organizationId: String!, $customerId: String!, $page: Int!, $limit: Int!, $hideSmall: Boolean!, $smallUsdThreshold: Float) {
  getCustomerTransactions(
    organizationId: $organizationId
    customerId: $customerId
    page: $page
    limit: $limit
    hideSmall: $hideSmall
    smallUsdThreshold: $smallUsdThreshold
  ) {
    transactions {
      id
      customerId
      txHash
      amount
      uiAmount
      usdAmount
      failedReason
      fromAddress
      toAddress
      mint {
        ...Mint
      }
      transactionReference
      createdAt
      confirmedAt
      type
      status
    }
    totalCount
  }
}
    ${MintFragmentDoc}`;

export function useGetCustomerTransactionsQuery(options: Omit<Urql.UseQueryArgs<GetCustomerTransactionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCustomerTransactionsQuery, GetCustomerTransactionsQueryVariables>({ query: GetCustomerTransactionsDocument, ...options });
};
export const GetCustomerLedgerDocument = gql`
    query getCustomerLedger($organizationId: String!, $customerId: String!, $page: Int!, $limit: Int!, $kind: CustomerLedgerKind!, $hideSmall: Boolean!, $smallUsdThreshold: Float) {
  getCustomerLedger(
    organizationId: $organizationId
    customerId: $customerId
    page: $page
    limit: $limit
    kind: $kind
    hideSmall: $hideSmall
    smallUsdThreshold: $smallUsdThreshold
  ) {
    transactions {
      id
      txHash
      amount
      uiAmount
      usdAmount
      failedReason
      fromAddress
      toAddress
      mint {
        ...Mint
      }
      transactionReference
      createdAt
      confirmedAt
      type
      status
      kind
      canUnflag
      customerSwap {
        ...CustomerSwapSummaryFields
      }
    }
    totalCount
  }
}
    ${MintFragmentDoc}
${CustomerSwapSummaryFieldsFragmentDoc}`;

export function useGetCustomerLedgerQuery(options: Omit<Urql.UseQueryArgs<GetCustomerLedgerQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCustomerLedgerQuery, GetCustomerLedgerQueryVariables>({ query: GetCustomerLedgerDocument, ...options });
};
export const GetCustomerWithdrawalsDocument = gql`
    query getCustomerWithdrawals($organizationId: String!, $customerId: String!, $page: Int!, $limit: Int!, $hideSmall: Boolean!, $smallUsdThreshold: Float) {
  getCustomerWithdrawals(
    organizationId: $organizationId
    customerId: $customerId
    page: $page
    limit: $limit
    hideSmall: $hideSmall
    smallUsdThreshold: $smallUsdThreshold
  ) {
    withdrawals {
      id
      mainWalletId
      txHash
      amount
      uiAmount
      usdAmount
      fromAddress
      toAddress
      mint {
        ...Mint
      }
      transactionReference
      createdAt
      confirmedAt
      type
      status
    }
    totalCount
  }
}
    ${MintFragmentDoc}`;

export function useGetCustomerWithdrawalsQuery(options: Omit<Urql.UseQueryArgs<GetCustomerWithdrawalsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCustomerWithdrawalsQuery, GetCustomerWithdrawalsQueryVariables>({ query: GetCustomerWithdrawalsDocument, ...options });
};
export const GetMainWalletTransactionsDocument = gql`
    query getMainWalletTransactions($organizationId: String!, $purpose: MainWalletPurpose!, $filters: InputFiltersTransaction, $page: Int!, $limit: Int!, $hideSmall: Boolean!, $smallUsdThreshold: Float) {
  getMainWalletTransactions(
    organizationId: $organizationId
    purpose: $purpose
    filters: $filters
    page: $page
    limit: $limit
    hideSmall: $hideSmall
    smallUsdThreshold: $smallUsdThreshold
  ) {
    transactions {
      id
      mainWalletId
      txHash
      amount
      uiAmount
      usdAmount
      failedReason
      fromAddress
      toAddress
      mint {
        ...Mint
      }
      transactionReference
      createdAt
      confirmedAt
      type
      status
      customerExternalEmail
      customerId
      settlementSource
      invoiceId
      invoiceNumber
      initiatedBy {
        ...BatchPayoutActorFields
      }
      approvedBy {
        ...BatchPayoutActorFields
      }
      approvedAt
      rejectedBy {
        ...BatchPayoutActorFields
      }
      rejectedAt
      nearIntent {
        ...NearIntentFields
      }
      swapOriginMint {
        ...Mint
      }
      prefundIntent {
        ...NearIntentFields
      }
      customerSwap {
        ...CustomerSwapSummaryFields
      }
      swap {
        ...WithdrawalSwapFields
      }
    }
    totalCount
  }
}
    ${MintFragmentDoc}
${BatchPayoutActorFieldsFragmentDoc}
${NearIntentFieldsFragmentDoc}
${CustomerSwapSummaryFieldsFragmentDoc}
${WithdrawalSwapFieldsFragmentDoc}`;

export function useGetMainWalletTransactionsQuery(options: Omit<Urql.UseQueryArgs<GetMainWalletTransactionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMainWalletTransactionsQuery, GetMainWalletTransactionsQueryVariables>({ query: GetMainWalletTransactionsDocument, ...options });
};
export const GetMainWalletBalancesByPurposeDocument = gql`
    query getMainWalletBalancesByPurpose($organizationId: String!) {
  getMainWalletBalancesByPurpose(organizationId: $organizationId) {
    purpose
    totalBalanceUSD
  }
}
    `;

export function useGetMainWalletBalancesByPurposeQuery(options: Omit<Urql.UseQueryArgs<GetMainWalletBalancesByPurposeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMainWalletBalancesByPurposeQuery, GetMainWalletBalancesByPurposeQueryVariables>({ query: GetMainWalletBalancesByPurposeDocument, ...options });
};
export const GetGasTransactionsDocument = gql`
    query getGasTransactions($organizationId: String!, $page: Int!, $limit: Int!, $hideSmall: Boolean!, $smallUsdThreshold: Float, $filters: InputFiltersGasTransaction) {
  getGasTransactions(
    organizationId: $organizationId
    page: $page
    limit: $limit
    hideSmall: $hideSmall
    smallUsdThreshold: $smallUsdThreshold
    filters: $filters
  ) {
    transactions {
      id
      gasWalletId
      txHash
      amount
      uiAmount
      usdAmount
      fromAddress
      toAddress
      mint {
        ...Mint
      }
      transactionReference
      createdAt
      confirmedAt
      type
      status
    }
    totalCount
  }
}
    ${MintFragmentDoc}`;

export function useGetGasTransactionsQuery(options: Omit<Urql.UseQueryArgs<GetGasTransactionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetGasTransactionsQuery, GetGasTransactionsQueryVariables>({ query: GetGasTransactionsDocument, ...options });
};
export const GetWalletsMainDocument = gql`
    query getWalletsMain($organizationId: String!, $searchQuery: String, $purpose: MainWalletPurpose!) {
  getWalletsMain(
    organizationId: $organizationId
    searchQuery: $searchQuery
    purpose: $purpose
  ) {
    chain
    address
    isTestnet
  }
}
    `;

export function useGetWalletsMainQuery(options: Omit<Urql.UseQueryArgs<GetWalletsMainQueryVariables>, 'query'>) {
  return Urql.useQuery<GetWalletsMainQuery, GetWalletsMainQueryVariables>({ query: GetWalletsMainDocument, ...options });
};
export const GetWalletsCustomersDocument = gql`
    query getWalletsCustomers($organizationId: String!, $page: Int!, $limit: Int!, $searchQuery: String) {
  getWalletsCustomers(
    organizationId: $organizationId
    page: $page
    limit: $limit
    searchQuery: $searchQuery
  ) {
    total
    customersWallets {
      customerId
      wallets {
        chain
        address
        active
        retiredAt
      }
    }
  }
}
    `;

export function useGetWalletsCustomersQuery(options: Omit<Urql.UseQueryArgs<GetWalletsCustomersQueryVariables>, 'query'>) {
  return Urql.useQuery<GetWalletsCustomersQuery, GetWalletsCustomersQueryVariables>({ query: GetWalletsCustomersDocument, ...options });
};
export const GetCustomersTransactionsDocument = gql`
    query getCustomersTransactions($organizationId: String!, $purpose: MainWalletPurpose!, $page: Int!, $limit: Int!, $filters: InputFiltersTransaction, $hideSmall: Boolean!, $smallUsdThreshold: Float) {
  getCustomersTransactions(
    organizationId: $organizationId
    purpose: $purpose
    page: $page
    limit: $limit
    filters: $filters
    hideSmall: $hideSmall
    smallUsdThreshold: $smallUsdThreshold
  ) {
    transactions {
      id
      customerId
      txHash
      amount
      uiAmount
      usdAmount
      failedReason
      fromAddress
      toAddress
      mint {
        ...Mint
      }
      transactionReference
      createdAt
      confirmedAt
      type
      status
      nearIntent {
        ...NearIntentFields
      }
      customerSwap {
        ...CustomerSwapSummaryFields
      }
    }
    totalCount
  }
}
    ${MintFragmentDoc}
${NearIntentFieldsFragmentDoc}
${CustomerSwapSummaryFieldsFragmentDoc}`;

export function useGetCustomersTransactionsQuery(options: Omit<Urql.UseQueryArgs<GetCustomersTransactionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCustomersTransactionsQuery, GetCustomersTransactionsQueryVariables>({ query: GetCustomersTransactionsDocument, ...options });
};
export const RollApiKeyDocument = gql`
    mutation rollApiKey($organizationId: String!) {
  rollApiKey(organizationId: $organizationId)
}
    `;

export function useRollApiKeyMutation() {
  return Urql.useMutation<RollApiKeyMutation, RollApiKeyMutationVariables>(RollApiKeyDocument);
};
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;

export function useLogoutMutation() {
  return Urql.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument);
};
export const UpdateUsernameDocument = gql`
    mutation updateUsername($username: String!) {
  updateUsername(username: $username) {
    ...User
  }
}
    ${UserFragmentDoc}`;

export function useUpdateUsernameMutation() {
  return Urql.useMutation<UpdateUsernameMutation, UpdateUsernameMutationVariables>(UpdateUsernameDocument);
};
export const UpdateEmailDocument = gql`
    mutation updateEmail($email: String!) {
  updateEmail(email: $email) {
    ...User
  }
}
    ${UserFragmentDoc}`;

export function useUpdateEmailMutation() {
  return Urql.useMutation<UpdateEmailMutation, UpdateEmailMutationVariables>(UpdateEmailDocument);
};
export const UpdatePasswordDocument = gql`
    mutation updatePassword($oldPassword: String!, $newPassword: String!) {
  updatePassword(oldPassword: $oldPassword, newPassword: $newPassword) {
    userId
    username
    email
  }
}
    `;

export function useUpdatePasswordMutation() {
  return Urql.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument);
};
export const ResetMyPasswordDocument = gql`
    mutation resetMyPassword {
  resetMyPassword {
    ...User
  }
}
    ${UserFragmentDoc}`;

export function useResetMyPasswordMutation() {
  return Urql.useMutation<ResetMyPasswordMutation, ResetMyPasswordMutationVariables>(ResetMyPasswordDocument);
};
export const RequestTwoFactorAuthDocument = gql`
    mutation requestTwoFactorAuth {
  requestTwoFactorAuth
}
    `;

export function useRequestTwoFactorAuthMutation() {
  return Urql.useMutation<RequestTwoFactorAuthMutation, RequestTwoFactorAuthMutationVariables>(RequestTwoFactorAuthDocument);
};
export const SetupTwoFactorAuthDocument = gql`
    mutation setupTwoFactorAuth($secret: String!) {
  setupTwoFactorAuth(secret: $secret) {
    ...UserWithRecoveryCodes
  }
}
    ${UserWithRecoveryCodesFragmentDoc}`;

export function useSetupTwoFactorAuthMutation() {
  return Urql.useMutation<SetupTwoFactorAuthMutation, SetupTwoFactorAuthMutationVariables>(SetupTwoFactorAuthDocument);
};
export const WithdrawDocument = gql`
    mutation withdraw($organizationId: String!, $amount: String!, $whitelistId: Int!, $mintId: Int!, $purpose: MainWalletPurpose!, $totpCode: String!, $destinationAssetId: String, $maxSlippageBps: Int) {
  withdraw(
    organizationId: $organizationId
    amount: $amount
    whitelistId: $whitelistId
    mintId: $mintId
    purpose: $purpose
    totpCode: $totpCode
    destinationAssetId: $destinationAssetId
    maxSlippageBps: $maxSlippageBps
  )
}
    `;

export function useWithdrawMutation() {
  return Urql.useMutation<WithdrawMutation, WithdrawMutationVariables>(WithdrawDocument);
};
export const WithdrawalSwapQuoteDocument = gql`
    query withdrawalSwapQuote($organizationId: String!, $purpose: MainWalletPurpose!, $mintId: Int!, $amount: String!, $destinationAssetId: String!, $whitelistId: Int!, $maxSlippageBps: Int) {
  withdrawalSwapQuote(
    organizationId: $organizationId
    purpose: $purpose
    mintId: $mintId
    amount: $amount
    destinationAssetId: $destinationAssetId
    whitelistId: $whitelistId
    maxSlippageBps: $maxSlippageBps
  ) {
    quotedAmountOut
    minAmountOut
    destinationAsset {
      assetId
      symbol
      decimals
      chain
    }
    withdrawalFee {
      bps
      amount
    }
    swapFee {
      bps
      amount
    }
    sourceUsd
    quotedOutUsd
    deadline
  }
}
    `;

export function useWithdrawalSwapQuoteQuery(options: Omit<Urql.UseQueryArgs<WithdrawalSwapQuoteQueryVariables>, 'query'>) {
  return Urql.useQuery<WithdrawalSwapQuoteQuery, WithdrawalSwapQuoteQueryVariables>({ query: WithdrawalSwapQuoteDocument, ...options });
};
export const UpdateMinimumThresholdDocument = gql`
    mutation updateMinimumThreshold($organizationId: String!, $amountInUSD: Float!, $chain: Chain!) {
  updateMinimumThreshold(
    organizationId: $organizationId
    amountInUSD: $amountInUSD
    chain: $chain
  )
}
    `;

export function useUpdateMinimumThresholdMutation() {
  return Urql.useMutation<UpdateMinimumThresholdMutation, UpdateMinimumThresholdMutationVariables>(UpdateMinimumThresholdDocument);
};
export const ApproveTransactionDocument = gql`
    mutation approveTransaction($transactionId: Int!) {
  approveTransaction(transactionId: $transactionId)
}
    `;

export function useApproveTransactionMutation() {
  return Urql.useMutation<ApproveTransactionMutation, ApproveTransactionMutationVariables>(ApproveTransactionDocument);
};
export const RemoveTransactionDocument = gql`
    mutation removeTransaction($organizationId: String!, $transactionId: Int!) {
  removeTransaction(
    organizationId: $organizationId
    transactionId: $transactionId
  )
}
    `;

export function useRemoveTransactionMutation() {
  return Urql.useMutation<RemoveTransactionMutation, RemoveTransactionMutationVariables>(RemoveTransactionDocument);
};
export const RetryTransactionDocument = gql`
    mutation retryTransaction($transactionId: Int!) {
  retryTransaction(transactionId: $transactionId)
}
    `;

export function useRetryTransactionMutation() {
  return Urql.useMutation<RetryTransactionMutation, RetryTransactionMutationVariables>(RetryTransactionDocument);
};
export const UpdateReceiveNotificationsDocument = gql`
    mutation updateReceiveNotifications($receiveNotifications: Boolean!) {
  updateReceiveNotifications(receiveNotifications: $receiveNotifications) {
    ...User
  }
}
    ${UserFragmentDoc}`;

export function useUpdateReceiveNotificationsMutation() {
  return Urql.useMutation<UpdateReceiveNotificationsMutation, UpdateReceiveNotificationsMutationVariables>(UpdateReceiveNotificationsDocument);
};
export const UnflagDepositTransactionDocument = gql`
    mutation unflagDepositTransaction($transactionId: Int!) {
  unflagDepositTransaction(transactionId: $transactionId)
}
    `;

export function useUnflagDepositTransactionMutation() {
  return Urql.useMutation<UnflagDepositTransactionMutation, UnflagDepositTransactionMutationVariables>(UnflagDepositTransactionDocument);
};
export const RejectFlaggedDepositDocument = gql`
    mutation rejectFlaggedDeposit($transactionId: Int!) {
  rejectFlaggedDeposit(transactionId: $transactionId)
}
    `;

export function useRejectFlaggedDepositMutation() {
  return Urql.useMutation<RejectFlaggedDepositMutation, RejectFlaggedDepositMutationVariables>(RejectFlaggedDepositDocument);
};
export const SetRiskScoreThresholdDocument = gql`
    mutation setRiskScoreThreshold($organizationId: String!, $severityThreshold: RiskScoreSeverity!, $usdThreshold: Float!) {
  setRiskScoreThreshold(
    organizationId: $organizationId
    severityThreshold: $severityThreshold
    usdThreshold: $usdThreshold
  )
}
    `;

export function useSetRiskScoreThresholdMutation() {
  return Urql.useMutation<SetRiskScoreThresholdMutation, SetRiskScoreThresholdMutationVariables>(SetRiskScoreThresholdDocument);
};
export const WithdrawalApprovalEmailsDocument = gql`
    query withdrawalApprovalEmails($organizationId: String!) {
  withdrawalApprovalEmails(organizationId: $organizationId) {
    id
    email
    createdAt
  }
}
    `;

export function useWithdrawalApprovalEmailsQuery(options: Omit<Urql.UseQueryArgs<WithdrawalApprovalEmailsQueryVariables>, 'query'>) {
  return Urql.useQuery<WithdrawalApprovalEmailsQuery, WithdrawalApprovalEmailsQueryVariables>({ query: WithdrawalApprovalEmailsDocument, ...options });
};
export const AddWithdrawalApprovalEmailDocument = gql`
    mutation addWithdrawalApprovalEmail($organizationId: String!, $email: String!) {
  addWithdrawalApprovalEmail(organizationId: $organizationId, email: $email) {
    id
    email
    createdAt
  }
}
    `;

export function useAddWithdrawalApprovalEmailMutation() {
  return Urql.useMutation<AddWithdrawalApprovalEmailMutation, AddWithdrawalApprovalEmailMutationVariables>(AddWithdrawalApprovalEmailDocument);
};
export const ArchiveWithdrawalApprovalEmailDocument = gql`
    mutation archiveWithdrawalApprovalEmail($organizationId: String!, $id: Int!) {
  archiveWithdrawalApprovalEmail(organizationId: $organizationId, id: $id)
}
    `;

export function useArchiveWithdrawalApprovalEmailMutation() {
  return Urql.useMutation<ArchiveWithdrawalApprovalEmailMutation, ArchiveWithdrawalApprovalEmailMutationVariables>(ArchiveWithdrawalApprovalEmailDocument);
};
export const SetPlayerBalanceWebhookDocument = gql`
    mutation setPlayerBalanceWebhook($organizationId: String!, $url: String!) {
  setPlayerBalanceWebhook(organizationId: $organizationId, url: $url)
}
    `;

export function useSetPlayerBalanceWebhookMutation() {
  return Urql.useMutation<SetPlayerBalanceWebhookMutation, SetPlayerBalanceWebhookMutationVariables>(SetPlayerBalanceWebhookDocument);
};
export const RotatePlayerBalanceWebhookSecretDocument = gql`
    mutation rotatePlayerBalanceWebhookSecret($organizationId: String!) {
  rotatePlayerBalanceWebhookSecret(organizationId: $organizationId) {
    secret
  }
}
    `;

export function useRotatePlayerBalanceWebhookSecretMutation() {
  return Urql.useMutation<RotatePlayerBalanceWebhookSecretMutation, RotatePlayerBalanceWebhookSecretMutationVariables>(RotatePlayerBalanceWebhookSecretDocument);
};
export const RefreshPlayerBalancesDocument = gql`
    mutation refreshPlayerBalances($organizationId: String!) {
  refreshPlayerBalances(organizationId: $organizationId) {
    ...PlayerBalancesFields
  }
}
    ${PlayerBalancesFieldsFragmentDoc}`;

export function useRefreshPlayerBalancesMutation() {
  return Urql.useMutation<RefreshPlayerBalancesMutation, RefreshPlayerBalancesMutationVariables>(RefreshPlayerBalancesDocument);
};
export const GetProductsDocument = gql`
    query getProducts($organizationId: String!, $status: ProductStatus, $limit: Int, $cursor: String) {
  getProducts(
    organizationId: $organizationId
    status: $status
    limit: $limit
    cursor: $cursor
  ) {
    items {
      ...Product
    }
    hasMore
    nextCursor
  }
}
    ${ProductFragmentDoc}`;

export function useGetProductsQuery(options: Omit<Urql.UseQueryArgs<GetProductsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProductsQuery, GetProductsQueryVariables>({ query: GetProductsDocument, ...options });
};
export const GetProductDocument = gql`
    query getProduct($organizationId: String!, $productId: String!) {
  getProduct(organizationId: $organizationId, productId: $productId) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

export function useGetProductQuery(options: Omit<Urql.UseQueryArgs<GetProductQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProductQuery, GetProductQueryVariables>({ query: GetProductDocument, ...options });
};
export const CreateProductDocument = gql`
    mutation createProduct($organizationId: String!, $input: CreateProductInput!) {
  createProduct(organizationId: $organizationId, input: $input) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

export function useCreateProductMutation() {
  return Urql.useMutation<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument);
};
export const UpdateProductDocument = gql`
    mutation updateProduct($organizationId: String!, $productId: String!, $input: UpdateProductInput!) {
  updateProduct(
    organizationId: $organizationId
    productId: $productId
    input: $input
  ) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

export function useUpdateProductMutation() {
  return Urql.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument);
};
export const GetCheckoutDepositAddressesDocument = gql`
    query getCheckoutDepositAddresses($organizationId: String!, $limit: Int, $cursor: String) {
  getCheckoutDepositAddresses(
    organizationId: $organizationId
    limit: $limit
    cursor: $cursor
  ) {
    items {
      ...CheckoutDepositAddress
    }
    hasMore
    nextCursor
  }
}
    ${CheckoutDepositAddressFragmentDoc}`;

export function useGetCheckoutDepositAddressesQuery(options: Omit<Urql.UseQueryArgs<GetCheckoutDepositAddressesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCheckoutDepositAddressesQuery, GetCheckoutDepositAddressesQueryVariables>({ query: GetCheckoutDepositAddressesDocument, ...options });
};
export const GetCheckoutsWithSessionsDocument = gql`
    query getCheckoutsWithSessions($organizationId: String!, $limit: Int, $cursor: String) {
  getCheckoutsWithSessions(
    organizationId: $organizationId
    limit: $limit
    cursor: $cursor
  ) {
    items {
      ...CheckoutSummary
    }
    hasMore
    nextCursor
  }
}
    ${CheckoutSummaryFragmentDoc}`;

export function useGetCheckoutsWithSessionsQuery(options: Omit<Urql.UseQueryArgs<GetCheckoutsWithSessionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCheckoutsWithSessionsQuery, GetCheckoutsWithSessionsQueryVariables>({ query: GetCheckoutsWithSessionsDocument, ...options });
};
export const GetCheckoutSwapEligibilityDocument = gql`
    query getCheckoutSwapEligibility($organizationId: String!, $checkoutId: ID!) {
  getCheckoutSwapEligibility(
    organizationId: $organizationId
    checkoutId: $checkoutId
  ) {
    eligible
    reason
    minUsd
  }
}
    `;

export function useGetCheckoutSwapEligibilityQuery(options: Omit<Urql.UseQueryArgs<GetCheckoutSwapEligibilityQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCheckoutSwapEligibilityQuery, GetCheckoutSwapEligibilityQueryVariables>({ query: GetCheckoutSwapEligibilityDocument, ...options });
};
export const GetCheckoutSettlementDetailDocument = gql`
    query getCheckoutSettlementDetail($organizationId: String!, $mainWalletTransactionId: Int!) {
  getCheckoutSettlementDetail(
    organizationId: $organizationId
    mainWalletTransactionId: $mainWalletTransactionId
  ) {
    settlement {
      id
      txHash
      uiAmount
      usdAmount
      status
      confirmedAt
      mint {
        ...Mint
      }
    }
    session {
      id
      checkoutId
      status
      depositAddress
      mintSymbol
      mintChain
      isTestnet
      rateLocked
      amountRequired
      amountReceived
      swap {
        ...CheckoutSessionSwapFields
      }
    }
    checkout {
      id
      productName
      priceUsdSnapshot
    }
    deposits {
      id
      txHash
      fromAddress
      amount
      confirmedAt
    }
    grossReceived
    netSettled
  }
}
    ${MintFragmentDoc}
${CheckoutSessionSwapFieldsFragmentDoc}`;

export function useGetCheckoutSettlementDetailQuery(options: Omit<Urql.UseQueryArgs<GetCheckoutSettlementDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCheckoutSettlementDetailQuery, GetCheckoutSettlementDetailQueryVariables>({ query: GetCheckoutSettlementDetailDocument, ...options });
};
export const GetCheckoutPenaltyDetailDocument = gql`
    query getCheckoutPenaltyDetail($organizationId: String!, $mainWalletTransactionId: Int!) {
  getCheckoutPenaltyDetail(
    organizationId: $organizationId
    mainWalletTransactionId: $mainWalletTransactionId
  ) {
    penalty {
      id
      txHash
      uiAmount
      usdAmount
      status
      confirmedAt
      mint {
        ...Mint
      }
    }
    session {
      id
      checkoutId
      status
      depositAddress
      mintSymbol
      mintChain
      isTestnet
      rateLocked
      amountRequired
      amountReceived
    }
    checkout {
      id
      productName
      priceUsdSnapshot
    }
    refundTxHash
    refund {
      txHash
      amount
      confirmedAt
    }
  }
}
    ${MintFragmentDoc}`;

export function useGetCheckoutPenaltyDetailQuery(options: Omit<Urql.UseQueryArgs<GetCheckoutPenaltyDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCheckoutPenaltyDetailQuery, GetCheckoutPenaltyDetailQueryVariables>({ query: GetCheckoutPenaltyDetailDocument, ...options });
};
export const DeleteProductDocument = gql`
    mutation deleteProduct($organizationId: String!, $productId: String!) {
  deleteProduct(organizationId: $organizationId, productId: $productId)
}
    `;

export function useDeleteProductMutation() {
  return Urql.useMutation<DeleteProductMutation, DeleteProductMutationVariables>(DeleteProductDocument);
};
export const GetValiantSwappableAssetsDocument = gql`
    query getValiantSwappableAssets($organizationId: String!) {
  valiantSwappableAssets(organizationId: $organizationId) {
    cheddarMint {
      ...Mint
    }
    valiantMintId
    availableBalance
    availableBalanceHuman
    nativeFeeCapPerGas
  }
}
    ${MintFragmentDoc}`;

export function useGetValiantSwappableAssetsQuery(options: Omit<Urql.UseQueryArgs<GetValiantSwappableAssetsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetValiantSwappableAssetsQuery, GetValiantSwappableAssetsQueryVariables>({ query: GetValiantSwappableAssetsDocument, ...options });
};
export const GetValiantMintsDocument = gql`
    query getValiantMints($organizationId: String!, $chain: String) {
  valiantMints(organizationId: $organizationId, chain: $chain) {
    id
    symbol
    name
    decimals
    displayDecimals
    chain
    address
  }
}
    `;

export function useGetValiantMintsQuery(options: Omit<Urql.UseQueryArgs<GetValiantMintsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetValiantMintsQuery, GetValiantMintsQueryVariables>({ query: GetValiantMintsDocument, ...options });
};
export const GetValiantWhitelistedAddressesDocument = gql`
    query getValiantWhitelistedAddresses($organizationId: String!) {
  valiantWhitelistedAddresses(organizationId: $organizationId) {
    id
    chain
    address
    label
  }
}
    `;

export function useGetValiantWhitelistedAddressesQuery(options: Omit<Urql.UseQueryArgs<GetValiantWhitelistedAddressesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetValiantWhitelistedAddressesQuery, GetValiantWhitelistedAddressesQueryVariables>({ query: GetValiantWhitelistedAddressesDocument, ...options });
};
export const GetNearIntentsDocument = gql`
    query getNearIntents($organizationId: String!, $page: Int, $limit: Int, $status: NearIntentStatus) {
  nearIntents(
    organizationId: $organizationId
    page: $page
    limit: $limit
    status: $status
  ) {
    ...NearIntentFields
  }
}
    ${NearIntentFieldsFragmentDoc}`;

export function useGetNearIntentsQuery(options: Omit<Urql.UseQueryArgs<GetNearIntentsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNearIntentsQuery, GetNearIntentsQueryVariables>({ query: GetNearIntentsDocument, ...options });
};
export const GetNearIntentDocument = gql`
    query getNearIntent($organizationId: String!, $intentId: String!) {
  nearIntent(organizationId: $organizationId, intentId: $intentId) {
    ...NearIntentFields
  }
}
    ${NearIntentFieldsFragmentDoc}`;

export function useGetNearIntentQuery(options: Omit<Urql.UseQueryArgs<GetNearIntentQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNearIntentQuery, GetNearIntentQueryVariables>({ query: GetNearIntentDocument, ...options });
};
export const GetCustomerSwapsDocument = gql`
    query getCustomerSwaps($organizationId: String!, $filter: CustomerSwapFilter, $pagination: CustomerSwapPagination) {
  customerSwaps(
    organizationId: $organizationId
    filter: $filter
    pagination: $pagination
  ) {
    nextCursor
    items {
      ...CustomerSwapFields
    }
  }
}
    ${CustomerSwapFieldsFragmentDoc}`;

export function useGetCustomerSwapsQuery(options: Omit<Urql.UseQueryArgs<GetCustomerSwapsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCustomerSwapsQuery, GetCustomerSwapsQueryVariables>({ query: GetCustomerSwapsDocument, ...options });
};
export const GetCustomerSwapDocument = gql`
    query getCustomerSwap($organizationId: String!, $id: String!) {
  customerSwap(organizationId: $organizationId, id: $id) {
    ...CustomerSwapFields
  }
}
    ${CustomerSwapFieldsFragmentDoc}`;

export function useGetCustomerSwapQuery(options: Omit<Urql.UseQueryArgs<GetCustomerSwapQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCustomerSwapQuery, GetCustomerSwapQueryVariables>({ query: GetCustomerSwapDocument, ...options });
};
export const GetCustomerSwapsExportDocument = gql`
    query getCustomerSwapsExport($organizationId: String!, $filter: CustomerSwapFilter) {
  customerSwapsExport(organizationId: $organizationId, filter: $filter) {
    ...CustomerSwapFields
  }
}
    ${CustomerSwapFieldsFragmentDoc}`;

export function useGetCustomerSwapsExportQuery(options: Omit<Urql.UseQueryArgs<GetCustomerSwapsExportQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCustomerSwapsExportQuery, GetCustomerSwapsExportQueryVariables>({ query: GetCustomerSwapsExportDocument, ...options });
};
export const GetValiantSwapsDocument = gql`
    query getValiantSwaps($organizationId: String!) {
  valiantSwaps(organizationId: $organizationId) {
    ...ValiantSwapFields
  }
}
    ${ValiantSwapFieldsFragmentDoc}`;

export function useGetValiantSwapsQuery(options: Omit<Urql.UseQueryArgs<GetValiantSwapsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetValiantSwapsQuery, GetValiantSwapsQueryVariables>({ query: GetValiantSwapsDocument, ...options });
};
export const GetValiantSwapDocument = gql`
    query getValiantSwap($organizationId: String!, $swapId: String!) {
  valiantSwap(organizationId: $organizationId, swapId: $swapId) {
    ...ValiantSwapFields
  }
}
    ${ValiantSwapFieldsFragmentDoc}`;

export function useGetValiantSwapQuery(options: Omit<Urql.UseQueryArgs<GetValiantSwapQueryVariables>, 'query'>) {
  return Urql.useQuery<GetValiantSwapQuery, GetValiantSwapQueryVariables>({ query: GetValiantSwapDocument, ...options });
};
export const CreateSwapDocument = gql`
    mutation createSwap($input: CreateSwapInput!) {
  createSwap(input: $input) {
    ...ValiantSwapFields
  }
}
    ${ValiantSwapFieldsFragmentDoc}`;

export function useCreateSwapMutation() {
  return Urql.useMutation<CreateSwapMutation, CreateSwapMutationVariables>(CreateSwapDocument);
};
export const BatchPayoutsDocument = gql`
    query batchPayouts($organizationId: String!) {
  batchPayouts(organizationId: $organizationId) {
    ...BatchPayoutFields
  }
}
    ${BatchPayoutFieldsFragmentDoc}`;

export function useBatchPayoutsQuery(options: Omit<Urql.UseQueryArgs<BatchPayoutsQueryVariables>, 'query'>) {
  return Urql.useQuery<BatchPayoutsQuery, BatchPayoutsQueryVariables>({ query: BatchPayoutsDocument, ...options });
};
export const BatchPayoutDocument = gql`
    query batchPayout($id: String!) {
  batchPayout(id: $id) {
    ...BatchPayoutFields
  }
}
    ${BatchPayoutFieldsFragmentDoc}`;

export function useBatchPayoutQuery(options: Omit<Urql.UseQueryArgs<BatchPayoutQueryVariables>, 'query'>) {
  return Urql.useQuery<BatchPayoutQuery, BatchPayoutQueryVariables>({ query: BatchPayoutDocument, ...options });
};
export const CreateBatchPayoutDocument = gql`
    mutation createBatchPayout($input: CreateBatchPayoutInput!) {
  createBatchPayout(input: $input) {
    ...BatchPayoutFields
  }
}
    ${BatchPayoutFieldsFragmentDoc}`;

export function useCreateBatchPayoutMutation() {
  return Urql.useMutation<CreateBatchPayoutMutation, CreateBatchPayoutMutationVariables>(CreateBatchPayoutDocument);
};
export const UpdateBatchPayoutLabelsDocument = gql`
    mutation updateBatchPayoutLabels($input: UpdateBatchPayoutLabelsInput!) {
  updateBatchPayoutLabels(input: $input) {
    ...BatchPayoutFields
  }
}
    ${BatchPayoutFieldsFragmentDoc}`;

export function useUpdateBatchPayoutLabelsMutation() {
  return Urql.useMutation<UpdateBatchPayoutLabelsMutation, UpdateBatchPayoutLabelsMutationVariables>(UpdateBatchPayoutLabelsDocument);
};
export const SubmitBatchPayoutDocument = gql`
    mutation submitBatchPayout($id: String!, $totpCode: String!) {
  submitBatchPayout(id: $id, totpCode: $totpCode) {
    ...BatchPayoutFields
  }
}
    ${BatchPayoutFieldsFragmentDoc}`;

export function useSubmitBatchPayoutMutation() {
  return Urql.useMutation<SubmitBatchPayoutMutation, SubmitBatchPayoutMutationVariables>(SubmitBatchPayoutDocument);
};
export const GetInvoicesDocument = gql`
    query getInvoices($organizationId: String!, $limit: Int, $cursor: String, $searchQuery: String) {
  getInvoices(
    organizationId: $organizationId
    limit: $limit
    cursor: $cursor
    searchQuery: $searchQuery
  ) {
    items {
      ...InvoiceSummary
    }
    hasMore
    nextCursor
  }
}
    ${InvoiceSummaryFragmentDoc}`;

export function useGetInvoicesQuery(options: Omit<Urql.UseQueryArgs<GetInvoicesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetInvoicesQuery, GetInvoicesQueryVariables>({ query: GetInvoicesDocument, ...options });
};
export const GetInvoiceDocument = gql`
    query getInvoice($organizationId: String!, $id: String!) {
  getInvoice(organizationId: $organizationId, id: $id) {
    ...InvoiceDetail
  }
}
    ${InvoiceDetailFragmentDoc}`;

export function useGetInvoiceQuery(options: Omit<Urql.UseQueryArgs<GetInvoiceQueryVariables>, 'query'>) {
  return Urql.useQuery<GetInvoiceQuery, GetInvoiceQueryVariables>({ query: GetInvoiceDocument, ...options });
};
export const CreateInvoiceDocument = gql`
    mutation createInvoice($organizationId: String!, $input: CreateInvoiceInput!) {
  createInvoice(organizationId: $organizationId, input: $input) {
    ...InvoiceDetail
  }
}
    ${InvoiceDetailFragmentDoc}`;

export function useCreateInvoiceMutation() {
  return Urql.useMutation<CreateInvoiceMutation, CreateInvoiceMutationVariables>(CreateInvoiceDocument);
};
export const VoidInvoiceDocument = gql`
    mutation voidInvoice($organizationId: String!, $id: String!) {
  voidInvoice(organizationId: $organizationId, id: $id) {
    ...InvoiceDetail
  }
}
    ${InvoiceDetailFragmentDoc}`;

export function useVoidInvoiceMutation() {
  return Urql.useMutation<VoidInvoiceMutation, VoidInvoiceMutationVariables>(VoidInvoiceDocument);
};
export const ExtendInvoiceDocument = gql`
    mutation extendInvoice($organizationId: String!, $id: String!, $dueDate: String!) {
  extendInvoice(organizationId: $organizationId, id: $id, dueDate: $dueDate) {
    ...InvoiceDetail
  }
}
    ${InvoiceDetailFragmentDoc}`;

export function useExtendInvoiceMutation() {
  return Urql.useMutation<ExtendInvoiceMutation, ExtendInvoiceMutationVariables>(ExtendInvoiceDocument);
};
export const GetPlatformBillUsdDueDocument = gql`
    query getPlatformBillUsdDue($organizationId: String!) {
  getPlatformBillUsdDue(organizationId: $organizationId) {
    dueNowUsd
    accruingUsd
    breakdown {
      ...PlatformBillUsdBreakdownRow
    }
  }
}
    ${PlatformBillUsdBreakdownRowFragmentDoc}`;

export function useGetPlatformBillUsdDueQuery(options: Omit<Urql.UseQueryArgs<GetPlatformBillUsdDueQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPlatformBillUsdDueQuery, GetPlatformBillUsdDueQueryVariables>({ query: GetPlatformBillUsdDueDocument, ...options });
};
export const GetPlayerBalancesDocument = gql`
    query getPlayerBalances($organizationId: String!) {
  getPlayerBalances(organizationId: $organizationId) {
    ...PlayerBalancesFields
  }
}
    ${PlayerBalancesFieldsFragmentDoc}`;

export function useGetPlayerBalancesQuery(options: Omit<Urql.UseQueryArgs<GetPlayerBalancesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPlayerBalancesQuery, GetPlayerBalancesQueryVariables>({ query: GetPlayerBalancesDocument, ...options });
};
export const ListPlatformBillsDocument = gql`
    query listPlatformBills($organizationId: String!, $status: PlatformBillStatus, $limit: Int, $cursor: Int) {
  listPlatformBills(
    organizationId: $organizationId
    status: $status
    limit: $limit
    cursor: $cursor
  ) {
    items {
      ...PlatformBill
    }
    hasMore
    nextCursor
  }
}
    ${PlatformBillFragmentDoc}`;

export function useListPlatformBillsQuery(options: Omit<Urql.UseQueryArgs<ListPlatformBillsQueryVariables>, 'query'>) {
  return Urql.useQuery<ListPlatformBillsQuery, ListPlatformBillsQueryVariables>({ query: ListPlatformBillsDocument, ...options });
};
export const ListPlatformBillPaymentsDocument = gql`
    query listPlatformBillPayments($organizationId: String!, $limit: Int, $cursor: Int) {
  listPlatformBillPayments(
    organizationId: $organizationId
    limit: $limit
    cursor: $cursor
  ) {
    items {
      id
      createdAt
      amount
      usdDueCovered
      mintId
      mintSymbol
      chain
      mainWalletPurpose
      status
      settledTxRef
      coveredBills {
        id
        yearMonth
      }
    }
    hasMore
    nextCursor
  }
}
    `;

export function useListPlatformBillPaymentsQuery(options: Omit<Urql.UseQueryArgs<ListPlatformBillPaymentsQueryVariables>, 'query'>) {
  return Urql.useQuery<ListPlatformBillPaymentsQuery, ListPlatformBillPaymentsQueryVariables>({ query: ListPlatformBillPaymentsDocument, ...options });
};
export const PlatformFeeRecipientDocument = gql`
    query platformFeeRecipient($chain: Chain!) {
  platformFeeRecipient(chain: $chain)
}
    `;

export function usePlatformFeeRecipientQuery(options: Omit<Urql.UseQueryArgs<PlatformFeeRecipientQueryVariables>, 'query'>) {
  return Urql.useQuery<PlatformFeeRecipientQuery, PlatformFeeRecipientQueryVariables>({ query: PlatformFeeRecipientDocument, ...options });
};
export const PayAllPlatformBillsDocument = gql`
    mutation payAllPlatformBills($organizationId: String!, $mintId: Int!, $mainWalletPurpose: MainWalletPurpose!, $expectedUsdDueMicro: String) {
  payAllPlatformBills(
    organizationId: $organizationId
    mintId: $mintId
    mainWalletPurpose: $mainWalletPurpose
    expectedUsdDueMicro: $expectedUsdDueMicro
  ) {
    paymentId
    amount
    usdDueCovered
    billIds
    mainWalletId
  }
}
    `;

export function usePayAllPlatformBillsMutation() {
  return Urql.useMutation<PayAllPlatformBillsMutation, PayAllPlatformBillsMutationVariables>(PayAllPlatformBillsDocument);
};
export const PayPlatformBillDocument = gql`
    mutation payPlatformBill($organizationId: String!, $platformBillId: Int!, $mintId: Int!, $mainWalletPurpose: MainWalletPurpose!, $expectedUsdDueMicro: String) {
  payPlatformBill(
    organizationId: $organizationId
    platformBillId: $platformBillId
    mintId: $mintId
    mainWalletPurpose: $mainWalletPurpose
    expectedUsdDueMicro: $expectedUsdDueMicro
  ) {
    paymentId
    amount
    usdDueCovered
    billIds
    mainWalletId
  }
}
    `;

export function usePayPlatformBillMutation() {
  return Urql.useMutation<PayPlatformBillMutation, PayPlatformBillMutationVariables>(PayPlatformBillDocument);
};
export const ReportingMonthlySummaryDocument = gql`
    query reportingMonthlySummary($organizationId: String!, $purpose: MainWalletPurpose!) {
  reportingMonthlySummary(organizationId: $organizationId, purpose: $purpose) {
    ...ReportingMonthlySummaryFields
  }
}
    ${ReportingMonthlySummaryFieldsFragmentDoc}`;

export function useReportingMonthlySummaryQuery(options: Omit<Urql.UseQueryArgs<ReportingMonthlySummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<ReportingMonthlySummaryQuery, ReportingMonthlySummaryQueryVariables>({ query: ReportingMonthlySummaryDocument, ...options });
};
export const ReportingTransactionsDocument = gql`
    query reportingTransactions($organizationId: String!, $purpose: MainWalletPurpose!, $from: String!, $to: String!) {
  reportingTransactions(
    organizationId: $organizationId
    purpose: $purpose
    from: $from
    to: $to
  ) {
    ...ReportingTransactionFields
  }
}
    ${ReportingTransactionFieldsFragmentDoc}`;

export function useReportingTransactionsQuery(options: Omit<Urql.UseQueryArgs<ReportingTransactionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ReportingTransactionsQuery, ReportingTransactionsQueryVariables>({ query: ReportingTransactionsDocument, ...options });
};
export const ReportingSwapsMonthlySummaryDocument = gql`
    query reportingSwapsMonthlySummary($organizationId: String!) {
  reportingSwapsMonthlySummary(organizationId: $organizationId) {
    ...SwapsReportingMonthlySummaryFields
  }
}
    ${SwapsReportingMonthlySummaryFieldsFragmentDoc}`;

export function useReportingSwapsMonthlySummaryQuery(options: Omit<Urql.UseQueryArgs<ReportingSwapsMonthlySummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<ReportingSwapsMonthlySummaryQuery, ReportingSwapsMonthlySummaryQueryVariables>({ query: ReportingSwapsMonthlySummaryDocument, ...options });
};
export const ReportingSwapsDocument = gql`
    query reportingSwaps($organizationId: String!, $from: String!, $to: String!) {
  reportingSwaps(organizationId: $organizationId, from: $from, to: $to) {
    ...SwapsReportingSwapFields
  }
}
    ${SwapsReportingSwapFieldsFragmentDoc}`;

export function useReportingSwapsQuery(options: Omit<Urql.UseQueryArgs<ReportingSwapsQueryVariables>, 'query'>) {
  return Urql.useQuery<ReportingSwapsQuery, ReportingSwapsQueryVariables>({ query: ReportingSwapsDocument, ...options });
};
export const ReportingWindowedStableDocument = gql`
    query reportingWindowedStable($organizationId: String!, $purpose: MainWalletPurpose!, $timezone: String!, $cacheDay: String!) {
  reportingWindowedTotals(
    organizationId: $organizationId
    purpose: $purpose
    timezone: $timezone
    cacheDay: $cacheDay
  ) {
    purpose
    timezone
    metrics {
      metric
      stable {
        ...ReportingMetricStableWindowsFields
      }
    }
  }
}
    ${ReportingMetricStableWindowsFieldsFragmentDoc}`;

export function useReportingWindowedStableQuery(options: Omit<Urql.UseQueryArgs<ReportingWindowedStableQueryVariables>, 'query'>) {
  return Urql.useQuery<ReportingWindowedStableQuery, ReportingWindowedStableQueryVariables>({ query: ReportingWindowedStableDocument, ...options });
};
export const ReportingWindowedTodayDocument = gql`
    query reportingWindowedToday($organizationId: String!, $purpose: MainWalletPurpose!, $timezone: String!, $cacheDay: String!) {
  reportingWindowedTotals(
    organizationId: $organizationId
    purpose: $purpose
    timezone: $timezone
    cacheDay: $cacheDay
  ) {
    purpose
    timezone
    metrics {
      metric
      today {
        today {
          ...ReportingCountUsdFields
        }
      }
    }
  }
}
    ${ReportingCountUsdFieldsFragmentDoc}`;

export function useReportingWindowedTodayQuery(options: Omit<Urql.UseQueryArgs<ReportingWindowedTodayQueryVariables>, 'query'>) {
  return Urql.useQuery<ReportingWindowedTodayQuery, ReportingWindowedTodayQueryVariables>({ query: ReportingWindowedTodayDocument, ...options });
};
export const ReportingSwapsWindowedStableDocument = gql`
    query reportingSwapsWindowedStable($organizationId: String!, $timezone: String!, $cacheDay: String!) {
  reportingSwapsWindowedTotals(
    organizationId: $organizationId
    timezone: $timezone
    cacheDay: $cacheDay
  ) {
    timezone
    stable {
      yesterday {
        ...ReportingSwapWindowBucketFields
      }
      priorSixDays {
        ...ReportingSwapWindowBucketFields
      }
      monthToYesterday {
        ...ReportingSwapWindowBucketFields
      }
      lifetimeToYesterday {
        ...ReportingSwapWindowBucketFields
      }
    }
  }
}
    ${ReportingSwapWindowBucketFieldsFragmentDoc}`;

export function useReportingSwapsWindowedStableQuery(options: Omit<Urql.UseQueryArgs<ReportingSwapsWindowedStableQueryVariables>, 'query'>) {
  return Urql.useQuery<ReportingSwapsWindowedStableQuery, ReportingSwapsWindowedStableQueryVariables>({ query: ReportingSwapsWindowedStableDocument, ...options });
};
export const ReportingSwapsWindowedTodayDocument = gql`
    query reportingSwapsWindowedToday($organizationId: String!, $timezone: String!, $cacheDay: String!) {
  reportingSwapsWindowedTotals(
    organizationId: $organizationId
    timezone: $timezone
    cacheDay: $cacheDay
  ) {
    timezone
    today {
      today {
        ...ReportingSwapWindowBucketFields
      }
    }
  }
}
    ${ReportingSwapWindowBucketFieldsFragmentDoc}`;

export function useReportingSwapsWindowedTodayQuery(options: Omit<Urql.UseQueryArgs<ReportingSwapsWindowedTodayQueryVariables>, 'query'>) {
  return Urql.useQuery<ReportingSwapsWindowedTodayQuery, ReportingSwapsWindowedTodayQueryVariables>({ query: ReportingSwapsWindowedTodayDocument, ...options });
};
export const ReportingTimeSeriesAmountsDocument = gql`
    query reportingTimeSeriesAmounts($organizationId: String!, $purpose: MainWalletPurpose!, $from: String!, $to: String!, $granularity: TimeSeriesGranularity!, $timezone: String!) {
  reportingTimeSeries(
    organizationId: $organizationId
    purpose: $purpose
    from: $from
    to: $to
    granularity: $granularity
    timezone: $timezone
  ) {
    purpose
    granularity
    timezone
    buckets {
      bucketStart
      depositsUsd
      withdrawalsUsd
      salesUsd
    }
    rangeTotals {
      depositsUsd
      withdrawalsUsd
      salesUsd
    }
  }
}
    `;

export function useReportingTimeSeriesAmountsQuery(options: Omit<Urql.UseQueryArgs<ReportingTimeSeriesAmountsQueryVariables>, 'query'>) {
  return Urql.useQuery<ReportingTimeSeriesAmountsQuery, ReportingTimeSeriesAmountsQueryVariables>({ query: ReportingTimeSeriesAmountsDocument, ...options });
};
export const ReportingTimeSeriesUniquesDocument = gql`
    query reportingTimeSeriesUniques($organizationId: String!, $purpose: MainWalletPurpose!, $from: String!, $to: String!, $granularity: TimeSeriesGranularity!, $timezone: String!) {
  reportingTimeSeries(
    organizationId: $organizationId
    purpose: $purpose
    from: $from
    to: $to
    granularity: $granularity
    timezone: $timezone
  ) {
    purpose
    granularity
    timezone
    buckets {
      bucketStart
      uniqueDepositors
      uniqueWithdrawers
      uniqueBuyers
    }
    rangeTotals {
      uniqueDepositors
      uniqueWithdrawers
      uniqueBuyers
    }
  }
}
    `;

export function useReportingTimeSeriesUniquesQuery(options: Omit<Urql.UseQueryArgs<ReportingTimeSeriesUniquesQueryVariables>, 'query'>) {
  return Urql.useQuery<ReportingTimeSeriesUniquesQuery, ReportingTimeSeriesUniquesQueryVariables>({ query: ReportingTimeSeriesUniquesDocument, ...options });
};
export const GetTerminalDevicesDocument = gql`
    query getTerminalDevices($organizationId: String!) {
  getTerminalDevices(organizationId: $organizationId) {
    id
    organizationId
    name
    status
    lastSeenAt
    revokedAt
    pairedAt
    createdAt
  }
}
    `;

export function useGetTerminalDevicesQuery(options: Omit<Urql.UseQueryArgs<GetTerminalDevicesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTerminalDevicesQuery, GetTerminalDevicesQueryVariables>({ query: GetTerminalDevicesDocument, ...options });
};
export const GetTerminalOperatorsDocument = gql`
    query getTerminalOperators($organizationId: String!) {
  getTerminalOperators(organizationId: $organizationId) {
    id
    organizationId
    name
    code
    status
    createdAt
    updatedAt
  }
}
    `;

export function useGetTerminalOperatorsQuery(options: Omit<Urql.UseQueryArgs<GetTerminalOperatorsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTerminalOperatorsQuery, GetTerminalOperatorsQueryVariables>({ query: GetTerminalOperatorsDocument, ...options });
};
export const CreateTerminalPairingCodeDocument = gql`
    mutation createTerminalPairingCode($organizationId: String!) {
  createTerminalPairingCode(organizationId: $organizationId) {
    id
    code
    expiresAt
  }
}
    `;

export function useCreateTerminalPairingCodeMutation() {
  return Urql.useMutation<CreateTerminalPairingCodeMutation, CreateTerminalPairingCodeMutationVariables>(CreateTerminalPairingCodeDocument);
};
export const RenameTerminalDeviceDocument = gql`
    mutation renameTerminalDevice($organizationId: String!, $deviceId: String!, $name: String!) {
  renameTerminalDevice(
    organizationId: $organizationId
    deviceId: $deviceId
    name: $name
  ) {
    id
    name
    status
    lastSeenAt
    pairedAt
  }
}
    `;

export function useRenameTerminalDeviceMutation() {
  return Urql.useMutation<RenameTerminalDeviceMutation, RenameTerminalDeviceMutationVariables>(RenameTerminalDeviceDocument);
};
export const RevokeTerminalDeviceDocument = gql`
    mutation revokeTerminalDevice($organizationId: String!, $deviceId: String!) {
  revokeTerminalDevice(organizationId: $organizationId, deviceId: $deviceId) {
    id
    status
    revokedAt
  }
}
    `;

export function useRevokeTerminalDeviceMutation() {
  return Urql.useMutation<RevokeTerminalDeviceMutation, RevokeTerminalDeviceMutationVariables>(RevokeTerminalDeviceDocument);
};
export const CreateTerminalOperatorDocument = gql`
    mutation createTerminalOperator($organizationId: String!, $input: CreateTerminalOperatorInput!) {
  createTerminalOperator(organizationId: $organizationId, input: $input) {
    id
    name
    code
    status
  }
}
    `;

export function useCreateTerminalOperatorMutation() {
  return Urql.useMutation<CreateTerminalOperatorMutation, CreateTerminalOperatorMutationVariables>(CreateTerminalOperatorDocument);
};
export const UpdateTerminalOperatorDocument = gql`
    mutation updateTerminalOperator($organizationId: String!, $operatorId: String!, $input: UpdateTerminalOperatorInput!) {
  updateTerminalOperator(
    organizationId: $organizationId
    operatorId: $operatorId
    input: $input
  ) {
    id
    name
    code
    status
  }
}
    `;

export function useUpdateTerminalOperatorMutation() {
  return Urql.useMutation<UpdateTerminalOperatorMutation, UpdateTerminalOperatorMutationVariables>(UpdateTerminalOperatorDocument);
};
export const ArchiveTerminalOperatorDocument = gql`
    mutation archiveTerminalOperator($organizationId: String!, $operatorId: String!) {
  archiveTerminalOperator(
    organizationId: $organizationId
    operatorId: $operatorId
  ) {
    id
    status
  }
}
    `;

export function useArchiveTerminalOperatorMutation() {
  return Urql.useMutation<ArchiveTerminalOperatorMutation, ArchiveTerminalOperatorMutationVariables>(ArchiveTerminalOperatorDocument);
};
export const CreatePurposeWalletTransferDocument = gql`
    mutation createPurposeWalletTransfer($organizationId: String!, $sourcePurpose: MainWalletPurpose!, $destPurpose: MainWalletPurpose!, $mintId: Int!, $amount: String!) {
  createPurposeWalletTransfer(
    organizationId: $organizationId
    sourcePurpose: $sourcePurpose
    destPurpose: $destPurpose
    mintId: $mintId
    amount: $amount
  ) {
    transferId
    outTransactionId
  }
}
    `;

export function useCreatePurposeWalletTransferMutation() {
  return Urql.useMutation<CreatePurposeWalletTransferMutation, CreatePurposeWalletTransferMutationVariables>(CreatePurposeWalletTransferDocument);
};
export const PurposeTransferSpendableDocument = gql`
    query purposeTransferSpendable($organizationId: String!, $purpose: MainWalletPurpose!, $mintId: Int!) {
  purposeTransferSpendable(
    organizationId: $organizationId
    purpose: $purpose
    mintId: $mintId
  ) {
    spendable
    confirmed
    networkFeeReserve
  }
}
    `;

export function usePurposeTransferSpendableQuery(options: Omit<Urql.UseQueryArgs<PurposeTransferSpendableQueryVariables>, 'query'>) {
  return Urql.useQuery<PurposeTransferSpendableQuery, PurposeTransferSpendableQueryVariables>({ query: PurposeTransferSpendableDocument, ...options });
};
export const WithdrawableBalanceDocument = gql`
    query withdrawableBalance($organizationId: String!, $purpose: MainWalletPurpose!, $mintId: Int!) {
  withdrawableBalance(
    organizationId: $organizationId
    purpose: $purpose
    mintId: $mintId
  ) {
    balance
    networkFeeReserve
    maxWithdrawable
  }
}
    `;

export function useWithdrawableBalanceQuery(options: Omit<Urql.UseQueryArgs<WithdrawableBalanceQueryVariables>, 'query'>) {
  return Urql.useQuery<WithdrawableBalanceQuery, WithdrawableBalanceQueryVariables>({ query: WithdrawableBalanceDocument, ...options });
};
export const GetPurposeWalletTransfersDocument = gql`
    query getPurposeWalletTransfers($organizationId: String!, $page: Int!, $limit: Int!) {
  getPurposeWalletTransfers(
    organizationId: $organizationId
    page: $page
    limit: $limit
  ) {
    totalCount
    transfers {
      id
      sourcePurpose
      destPurpose
      status
      amount
      uiAmount
      usdAmount
      txHash
      fromAddress
      toAddress
      createdAt
      confirmedAt
      failedReason
      mint {
        id
        name
        chain
        img
        isNative
        isTestnet
        symbol
        decimals
        address
        usdPrice
      }
    }
  }
}
    `;

export function useGetPurposeWalletTransfersQuery(options: Omit<Urql.UseQueryArgs<GetPurposeWalletTransfersQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPurposeWalletTransfersQuery, GetPurposeWalletTransfersQueryVariables>({ query: GetPurposeWalletTransfersDocument, ...options });
};
export const TreasuryMintPoliciesDocument = gql`
    query treasuryMintPolicies($organizationId: String!) {
  treasuryMintPolicies(organizationId: $organizationId) {
    mint {
      id
      name
      symbol
      chain
      img
      decimals
      address
      isNative
      isTestnet
    }
    autoSwapToSolUsdc
    eligible
    ineligibilityCode
    ineligibilityReason
    autoPrefundFromSolUsdc
    prefundEligible
    prefundIneligibilityCode
    prefundIneligibilityReason
  }
}
    `;

export function useTreasuryMintPoliciesQuery(options: Omit<Urql.UseQueryArgs<TreasuryMintPoliciesQueryVariables>, 'query'>) {
  return Urql.useQuery<TreasuryMintPoliciesQuery, TreasuryMintPoliciesQueryVariables>({ query: TreasuryMintPoliciesDocument, ...options });
};
export const SetTreasuryMintAutoSwapDocument = gql`
    mutation setTreasuryMintAutoSwap($organizationId: String!, $mintId: Int!, $enabled: Boolean!) {
  setTreasuryMintAutoSwap(
    organizationId: $organizationId
    mintId: $mintId
    enabled: $enabled
  )
}
    `;

export function useSetTreasuryMintAutoSwapMutation() {
  return Urql.useMutation<SetTreasuryMintAutoSwapMutation, SetTreasuryMintAutoSwapMutationVariables>(SetTreasuryMintAutoSwapDocument);
};
export const SetTreasuryMintAutoPrefundDocument = gql`
    mutation setTreasuryMintAutoPrefund($organizationId: String!, $mintId: Int!, $enabled: Boolean!) {
  setTreasuryMintAutoPrefund(
    organizationId: $organizationId
    mintId: $mintId
    enabled: $enabled
  )
}
    `;

export function useSetTreasuryMintAutoPrefundMutation() {
  return Urql.useMutation<SetTreasuryMintAutoPrefundMutation, SetTreasuryMintAutoPrefundMutationVariables>(SetTreasuryMintAutoPrefundDocument);
};
export const SetDepositAddressRotationEnabledDocument = gql`
    mutation setDepositAddressRotationEnabled($organizationId: String!, $enabled: Boolean!) {
  setDepositAddressRotationEnabled(
    organizationId: $organizationId
    enabled: $enabled
  )
}
    `;

export function useSetDepositAddressRotationEnabledMutation() {
  return Urql.useMutation<SetDepositAddressRotationEnabledMutation, SetDepositAddressRotationEnabledMutationVariables>(SetDepositAddressRotationEnabledDocument);
};
export const CheckoutConversionPoliciesDocument = gql`
    query checkoutConversionPolicies($organizationId: String!) {
  checkoutConversionPolicies(organizationId: $organizationId) {
    mint {
      id
      name
      symbol
      chain
      img
      decimals
      address
      isNative
      isTestnet
    }
    autoSwapCheckoutProceeds
    eligible
    ineligibilityCode
    ineligibilityReason
  }
}
    `;

export function useCheckoutConversionPoliciesQuery(options: Omit<Urql.UseQueryArgs<CheckoutConversionPoliciesQueryVariables>, 'query'>) {
  return Urql.useQuery<CheckoutConversionPoliciesQuery, CheckoutConversionPoliciesQueryVariables>({ query: CheckoutConversionPoliciesDocument, ...options });
};
export const SetCheckoutAutoConversionDocument = gql`
    mutation setCheckoutAutoConversion($organizationId: String!, $mintId: Int!, $enabled: Boolean!) {
  setCheckoutAutoConversion(
    organizationId: $organizationId
    mintId: $mintId
    enabled: $enabled
  )
}
    `;

export function useSetCheckoutAutoConversionMutation() {
  return Urql.useMutation<SetCheckoutAutoConversionMutation, SetCheckoutAutoConversionMutationVariables>(SetCheckoutAutoConversionDocument);
};


export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Asset: ResolverTypeWrapper<Asset>;
  BatchPayout: ResolverTypeWrapper<BatchPayout>;
  BatchPayoutActor: ResolverTypeWrapper<BatchPayoutActor>;
  BatchPayoutMode: BatchPayoutMode;
  BatchPayoutNetworkFee: ResolverTypeWrapper<BatchPayoutNetworkFee>;
  BatchPayoutPhase: BatchPayoutPhase;
  BatchPayoutRecipient: ResolverTypeWrapper<BatchPayoutRecipient>;
  BatchPayoutRecipientInput: BatchPayoutRecipientInput;
  BatchPayoutRecipientStatus: BatchPayoutRecipientStatus;
  BatchPayoutStatus: BatchPayoutStatus;
  BatchPayoutTokenBalance: ResolverTypeWrapper<BatchPayoutTokenBalance>;
  BatchPayoutWallet: ResolverTypeWrapper<BatchPayoutWallet>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  Chain: Chain;
  ChainToken: ResolverTypeWrapper<ChainToken>;
  ChainTokenInput: ChainTokenInput;
  CheckoutConversionIneligibility: CheckoutConversionIneligibility;
  CheckoutConversionPolicy: ResolverTypeWrapper<CheckoutConversionPolicy>;
  CheckoutDepositAddress: ResolverTypeWrapper<CheckoutDepositAddress>;
  CheckoutDepositAddressList: ResolverTypeWrapper<CheckoutDepositAddressList>;
  CheckoutFlagAcceptAttestationInput: CheckoutFlagAcceptAttestationInput;
  CheckoutFlagReview: ResolverTypeWrapper<CheckoutFlagReview>;
  CheckoutFlagReviewList: ResolverTypeWrapper<CheckoutFlagReviewList>;
  CheckoutLineItemSummary: ResolverTypeWrapper<CheckoutLineItemSummary>;
  CheckoutList: ResolverTypeWrapper<CheckoutList>;
  CheckoutPenaltyDetail: ResolverTypeWrapper<CheckoutPenaltyDetail>;
  CheckoutPenaltyRefund: ResolverTypeWrapper<CheckoutPenaltyRefund>;
  CheckoutSessionAmountSent: ResolverTypeWrapper<CheckoutSessionAmountSent>;
  CheckoutSessionPaymentIndicator: CheckoutSessionPaymentIndicator;
  CheckoutSessionStatus: CheckoutSessionStatus;
  CheckoutSessionSummary: ResolverTypeWrapper<CheckoutSessionSummary>;
  CheckoutSessionSwap: ResolverTypeWrapper<CheckoutSessionSwap>;
  CheckoutSettlementCheckoutInfo: ResolverTypeWrapper<CheckoutSettlementCheckoutInfo>;
  CheckoutSettlementDeposit: ResolverTypeWrapper<CheckoutSettlementDeposit>;
  CheckoutSettlementDetail: ResolverTypeWrapper<CheckoutSettlementDetail>;
  CheckoutSettlementNetworkFee: ResolverTypeWrapper<CheckoutSettlementNetworkFee>;
  CheckoutSettlementNetworkFeePayer: CheckoutSettlementNetworkFeePayer;
  CheckoutSettlementPlatformFee: ResolverTypeWrapper<CheckoutSettlementPlatformFee>;
  CheckoutSettlementSessionDetail: ResolverTypeWrapper<CheckoutSettlementSessionDetail>;
  CheckoutSettlementSource: CheckoutSettlementSource;
  CheckoutStatus: CheckoutStatus;
  CheckoutSummary: ResolverTypeWrapper<CheckoutSummary>;
  CheckoutSwapEligibility: ResolverTypeWrapper<CheckoutSwapEligibility>;
  CheckoutSwapIneligibleReason: CheckoutSwapIneligibleReason;
  CreateBatchPayoutInput: CreateBatchPayoutInput;
  CreateInvoiceInput: CreateInvoiceInput;
  CreateInvoiceLineItemInput: CreateInvoiceLineItemInput;
  CreateProductInput: CreateProductInput;
  CreateSwapInput: CreateSwapInput;
  CreateTerminalOperatorInput: CreateTerminalOperatorInput;
  Customer: ResolverTypeWrapper<Customer>;
  CustomerDepositAddress: ResolverTypeWrapper<CustomerDepositAddress>;
  CustomerLedgerKind: CustomerLedgerKind;
  CustomerLedgerPagination: ResolverTypeWrapper<CustomerLedgerPagination>;
  CustomerLedgerTransaction: ResolverTypeWrapper<CustomerLedgerTransaction>;
  CustomerLifetimeTotal: ResolverTypeWrapper<CustomerLifetimeTotal>;
  CustomerSwap: ResolverTypeWrapper<CustomerSwap>;
  CustomerSwapConnection: ResolverTypeWrapper<CustomerSwapConnection>;
  CustomerSwapFilter: CustomerSwapFilter;
  CustomerSwapPagination: CustomerSwapPagination;
  CustomerSwapStatus: CustomerSwapStatus;
  CustomerSwapSummary: ResolverTypeWrapper<CustomerSwapSummary>;
  CustomerTransactionType: CustomerTransactionType;
  CustomerTransactions: ResolverTypeWrapper<CustomerTransactions>;
  CustomerTransactionsPagination: ResolverTypeWrapper<CustomerTransactionsPagination>;
  CustomerWallet: ResolverTypeWrapper<CustomerWallet>;
  CustomerWallets: ResolverTypeWrapper<CustomerWallets>;
  CustomerWithdrawalPagination: ResolverTypeWrapper<CustomerWithdrawalPagination>;
  CustomersPagination: ResolverTypeWrapper<CustomersPagination>;
  DepositFlagReason: ResolverTypeWrapper<DepositFlagReason>;
  DepositResolution: DepositResolution;
  FilterMatchMode: FilterMatchMode;
  FlaggedCheckoutAcceptReason: FlaggedCheckoutAcceptReason;
  FlaggedDeposit: ResolverTypeWrapper<FlaggedDeposit>;
  FlaggedDepositFailedAttempt: ResolverTypeWrapper<FlaggedDepositFailedAttempt>;
  FlaggedDepositResolution: ResolverTypeWrapper<FlaggedDepositResolution>;
  FlaggedDepositResolutionsPagination: ResolverTypeWrapper<FlaggedDepositResolutionsPagination>;
  FlaggedDepositsPagination: ResolverTypeWrapper<FlaggedDepositsPagination>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  FundedCustomer: ResolverTypeWrapper<FundedCustomer>;
  FundedCustomersPagination: ResolverTypeWrapper<FundedCustomersPagination>;
  GasTopupQuote: ResolverTypeWrapper<GasTopupQuote>;
  GasTopupRequestResult: ResolverTypeWrapper<GasTopupRequestResult>;
  GasTopupRequestStatus: GasTopupRequestStatus;
  GasTopupStatus: ResolverTypeWrapper<GasTopupStatus>;
  GasTransaction: ResolverTypeWrapper<GasTransaction>;
  GasTransactionType: GasTransactionType;
  GasTransactionsPagination: ResolverTypeWrapper<GasTransactionsPagination>;
  GasWallet: ResolverTypeWrapper<GasWallet>;
  GetWalletsCustomersResponse: ResolverTypeWrapper<GetWalletsCustomersResponse>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  InputFiltersGasTransaction: InputFiltersGasTransaction;
  InputFiltersTransaction: InputFiltersTransaction;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  InternalTransferThreshold: ResolverTypeWrapper<InternalTransferThreshold>;
  Invoice: ResolverTypeWrapper<Invoice>;
  InvoiceLineItem: ResolverTypeWrapper<InvoiceLineItem>;
  InvoiceList: ResolverTypeWrapper<InvoiceList>;
  InvoiceSessionSummary: ResolverTypeWrapper<InvoiceSessionSummary>;
  InvoiceStatus: InvoiceStatus;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  KpiFlowMetric: KpiFlowMetric;
  MainWallet: ResolverTypeWrapper<MainWallet>;
  MainWalletFailedTransaction: ResolverTypeWrapper<MainWalletFailedTransaction>;
  MainWalletPurpose: MainWalletPurpose;
  MainWalletPurposeBalance: ResolverTypeWrapper<MainWalletPurposeBalance>;
  MainWalletTransaction: ResolverTypeWrapper<MainWalletTransaction>;
  MainWalletTransactionType: MainWalletTransactionType;
  MainWalletTransactionsPagination: ResolverTypeWrapper<MainWalletTransactionsPagination>;
  Mint: ResolverTypeWrapper<Mint>;
  MintSurface: MintSurface;
  Mutation: ResolverTypeWrapper<{}>;
  NearIntent: ResolverTypeWrapper<NearIntent>;
  NearIntentStatus: NearIntentStatus;
  Organization: ResolverTypeWrapper<Organization>;
  OrganizationWallet: ResolverTypeWrapper<OrganizationWallet>;
  PlatformBill: ResolverTypeWrapper<PlatformBill>;
  PlatformBillKindUsage: ResolverTypeWrapper<PlatformBillKindUsage>;
  PlatformBillLineItem: ResolverTypeWrapper<PlatformBillLineItem>;
  PlatformBillLineItemKind: PlatformBillLineItemKind;
  PlatformBillList: ResolverTypeWrapper<PlatformBillList>;
  PlatformBillPayment: ResolverTypeWrapper<PlatformBillPayment>;
  PlatformBillPaymentCoveredBill: ResolverTypeWrapper<PlatformBillPaymentCoveredBill>;
  PlatformBillPaymentList: ResolverTypeWrapper<PlatformBillPaymentList>;
  PlatformBillPaymentResult: ResolverTypeWrapper<PlatformBillPaymentResult>;
  PlatformBillPaymentStatus: PlatformBillPaymentStatus;
  PlatformBillStatus: PlatformBillStatus;
  PlatformBillSummaryBucket: ResolverTypeWrapper<PlatformBillSummaryBucket>;
  PlatformBillUsdBreakdownRow: ResolverTypeWrapper<PlatformBillUsdBreakdownRow>;
  PlatformBillUsdDue: ResolverTypeWrapper<PlatformBillUsdDue>;
  PlatformBillUsdPeriod: PlatformBillUsdPeriod;
  PlatformFeeKind: PlatformFeeKind;
  PlatformFeeRate: ResolverTypeWrapper<PlatformFeeRate>;
  PlayerBalanceSnapshotStatus: PlayerBalanceSnapshotStatus;
  PlayerBalanceToken: ResolverTypeWrapper<PlayerBalanceToken>;
  PlayerBalanceWebhookConfig: ResolverTypeWrapper<PlayerBalanceWebhookConfig>;
  PlayerBalances: ResolverTypeWrapper<PlayerBalances>;
  Product: ResolverTypeWrapper<Product>;
  ProductCreationSource: ProductCreationSource;
  ProductList: ResolverTypeWrapper<ProductList>;
  ProductStatus: ProductStatus;
  PurposeTransferSpendable: ResolverTypeWrapper<PurposeTransferSpendable>;
  PurposeWalletTransfer: ResolverTypeWrapper<PurposeWalletTransfer>;
  PurposeWalletTransferResult: ResolverTypeWrapper<PurposeWalletTransferResult>;
  PurposeWalletTransferStatus: PurposeWalletTransferStatus;
  PurposeWalletTransfersPagination: ResolverTypeWrapper<PurposeWalletTransfersPagination>;
  Query: ResolverTypeWrapper<{}>;
  ReportingCountUsd: ResolverTypeWrapper<ReportingCountUsd>;
  ReportingMetricStableWindows: ResolverTypeWrapper<ReportingMetricStableWindows>;
  ReportingMetricTodayWindow: ResolverTypeWrapper<ReportingMetricTodayWindow>;
  ReportingMetricWindowedTotals: ResolverTypeWrapper<ReportingMetricWindowedTotals>;
  ReportingMonthlySummary: ResolverTypeWrapper<ReportingMonthlySummary>;
  ReportingSwapWindowBucket: ResolverTypeWrapper<ReportingSwapWindowBucket>;
  ReportingSwapsStableWindows: ResolverTypeWrapper<ReportingSwapsStableWindows>;
  ReportingSwapsTodayWindow: ResolverTypeWrapper<ReportingSwapsTodayWindow>;
  ReportingSwapsWindowedTotals: ResolverTypeWrapper<ReportingSwapsWindowedTotals>;
  ReportingTimeSeries: ResolverTypeWrapper<ReportingTimeSeries>;
  ReportingTimeSeriesBucket: ResolverTypeWrapper<ReportingTimeSeriesBucket>;
  ReportingTimeSeriesRangeTotals: ResolverTypeWrapper<ReportingTimeSeriesRangeTotals>;
  ReportingTransaction: ResolverTypeWrapper<ReportingTransaction>;
  ReportingWindowedTotals: ResolverTypeWrapper<ReportingWindowedTotals>;
  ResolutionActor: ResolverTypeWrapper<ResolutionActor>;
  ResolutionActorKind: ResolutionActorKind;
  RiskScoreSeverity: RiskScoreSeverity;
  RotatePlayerBalanceWebhookSecretPayload: ResolverTypeWrapper<RotatePlayerBalanceWebhookSecretPayload>;
  SetupTwoFactorAuthResponse: ResolverTypeWrapper<SetupTwoFactorAuthResponse>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  SwapDepositStage: SwapDepositStage;
  SwapMintRef: ResolverTypeWrapper<SwapMintRef>;
  SwapOverallStatus: SwapOverallStatus;
  SwapStage: SwapStage;
  SwapsReportingMonthlySummary: ResolverTypeWrapper<SwapsReportingMonthlySummary>;
  SwapsReportingSwap: ResolverTypeWrapper<SwapsReportingSwap>;
  TerminalDevice: ResolverTypeWrapper<TerminalDevice>;
  TerminalDeviceStatus: TerminalDeviceStatus;
  TerminalOperator: ResolverTypeWrapper<TerminalOperator>;
  TerminalOperatorStatus: TerminalOperatorStatus;
  TerminalPairingCodeResult: ResolverTypeWrapper<TerminalPairingCodeResult>;
  TimeSeriesGranularity: TimeSeriesGranularity;
  TransactionStatus: TransactionStatus;
  TreasuryMintPolicy: ResolverTypeWrapper<TreasuryMintPolicy>;
  TreasuryMintPolicyIneligibility: TreasuryMintPolicyIneligibility;
  TreasuryMintPrefundIneligibility: TreasuryMintPrefundIneligibility;
  UpdateBatchPayoutLabelsInput: UpdateBatchPayoutLabelsInput;
  UpdateBatchPayoutRecipientReferenceInput: UpdateBatchPayoutRecipientReferenceInput;
  UpdateProductInput: UpdateProductInput;
  UpdateTerminalOperatorInput: UpdateTerminalOperatorInput;
  User: ResolverTypeWrapper<User>;
  ValiantMint: ResolverTypeWrapper<ValiantMint>;
  ValiantSwap: ResolverTypeWrapper<ValiantSwap>;
  ValiantSwappableAsset: ResolverTypeWrapper<ValiantSwappableAsset>;
  ValiantWhitelistedAddress: ResolverTypeWrapper<ValiantWhitelistedAddress>;
  WalletBasic: ResolverTypeWrapper<WalletBasic>;
  Whitelist: ResolverTypeWrapper<Whitelist>;
  WithdrawThreshold: ResolverTypeWrapper<WithdrawThreshold>;
  WithdrawableBalance: ResolverTypeWrapper<WithdrawableBalance>;
  WithdrawalApprovalEmail: ResolverTypeWrapper<WithdrawalApprovalEmail>;
  WithdrawalSwapAsset: ResolverTypeWrapper<WithdrawalSwapAsset>;
  WithdrawalSwapDestination: ResolverTypeWrapper<WithdrawalSwapDestination>;
  WithdrawalSwapFee: ResolverTypeWrapper<WithdrawalSwapFee>;
  WithdrawalSwapInfo: ResolverTypeWrapper<WithdrawalSwapInfo>;
  WithdrawalSwapQuote: ResolverTypeWrapper<WithdrawalSwapQuote>;
  WithdrawalSwapStatus: WithdrawalSwapStatus;
  getUsersOfOrganization: ResolverTypeWrapper<GetUsersOfOrganization>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Asset: Asset;
  BatchPayout: BatchPayout;
  BatchPayoutActor: BatchPayoutActor;
  BatchPayoutNetworkFee: BatchPayoutNetworkFee;
  BatchPayoutRecipient: BatchPayoutRecipient;
  BatchPayoutRecipientInput: BatchPayoutRecipientInput;
  BatchPayoutTokenBalance: BatchPayoutTokenBalance;
  BatchPayoutWallet: BatchPayoutWallet;
  Boolean: Scalars['Boolean']['output'];
  ChainToken: ChainToken;
  ChainTokenInput: ChainTokenInput;
  CheckoutConversionPolicy: CheckoutConversionPolicy;
  CheckoutDepositAddress: CheckoutDepositAddress;
  CheckoutDepositAddressList: CheckoutDepositAddressList;
  CheckoutFlagAcceptAttestationInput: CheckoutFlagAcceptAttestationInput;
  CheckoutFlagReview: CheckoutFlagReview;
  CheckoutFlagReviewList: CheckoutFlagReviewList;
  CheckoutLineItemSummary: CheckoutLineItemSummary;
  CheckoutList: CheckoutList;
  CheckoutPenaltyDetail: CheckoutPenaltyDetail;
  CheckoutPenaltyRefund: CheckoutPenaltyRefund;
  CheckoutSessionAmountSent: CheckoutSessionAmountSent;
  CheckoutSessionSummary: CheckoutSessionSummary;
  CheckoutSessionSwap: CheckoutSessionSwap;
  CheckoutSettlementCheckoutInfo: CheckoutSettlementCheckoutInfo;
  CheckoutSettlementDeposit: CheckoutSettlementDeposit;
  CheckoutSettlementDetail: CheckoutSettlementDetail;
  CheckoutSettlementNetworkFee: CheckoutSettlementNetworkFee;
  CheckoutSettlementPlatformFee: CheckoutSettlementPlatformFee;
  CheckoutSettlementSessionDetail: CheckoutSettlementSessionDetail;
  CheckoutSummary: CheckoutSummary;
  CheckoutSwapEligibility: CheckoutSwapEligibility;
  CreateBatchPayoutInput: CreateBatchPayoutInput;
  CreateInvoiceInput: CreateInvoiceInput;
  CreateInvoiceLineItemInput: CreateInvoiceLineItemInput;
  CreateProductInput: CreateProductInput;
  CreateSwapInput: CreateSwapInput;
  CreateTerminalOperatorInput: CreateTerminalOperatorInput;
  Customer: Customer;
  CustomerDepositAddress: CustomerDepositAddress;
  CustomerLedgerPagination: CustomerLedgerPagination;
  CustomerLedgerTransaction: CustomerLedgerTransaction;
  CustomerLifetimeTotal: CustomerLifetimeTotal;
  CustomerSwap: CustomerSwap;
  CustomerSwapConnection: CustomerSwapConnection;
  CustomerSwapFilter: CustomerSwapFilter;
  CustomerSwapPagination: CustomerSwapPagination;
  CustomerSwapSummary: CustomerSwapSummary;
  CustomerTransactions: CustomerTransactions;
  CustomerTransactionsPagination: CustomerTransactionsPagination;
  CustomerWallet: CustomerWallet;
  CustomerWallets: CustomerWallets;
  CustomerWithdrawalPagination: CustomerWithdrawalPagination;
  CustomersPagination: CustomersPagination;
  DepositFlagReason: DepositFlagReason;
  FlaggedDeposit: FlaggedDeposit;
  FlaggedDepositFailedAttempt: FlaggedDepositFailedAttempt;
  FlaggedDepositResolution: FlaggedDepositResolution;
  FlaggedDepositResolutionsPagination: FlaggedDepositResolutionsPagination;
  FlaggedDepositsPagination: FlaggedDepositsPagination;
  Float: Scalars['Float']['output'];
  FundedCustomer: FundedCustomer;
  FundedCustomersPagination: FundedCustomersPagination;
  GasTopupQuote: GasTopupQuote;
  GasTopupRequestResult: GasTopupRequestResult;
  GasTopupStatus: GasTopupStatus;
  GasTransaction: GasTransaction;
  GasTransactionsPagination: GasTransactionsPagination;
  GasWallet: GasWallet;
  GetWalletsCustomersResponse: GetWalletsCustomersResponse;
  ID: Scalars['ID']['output'];
  InputFiltersGasTransaction: InputFiltersGasTransaction;
  InputFiltersTransaction: InputFiltersTransaction;
  Int: Scalars['Int']['output'];
  InternalTransferThreshold: InternalTransferThreshold;
  Invoice: Invoice;
  InvoiceLineItem: InvoiceLineItem;
  InvoiceList: InvoiceList;
  InvoiceSessionSummary: InvoiceSessionSummary;
  JSON: Scalars['JSON']['output'];
  MainWallet: MainWallet;
  MainWalletFailedTransaction: MainWalletFailedTransaction;
  MainWalletPurposeBalance: MainWalletPurposeBalance;
  MainWalletTransaction: MainWalletTransaction;
  MainWalletTransactionsPagination: MainWalletTransactionsPagination;
  Mint: Mint;
  Mutation: {};
  NearIntent: NearIntent;
  Organization: Organization;
  OrganizationWallet: OrganizationWallet;
  PlatformBill: PlatformBill;
  PlatformBillKindUsage: PlatformBillKindUsage;
  PlatformBillLineItem: PlatformBillLineItem;
  PlatformBillList: PlatformBillList;
  PlatformBillPayment: PlatformBillPayment;
  PlatformBillPaymentCoveredBill: PlatformBillPaymentCoveredBill;
  PlatformBillPaymentList: PlatformBillPaymentList;
  PlatformBillPaymentResult: PlatformBillPaymentResult;
  PlatformBillSummaryBucket: PlatformBillSummaryBucket;
  PlatformBillUsdBreakdownRow: PlatformBillUsdBreakdownRow;
  PlatformBillUsdDue: PlatformBillUsdDue;
  PlatformFeeRate: PlatformFeeRate;
  PlayerBalanceToken: PlayerBalanceToken;
  PlayerBalanceWebhookConfig: PlayerBalanceWebhookConfig;
  PlayerBalances: PlayerBalances;
  Product: Product;
  ProductList: ProductList;
  PurposeTransferSpendable: PurposeTransferSpendable;
  PurposeWalletTransfer: PurposeWalletTransfer;
  PurposeWalletTransferResult: PurposeWalletTransferResult;
  PurposeWalletTransfersPagination: PurposeWalletTransfersPagination;
  Query: {};
  ReportingCountUsd: ReportingCountUsd;
  ReportingMetricStableWindows: ReportingMetricStableWindows;
  ReportingMetricTodayWindow: ReportingMetricTodayWindow;
  ReportingMetricWindowedTotals: ReportingMetricWindowedTotals;
  ReportingMonthlySummary: ReportingMonthlySummary;
  ReportingSwapWindowBucket: ReportingSwapWindowBucket;
  ReportingSwapsStableWindows: ReportingSwapsStableWindows;
  ReportingSwapsTodayWindow: ReportingSwapsTodayWindow;
  ReportingSwapsWindowedTotals: ReportingSwapsWindowedTotals;
  ReportingTimeSeries: ReportingTimeSeries;
  ReportingTimeSeriesBucket: ReportingTimeSeriesBucket;
  ReportingTimeSeriesRangeTotals: ReportingTimeSeriesRangeTotals;
  ReportingTransaction: ReportingTransaction;
  ReportingWindowedTotals: ReportingWindowedTotals;
  ResolutionActor: ResolutionActor;
  RotatePlayerBalanceWebhookSecretPayload: RotatePlayerBalanceWebhookSecretPayload;
  SetupTwoFactorAuthResponse: SetupTwoFactorAuthResponse;
  String: Scalars['String']['output'];
  SwapMintRef: SwapMintRef;
  SwapsReportingMonthlySummary: SwapsReportingMonthlySummary;
  SwapsReportingSwap: SwapsReportingSwap;
  TerminalDevice: TerminalDevice;
  TerminalOperator: TerminalOperator;
  TerminalPairingCodeResult: TerminalPairingCodeResult;
  TreasuryMintPolicy: TreasuryMintPolicy;
  UpdateBatchPayoutLabelsInput: UpdateBatchPayoutLabelsInput;
  UpdateBatchPayoutRecipientReferenceInput: UpdateBatchPayoutRecipientReferenceInput;
  UpdateProductInput: UpdateProductInput;
  UpdateTerminalOperatorInput: UpdateTerminalOperatorInput;
  User: User;
  ValiantMint: ValiantMint;
  ValiantSwap: ValiantSwap;
  ValiantSwappableAsset: ValiantSwappableAsset;
  ValiantWhitelistedAddress: ValiantWhitelistedAddress;
  WalletBasic: WalletBasic;
  Whitelist: Whitelist;
  WithdrawThreshold: WithdrawThreshold;
  WithdrawableBalance: WithdrawableBalance;
  WithdrawalApprovalEmail: WithdrawalApprovalEmail;
  WithdrawalSwapAsset: WithdrawalSwapAsset;
  WithdrawalSwapDestination: WithdrawalSwapDestination;
  WithdrawalSwapFee: WithdrawalSwapFee;
  WithdrawalSwapInfo: WithdrawalSwapInfo;
  WithdrawalSwapQuote: WithdrawalSwapQuote;
  getUsersOfOrganization: GetUsersOfOrganization;
};

export type AssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['Asset'] = ResolversParentTypes['Asset']> = {
  balance?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  unconfirmedBalance?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usdBalance?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BatchPayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['BatchPayout'] = ResolversParentTypes['BatchPayout']> = {
  chain?: Resolver<ResolversTypes['Chain'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  feeAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feeBps?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  idempotencyKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  initiatedBy?: Resolver<Maybe<ResolversTypes['BatchPayoutActor']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mintId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  mode?: Resolver<ResolversTypes['BatchPayoutMode'], ParentType, ContextType>;
  networkFee?: Resolver<Maybe<ResolversTypes['BatchPayoutNetworkFee']>, ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phase?: Resolver<ResolversTypes['BatchPayoutPhase'], ParentType, ContextType>;
  recipientCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  recipients?: Resolver<Array<ResolversTypes['BatchPayoutRecipient']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BatchPayoutStatus'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BatchPayoutActorResolvers<ContextType = any, ParentType extends ResolversParentTypes['BatchPayoutActor'] = ResolversParentTypes['BatchPayoutActor']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BatchPayoutNetworkFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BatchPayoutNetworkFee'] = ResolversParentTypes['BatchPayoutNetworkFee']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usdAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BatchPayoutRecipientResolvers<ContextType = any, ParentType extends ResolversParentTypes['BatchPayoutRecipient'] = ResolversParentTypes['BatchPayoutRecipient']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  legNetworkFee?: Resolver<Maybe<ResolversTypes['BatchPayoutNetworkFee']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payoutBlockConfirmed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  payoutConfirmedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  splitConfirmed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  splitTxid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  splitVout?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BatchPayoutRecipientStatus'], ParentType, ContextType>;
  transactionReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  txHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BatchPayoutTokenBalanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['BatchPayoutTokenBalance'] = ResolversParentTypes['BatchPayoutTokenBalance']> = {
  available?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  reserved?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BatchPayoutWalletResolvers<ContextType = any, ParentType extends ResolversParentTypes['BatchPayoutWallet'] = ResolversParentTypes['BatchPayoutWallet']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chain?: Resolver<ResolversTypes['Chain'], ParentType, ContextType>;
  isTestnet?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mainWalletId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChainTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChainToken'] = ResolversParentTypes['ChainToken']> = {
  chain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutConversionPolicyResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutConversionPolicy'] = ResolversParentTypes['CheckoutConversionPolicy']> = {
  autoSwapCheckoutProceeds?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  eligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ineligibilityCode?: Resolver<Maybe<ResolversTypes['CheckoutConversionIneligibility']>, ParentType, ContextType>;
  ineligibilityReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutDepositAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutDepositAddress'] = ResolversParentTypes['CheckoutDepositAddress']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkoutId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  derivationPath?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sessionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutDepositAddressListResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutDepositAddressList'] = ResolversParentTypes['CheckoutDepositAddressList']> = {
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['CheckoutDepositAddress']>, ParentType, ContextType>;
  nextCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutFlagReviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutFlagReview'] = ResolversParentTypes['CheckoutFlagReview']> = {
  amountReceived?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkoutId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  depositAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lineItems?: Resolver<Array<ResolversTypes['CheckoutLineItemSummary']>, ParentType, ContextType>;
  network?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  priceUsdSnapshot?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productSnapshot?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  quarantineDeadlineAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refundAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  riskFlag?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  sessionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutFlagReviewListResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutFlagReviewList'] = ResolversParentTypes['CheckoutFlagReviewList']> = {
  items?: Resolver<Array<ResolversTypes['CheckoutFlagReview']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutLineItemSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutLineItemSummary'] = ResolversParentTypes['CheckoutLineItemSummary']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lineTotalUsdSnapshot?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productSnapshot?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unitPriceUsdSnapshot?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutListResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutList'] = ResolversParentTypes['CheckoutList']> = {
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['CheckoutSummary']>, ParentType, ContextType>;
  nextCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutPenaltyDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutPenaltyDetail'] = ResolversParentTypes['CheckoutPenaltyDetail']> = {
  checkout?: Resolver<ResolversTypes['CheckoutSettlementCheckoutInfo'], ParentType, ContextType>;
  penalty?: Resolver<ResolversTypes['MainWalletTransaction'], ParentType, ContextType>;
  refund?: Resolver<Maybe<ResolversTypes['CheckoutPenaltyRefund']>, ParentType, ContextType>;
  refundTxHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  session?: Resolver<ResolversTypes['CheckoutSettlementSessionDetail'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutPenaltyRefundResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutPenaltyRefund'] = ResolversParentTypes['CheckoutPenaltyRefund']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  confirmedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  txHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSessionAmountSentResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSessionAmountSent'] = ResolversParentTypes['CheckoutSessionAmountSent']> = {
  amountRequiredCrypto?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amountRequiredUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amountSentCrypto?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amountSentUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isTestnet?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  paymentIndicator?: Resolver<Maybe<ResolversTypes['CheckoutSessionPaymentIndicator']>, ParentType, ContextType>;
  shortfallCrypto?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortfallUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSessionSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSessionSummary'] = ResolversParentTypes['CheckoutSessionSummary']> = {
  amountReceived?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amountRequired?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amountSent?: Resolver<ResolversTypes['CheckoutSessionAmountSent'], ParentType, ContextType>;
  checkoutId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  depositAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  depositAddressPath?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mintChain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mintId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  mintSymbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rateLocked?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CheckoutSessionStatus'], ParentType, ContextType>;
  swap?: Resolver<Maybe<ResolversTypes['CheckoutSessionSwap']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSessionSwapResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSessionSwap'] = ResolversParentTypes['CheckoutSessionSwap']> = {
  actualAmountOut?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amountIn?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amountInUsd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  destinationTxHashes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  failureReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  intentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  minAmountOut?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originAssetId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  originBlockchain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  originSymbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  originTxHashes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  quotedAmountOut?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refundFee?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slippageToleranceBps?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['NearIntentStatus'], ParentType, ContextType>;
  timeEstimateSeconds?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  withdrawFee?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSettlementCheckoutInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSettlementCheckoutInfo'] = ResolversParentTypes['CheckoutSettlementCheckoutInfo']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lineItems?: Resolver<Array<ResolversTypes['CheckoutLineItemSummary']>, ParentType, ContextType>;
  priceUsdSnapshot?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSettlementDepositResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSettlementDeposit'] = ResolversParentTypes['CheckoutSettlementDeposit']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  confirmedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  txHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSettlementDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSettlementDetail'] = ResolversParentTypes['CheckoutSettlementDetail']> = {
  checkout?: Resolver<ResolversTypes['CheckoutSettlementCheckoutInfo'], ParentType, ContextType>;
  deposits?: Resolver<Array<ResolversTypes['CheckoutSettlementDeposit']>, ParentType, ContextType>;
  grossReceived?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  netSettled?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  networkFee?: Resolver<Maybe<ResolversTypes['CheckoutSettlementNetworkFee']>, ParentType, ContextType>;
  platformFee?: Resolver<Maybe<ResolversTypes['CheckoutSettlementPlatformFee']>, ParentType, ContextType>;
  session?: Resolver<ResolversTypes['CheckoutSettlementSessionDetail'], ParentType, ContextType>;
  settlement?: Resolver<ResolversTypes['MainWalletTransaction'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSettlementNetworkFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSettlementNetworkFee'] = ResolversParentTypes['CheckoutSettlementNetworkFee']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paidBy?: Resolver<ResolversTypes['CheckoutSettlementNetworkFeePayer'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TransactionStatus'], ParentType, ContextType>;
  txHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uiAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usdAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSettlementPlatformFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSettlementPlatformFee'] = ResolversParentTypes['CheckoutSettlementPlatformFee']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  billStatus?: Resolver<ResolversTypes['PlatformBillStatus'], ParentType, ContextType>;
  uiAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usdAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  yearMonth?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSettlementSessionDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSettlementSessionDetail'] = ResolversParentTypes['CheckoutSettlementSessionDetail']> = {
  amountReceived?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amountRequired?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkoutId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  depositAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isTestnet?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mintChain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mintId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  mintSymbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rateLocked?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CheckoutSessionStatus'], ParentType, ContextType>;
  swap?: Resolver<Maybe<ResolversTypes['CheckoutSessionSwap']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSummary'] = ResolversParentTypes['CheckoutSummary']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hostedUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lineItems?: Resolver<Array<ResolversTypes['CheckoutLineItemSummary']>, ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  priceUsdSnapshot?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sessions?: Resolver<Array<ResolversTypes['CheckoutSessionSummary']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CheckoutStatus'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutSwapEligibilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSwapEligibility'] = ResolversParentTypes['CheckoutSwapEligibility']> = {
  eligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  minUsd?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['CheckoutSwapIneligibleReason']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Customer'] = ResolversParentTypes['Customer']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  organizationExternalEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationExternalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requireDepositApproval?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerDepositAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerDepositAddress'] = ResolversParentTypes['CustomerDepositAddress']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  retiredAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerLedgerPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerLedgerPagination'] = ResolversParentTypes['CustomerLedgerPagination']> = {
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  transactions?: Resolver<Array<ResolversTypes['CustomerLedgerTransaction']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerLedgerTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerLedgerTransaction'] = ResolversParentTypes['CustomerLedgerTransaction']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  canUnflag?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  confirmedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customerSwap?: Resolver<Maybe<ResolversTypes['CustomerSwapSummary']>, ParentType, ContextType>;
  failedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['CustomerLedgerKind'], ParentType, ContextType>;
  mint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TransactionStatus'], ParentType, ContextType>;
  toAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uiAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usdAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerLifetimeTotalResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerLifetimeTotal'] = ResolversParentTypes['CustomerLifetimeTotal']> = {
  depositAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  depositUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  withdrawalAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  withdrawalUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerSwapResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerSwap'] = ResolversParentTypes['CustomerSwap']> = {
  amountIn?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amountOut?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customerExternalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  destinationTxHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  estimatedAmountOut?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  failureReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromMint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  intentDeadline?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  intentStatus?: Resolver<Maybe<ResolversTypes['NearIntentStatus']>, ParentType, ContextType>;
  minAmountOut?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nearIntentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originTxHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prefundNearIntentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refundTxHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CustomerSwapStatus'], ParentType, ContextType>;
  toMint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerSwapConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerSwapConnection'] = ResolversParentTypes['CustomerSwapConnection']> = {
  items?: Resolver<Array<ResolversTypes['CustomerSwap']>, ParentType, ContextType>;
  nextCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerSwapSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerSwapSummary'] = ResolversParentTypes['CustomerSwapSummary']> = {
  amountIn?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amountOut?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  destinationTxHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  estimatedAmountOut?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fromMint?: Resolver<ResolversTypes['SwapMintRef'], ParentType, ContextType>;
  originTxHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CustomerSwapStatus'], ParentType, ContextType>;
  swapId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  toMint?: Resolver<ResolversTypes['SwapMintRef'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerTransactionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerTransactions'] = ResolversParentTypes['CustomerTransactions']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  confirmedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customerSwap?: Resolver<Maybe<ResolversTypes['CustomerSwapSummary']>, ParentType, ContextType>;
  failedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  mint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  nearIntent?: Resolver<Maybe<ResolversTypes['NearIntent']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TransactionStatus'], ParentType, ContextType>;
  toAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CustomerTransactionType'], ParentType, ContextType>;
  uiAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usdAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerTransactionsPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerTransactionsPagination'] = ResolversParentTypes['CustomerTransactionsPagination']> = {
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  transactions?: Resolver<Array<ResolversTypes['CustomerTransactions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerWalletResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerWallet'] = ResolversParentTypes['CustomerWallet']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  addresses?: Resolver<Array<ResolversTypes['CustomerDepositAddress']>, ParentType, ContextType>;
  assets?: Resolver<Array<ResolversTypes['Asset']>, ParentType, ContextType>;
  chain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalBalanceUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerWalletsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerWallets'] = ResolversParentTypes['CustomerWallets']> = {
  customerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  wallets?: Resolver<Array<ResolversTypes['CustomerDepositAddress']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerWithdrawalPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerWithdrawalPagination'] = ResolversParentTypes['CustomerWithdrawalPagination']> = {
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  withdrawals?: Resolver<Array<ResolversTypes['MainWalletTransaction']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomersPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomersPagination'] = ResolversParentTypes['CustomersPagination']> = {
  customers?: Resolver<Array<ResolversTypes['Customer']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DepositFlagReasonResolvers<ContextType = any, ParentType extends ResolversParentTypes['DepositFlagReason'] = ResolversParentTypes['DepositFlagReason']> = {
  entityName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entityType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  severity?: Resolver<Maybe<ResolversTypes['RiskScoreSeverity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlaggedDepositResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlaggedDeposit'] = ResolversParentTypes['FlaggedDeposit']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  canUnflag?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  confirmedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customerExternalEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  failedAttempts?: Resolver<Array<ResolversTypes['FlaggedDepositFailedAttempt']>, ParentType, ContextType>;
  flagReason?: Resolver<Maybe<ResolversTypes['DepositFlagReason']>, ParentType, ContextType>;
  fromAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  mint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TransactionStatus'], ParentType, ContextType>;
  toAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uiAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usdAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlaggedDepositFailedAttemptResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlaggedDepositFailedAttempt'] = ResolversParentTypes['FlaggedDepositFailedAttempt']> = {
  action?: Resolver<ResolversTypes['DepositResolution'], ParentType, ContextType>;
  actor?: Resolver<Maybe<ResolversTypes['ResolutionActor']>, ParentType, ContextType>;
  destinationAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  failedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlaggedDepositResolutionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlaggedDepositResolution'] = ResolversParentTypes['FlaggedDepositResolution']> = {
  actor?: Resolver<Maybe<ResolversTypes['ResolutionActor']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customerExternalEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerExternalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  depositTxHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flagReason?: Resolver<Maybe<ResolversTypes['DepositFlagReason']>, ParentType, ContextType>;
  flaggedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  legStatus?: Resolver<Maybe<ResolversTypes['TransactionStatus']>, ParentType, ContextType>;
  legTxHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  resolution?: Resolver<ResolversTypes['DepositResolution'], ParentType, ContextType>;
  resolutionReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resolvedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uiAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usdAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlaggedDepositResolutionsPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlaggedDepositResolutionsPagination'] = ResolversParentTypes['FlaggedDepositResolutionsPagination']> = {
  resolutions?: Resolver<Array<ResolversTypes['FlaggedDepositResolution']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlaggedDepositsPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlaggedDepositsPagination'] = ResolversParentTypes['FlaggedDepositsPagination']> = {
  deposits?: Resolver<Array<ResolversTypes['FlaggedDeposit']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FundedCustomerResolvers<ContextType = any, ParentType extends ResolversParentTypes['FundedCustomer'] = ResolversParentTypes['FundedCustomer']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  depositAmountUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationExternalEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  withdrawalAmountUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FundedCustomersPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['FundedCustomersPagination'] = ResolversParentTypes['FundedCustomersPagination']> = {
  customers?: Resolver<Array<ResolversTypes['FundedCustomer']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GasTopupQuoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['GasTopupQuote'] = ResolversParentTypes['GasTopupQuote']> = {
  amountInSol?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amountInUsd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amountOut?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  detail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GasTopupRequestResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['GasTopupRequestResult'] = ResolversParentTypes['GasTopupRequestResult']> = {
  detail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nearIntentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['GasTopupRequestStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GasTopupStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['GasTopupStatus'] = ResolversParentTypes['GasTopupStatus']> = {
  autoTopupEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  effectiveBalance?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  inFlightIntentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastResultAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paused?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pausedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceReserve?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  target?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trigger?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GasTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GasTransaction'] = ResolversParentTypes['GasTransaction']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  confirmedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fromAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  gasWalletId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  mint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TransactionStatus'], ParentType, ContextType>;
  toAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GasTransactionType'], ParentType, ContextType>;
  uiAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usdAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GasTransactionsPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['GasTransactionsPagination'] = ResolversParentTypes['GasTransactionsPagination']> = {
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  transactions?: Resolver<Array<ResolversTypes['GasTransaction']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GasWalletResolvers<ContextType = any, ParentType extends ResolversParentTypes['GasWallet'] = ResolversParentTypes['GasWallet']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  mint?: Resolver<Maybe<ResolversTypes['Mint']>, ParentType, ContextType>;
  pendingUiBalance?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  topup?: Resolver<Maybe<ResolversTypes['GasTopupStatus']>, ParentType, ContextType>;
  uiBalance?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usdBalance?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetWalletsCustomersResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetWalletsCustomersResponse'] = ResolversParentTypes['GetWalletsCustomersResponse']> = {
  customersWallets?: Resolver<Array<ResolversTypes['CustomerWallets']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalTransferThresholdResolvers<ContextType = any, ParentType extends ResolversParentTypes['InternalTransferThreshold'] = ResolversParentTypes['InternalTransferThreshold']> = {
  amountInUSD?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  chain?: Resolver<Maybe<ResolversTypes['Chain']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Invoice'] = ResolversParentTypes['Invoice']> = {
  amountPaidUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amountUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkoutId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dueDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  externalReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fundsReceivedOnVoid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hostedUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lineItems?: Resolver<Maybe<Array<ResolversTypes['InvoiceLineItem']>>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sessions?: Resolver<Maybe<Array<ResolversTypes['InvoiceSessionSummary']>>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['InvoiceStatus'], ParentType, ContextType>;
  terminalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  voidedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceLineItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoiceLineItem'] = ResolversParentTypes['InvoiceLineItem']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lineTotalUsdSnapshot?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productSnapshot?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unitPriceUsdSnapshot?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceListResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoiceList'] = ResolversParentTypes['InvoiceList']> = {
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['Invoice']>, ParentType, ContextType>;
  nextCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceSessionSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoiceSessionSummary'] = ResolversParentTypes['InvoiceSessionSummary']> = {
  amountReceived?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amountRequired?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amountSent?: Resolver<ResolversTypes['CheckoutSessionAmountSent'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mintChain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mintSymbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rateLocked?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CheckoutSessionStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type MainWalletResolvers<ContextType = any, ParentType extends ResolversParentTypes['MainWallet'] = ResolversParentTypes['MainWallet']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isTestnet?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MainWalletFailedTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MainWalletFailedTransaction'] = ResolversParentTypes['MainWalletFailedTransaction']> = {
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  retriedTransactionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MainWalletPurposeBalanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['MainWalletPurposeBalance'] = ResolversParentTypes['MainWalletPurposeBalance']> = {
  purpose?: Resolver<ResolversTypes['MainWalletPurpose'], ParentType, ContextType>;
  totalBalanceUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MainWalletTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MainWalletTransaction'] = ResolversParentTypes['MainWalletTransaction']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  approvedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  approvedBy?: Resolver<Maybe<ResolversTypes['BatchPayoutActor']>, ParentType, ContextType>;
  confirmedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customerExternalEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerSwap?: Resolver<Maybe<ResolversTypes['CustomerSwapSummary']>, ParentType, ContextType>;
  failedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  initiatedBy?: Resolver<Maybe<ResolversTypes['BatchPayoutActor']>, ParentType, ContextType>;
  invoiceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invoiceNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mainWalletId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  mint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  nearIntent?: Resolver<Maybe<ResolversTypes['NearIntent']>, ParentType, ContextType>;
  prefundIntent?: Resolver<Maybe<ResolversTypes['NearIntent']>, ParentType, ContextType>;
  rejectedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rejectedBy?: Resolver<Maybe<ResolversTypes['BatchPayoutActor']>, ParentType, ContextType>;
  settlementSource?: Resolver<Maybe<ResolversTypes['CheckoutSettlementSource']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TransactionStatus'], ParentType, ContextType>;
  swap?: Resolver<Maybe<ResolversTypes['WithdrawalSwapInfo']>, ParentType, ContextType>;
  swapOriginMint?: Resolver<Maybe<ResolversTypes['Mint']>, ParentType, ContextType>;
  toAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['MainWalletTransactionType'], ParentType, ContextType>;
  uiAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usdAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MainWalletTransactionsPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['MainWalletTransactionsPagination'] = ResolversParentTypes['MainWalletTransactionsPagination']> = {
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  transactions?: Resolver<Array<ResolversTypes['MainWalletTransaction']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MintResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mint'] = ResolversParentTypes['Mint']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  decimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  img?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isNative?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isTestnet?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usdPrice?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  withdrawalSwapSource?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  acceptFlaggedCheckout?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAcceptFlaggedCheckoutArgs, 'attestation' | 'organizationId' | 'sessionId'>>;
  addWithdrawalApprovalEmail?: Resolver<ResolversTypes['WithdrawalApprovalEmail'], ParentType, ContextType, RequireFields<MutationAddWithdrawalApprovalEmailArgs, 'email' | 'organizationId'>>;
  approveTransaction?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationApproveTransactionArgs, 'transactionId'>>;
  archiveTerminalOperator?: Resolver<ResolversTypes['TerminalOperator'], ParentType, ContextType, RequireFields<MutationArchiveTerminalOperatorArgs, 'operatorId' | 'organizationId'>>;
  archiveWithdrawalApprovalEmail?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationArchiveWithdrawalApprovalEmailArgs, 'id' | 'organizationId'>>;
  createBatchPayout?: Resolver<ResolversTypes['BatchPayout'], ParentType, ContextType, RequireFields<MutationCreateBatchPayoutArgs, 'input'>>;
  createInvoice?: Resolver<ResolversTypes['Invoice'], ParentType, ContextType, RequireFields<MutationCreateInvoiceArgs, 'input' | 'organizationId'>>;
  createProduct?: Resolver<ResolversTypes['Product'], ParentType, ContextType, RequireFields<MutationCreateProductArgs, 'input' | 'organizationId'>>;
  createPurposeWalletTransfer?: Resolver<ResolversTypes['PurposeWalletTransferResult'], ParentType, ContextType, RequireFields<MutationCreatePurposeWalletTransferArgs, 'amount' | 'destPurpose' | 'mintId' | 'organizationId' | 'sourcePurpose'>>;
  createSwap?: Resolver<ResolversTypes['ValiantSwap'], ParentType, ContextType, RequireFields<MutationCreateSwapArgs, 'input'>>;
  createTerminalOperator?: Resolver<ResolversTypes['TerminalOperator'], ParentType, ContextType, RequireFields<MutationCreateTerminalOperatorArgs, 'input' | 'organizationId'>>;
  createTerminalPairingCode?: Resolver<ResolversTypes['TerminalPairingCodeResult'], ParentType, ContextType, RequireFields<MutationCreateTerminalPairingCodeArgs, 'organizationId'>>;
  deleteProduct?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteProductArgs, 'organizationId' | 'productId'>>;
  extendInvoice?: Resolver<ResolversTypes['Invoice'], ParentType, ContextType, RequireFields<MutationExtendInvoiceArgs, 'dueDate' | 'id' | 'organizationId'>>;
  logout?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  payAllPlatformBills?: Resolver<ResolversTypes['PlatformBillPaymentResult'], ParentType, ContextType, RequireFields<MutationPayAllPlatformBillsArgs, 'mainWalletPurpose' | 'mintId' | 'organizationId'>>;
  payPlatformBill?: Resolver<ResolversTypes['PlatformBillPaymentResult'], ParentType, ContextType, RequireFields<MutationPayPlatformBillArgs, 'mainWalletPurpose' | 'mintId' | 'organizationId' | 'platformBillId'>>;
  refreshPlayerBalances?: Resolver<ResolversTypes['PlayerBalances'], ParentType, ContextType, RequireFields<MutationRefreshPlayerBalancesArgs, 'organizationId'>>;
  rejectFlaggedCheckout?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRejectFlaggedCheckoutArgs, 'organizationId' | 'sessionId'>>;
  rejectFlaggedDeposit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRejectFlaggedDepositArgs, 'transactionId'>>;
  removeTransaction?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationRemoveTransactionArgs, 'organizationId' | 'transactionId'>>;
  renameTerminalDevice?: Resolver<ResolversTypes['TerminalDevice'], ParentType, ContextType, RequireFields<MutationRenameTerminalDeviceArgs, 'deviceId' | 'name' | 'organizationId'>>;
  requestGasTopup?: Resolver<ResolversTypes['GasTopupRequestResult'], ParentType, ContextType, RequireFields<MutationRequestGasTopupArgs, 'chain' | 'organizationId'>>;
  requestTwoFactorAuth?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resetMyPassword?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  retryTransaction?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationRetryTransactionArgs, 'transactionId'>>;
  revokeTerminalDevice?: Resolver<ResolversTypes['TerminalDevice'], ParentType, ContextType, RequireFields<MutationRevokeTerminalDeviceArgs, 'deviceId' | 'organizationId'>>;
  rollApiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationRollApiKeyArgs, 'organizationId'>>;
  rotatePlayerBalanceWebhookSecret?: Resolver<ResolversTypes['RotatePlayerBalanceWebhookSecretPayload'], ParentType, ContextType, RequireFields<MutationRotatePlayerBalanceWebhookSecretArgs, 'organizationId'>>;
  sendTestWebhookEvent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSendTestWebhookEventArgs, 'eventType' | 'organizationId'>>;
  setCheckoutAutoConversion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetCheckoutAutoConversionArgs, 'enabled' | 'mintId' | 'organizationId'>>;
  setCustomerRequireDepositApproval?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetCustomerRequireDepositApprovalArgs, 'customerId' | 'enabled'>>;
  setDepositAddressRotationEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetDepositAddressRotationEnabledArgs, 'enabled' | 'organizationId'>>;
  setGasTopupAutoEnabled?: Resolver<ResolversTypes['GasWallet'], ParentType, ContextType, RequireFields<MutationSetGasTopupAutoEnabledArgs, 'chain' | 'enabled' | 'organizationId'>>;
  setPlayerBalanceWebhook?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetPlayerBalanceWebhookArgs, 'organizationId' | 'url'>>;
  setRiskScoreThreshold?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetRiskScoreThresholdArgs, 'organizationId' | 'severityThreshold' | 'usdThreshold'>>;
  setTreasuryMintAutoPrefund?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetTreasuryMintAutoPrefundArgs, 'enabled' | 'mintId' | 'organizationId'>>;
  setTreasuryMintAutoSwap?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetTreasuryMintAutoSwapArgs, 'enabled' | 'mintId' | 'organizationId'>>;
  setupTwoFactorAuth?: Resolver<ResolversTypes['SetupTwoFactorAuthResponse'], ParentType, ContextType, RequireFields<MutationSetupTwoFactorAuthArgs, 'secret'>>;
  submitBatchPayout?: Resolver<ResolversTypes['BatchPayout'], ParentType, ContextType, RequireFields<MutationSubmitBatchPayoutArgs, 'id' | 'totpCode'>>;
  unflagDepositTransaction?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUnflagDepositTransactionArgs, 'transactionId'>>;
  updateBatchPayoutLabels?: Resolver<ResolversTypes['BatchPayout'], ParentType, ContextType, RequireFields<MutationUpdateBatchPayoutLabelsArgs, 'input'>>;
  updateEmail?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationUpdateEmailArgs, 'email'>>;
  updateMinimumThreshold?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateMinimumThresholdArgs, 'amountInUSD' | 'chain' | 'organizationId'>>;
  updatePassword?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationUpdatePasswordArgs, 'newPassword' | 'oldPassword'>>;
  updateProduct?: Resolver<ResolversTypes['Product'], ParentType, ContextType, RequireFields<MutationUpdateProductArgs, 'input' | 'organizationId' | 'productId'>>;
  updateReceiveNotifications?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationUpdateReceiveNotificationsArgs, 'receiveNotifications'>>;
  updateTerminalOperator?: Resolver<ResolversTypes['TerminalOperator'], ParentType, ContextType, RequireFields<MutationUpdateTerminalOperatorArgs, 'input' | 'operatorId' | 'organizationId'>>;
  updateUsername?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationUpdateUsernameArgs, 'username'>>;
  voidInvoice?: Resolver<ResolversTypes['Invoice'], ParentType, ContextType, RequireFields<MutationVoidInvoiceArgs, 'id' | 'organizationId'>>;
  withdraw?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationWithdrawArgs, 'amount' | 'mintId' | 'organizationId' | 'purpose' | 'totpCode' | 'whitelistId'>>;
};

export type NearIntentResolvers<ContextType = any, ParentType extends ResolversParentTypes['NearIntent'] = ResolversParentTypes['NearIntent']> = {
  actualAmountOut?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amountIn?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amountInUsd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customerTransactionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deadline?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  depositAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  depositMemo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationTxHashes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  failureReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  minAmountOut?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originAssetId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  originBlockchain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  originSymbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  originTxHashes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  quotedAmountOut?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recipientAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refundFee?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refundTo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slippageToleranceBps?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['NearIntentStatus'], ParentType, ContextType>;
  timeEstimateSeconds?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  withdrawFee?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Organization'] = ResolversParentTypes['Organization']> = {
  batchPayoutsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canRollApiKey?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canViewBilling?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  customerSwapsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  depositAddressRotationEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  internalTransferThreshold?: Resolver<Array<ResolversTypes['InternalTransferThreshold']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nearIntentsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  platformFeeRates?: Resolver<Array<ResolversTypes['PlatformFeeRate']>, ParentType, ContextType>;
  playerBalanceWebhook?: Resolver<ResolversTypes['PlayerBalanceWebhookConfig'], ParentType, ContextType>;
  riskScoreSeverityThreshold?: Resolver<Maybe<ResolversTypes['RiskScoreSeverity']>, ParentType, ContextType>;
  riskScoreUsdThreshold?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  valiantEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  webhookAppId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  whitelist?: Resolver<Array<ResolversTypes['Whitelist']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationWalletResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationWallet'] = ResolversParentTypes['OrganizationWallet']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  assets?: Resolver<Array<ResolversTypes['Asset']>, ParentType, ContextType>;
  chain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isTestnet?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  totalBalanceUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlatformBillResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformBill'] = ResolversParentTypes['PlatformBill']> = {
  dueAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isClosed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  kindUsage?: Resolver<Array<ResolversTypes['PlatformBillKindUsage']>, ParentType, ContextType>;
  lineItems?: Resolver<Array<ResolversTypes['PlatformBillLineItem']>, ParentType, ContextType>;
  mainWalletId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  mainWalletPurpose?: Resolver<ResolversTypes['MainWalletPurpose'], ParentType, ContextType>;
  mintId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paidAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  settledTxRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PlatformBillStatus'], ParentType, ContextType>;
  successorOfId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  unpricedLineCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  usdDueAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  yearMonth?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlatformBillKindUsageResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformBillKindUsage'] = ResolversParentTypes['PlatformBillKindUsage']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  feeBps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['PlatformBillLineItemKind'], ParentType, ContextType>;
  totalFeeAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlatformBillLineItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformBillLineItem'] = ResolversParentTypes['PlatformBillLineItem']> = {
  feeAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  feeBps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  grossAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['PlatformBillLineItemKind'], ParentType, ContextType>;
  sourceTxRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlatformBillListResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformBillList'] = ResolversParentTypes['PlatformBillList']> = {
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['PlatformBill']>, ParentType, ContextType>;
  nextCursor?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlatformBillPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformBillPayment'] = ResolversParentTypes['PlatformBillPayment']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chain?: Resolver<ResolversTypes['Chain'], ParentType, ContextType>;
  coveredBills?: Resolver<Array<ResolversTypes['PlatformBillPaymentCoveredBill']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  mainWalletPurpose?: Resolver<ResolversTypes['MainWalletPurpose'], ParentType, ContextType>;
  mintId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  mintSymbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  settledTxRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PlatformBillPaymentStatus'], ParentType, ContextType>;
  usdDueCovered?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlatformBillPaymentCoveredBillResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformBillPaymentCoveredBill'] = ResolversParentTypes['PlatformBillPaymentCoveredBill']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  yearMonth?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlatformBillPaymentListResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformBillPaymentList'] = ResolversParentTypes['PlatformBillPaymentList']> = {
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['PlatformBillPayment']>, ParentType, ContextType>;
  nextCursor?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlatformBillPaymentResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformBillPaymentResult'] = ResolversParentTypes['PlatformBillPaymentResult']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  billIds?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  mainWalletId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  paymentId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  usdDueCovered?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlatformBillSummaryBucketResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformBillSummaryBucket'] = ResolversParentTypes['PlatformBillSummaryBucket']> = {
  dueAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mainWalletPurpose?: Resolver<ResolversTypes['MainWalletPurpose'], ParentType, ContextType>;
  mintId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlatformBillUsdBreakdownRowResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformBillUsdBreakdownRow'] = ResolversParentTypes['PlatformBillUsdBreakdownRow']> = {
  cryptoFeeTotal?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mainWalletPurpose?: Resolver<ResolversTypes['MainWalletPurpose'], ParentType, ContextType>;
  mintId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  period?: Resolver<ResolversTypes['PlatformBillUsdPeriod'], ParentType, ContextType>;
  snapshotUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  unpricedLineCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlatformBillUsdDueResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformBillUsdDue'] = ResolversParentTypes['PlatformBillUsdDue']> = {
  accruingUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  breakdown?: Resolver<Array<ResolversTypes['PlatformBillUsdBreakdownRow']>, ParentType, ContextType>;
  dueNowUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlatformFeeRateResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformFeeRate'] = ResolversParentTypes['PlatformFeeRate']> = {
  defaultBps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  effectiveBps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['PlatformFeeKind'], ParentType, ContextType>;
  overrideBps?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlayerBalanceTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlayerBalanceToken'] = ResolversParentTypes['PlayerBalanceToken']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chain?: Resolver<Maybe<ResolversTypes['Chain']>, ParentType, ContextType>;
  isTestnet?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mintId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  symbol?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  usdValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlayerBalanceWebhookConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlayerBalanceWebhookConfig'] = ResolversParentTypes['PlayerBalanceWebhookConfig']> = {
  hasSecret?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isConfigured?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlayerBalancesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlayerBalances'] = ResolversParentTypes['PlayerBalances']> = {
  fetchedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isStale?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['PlayerBalanceSnapshotStatus']>, ParentType, ContextType>;
  tokens?: Resolver<Array<ResolversTypes['PlayerBalanceToken']>, ParentType, ContextType>;
  totalUsd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['Product'] = ResolversParentTypes['Product']> = {
  acceptedNetworksTokens?: Resolver<Maybe<Array<ResolversTypes['ChainToken']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  creationSource?: Resolver<ResolversTypes['ProductCreationSource'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  priceUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ProductStatus'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductListResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductList'] = ResolversParentTypes['ProductList']> = {
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['Product']>, ParentType, ContextType>;
  nextCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurposeTransferSpendableResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeTransferSpendable'] = ResolversParentTypes['PurposeTransferSpendable']> = {
  confirmed?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  networkFeeReserve?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  spendable?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurposeWalletTransferResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeWalletTransfer'] = ResolversParentTypes['PurposeWalletTransfer']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  confirmedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  destPurpose?: Resolver<ResolversTypes['MainWalletPurpose'], ParentType, ContextType>;
  failedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  sourcePurpose?: Resolver<ResolversTypes['MainWalletPurpose'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PurposeWalletTransferStatus'], ParentType, ContextType>;
  toAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uiAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usdAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurposeWalletTransferResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeWalletTransferResult'] = ResolversParentTypes['PurposeWalletTransferResult']> = {
  outTransactionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  transferId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurposeWalletTransfersPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeWalletTransfersPagination'] = ResolversParentTypes['PurposeWalletTransfersPagination']> = {
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  transfers?: Resolver<Array<ResolversTypes['PurposeWalletTransfer']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  batchPayout?: Resolver<Maybe<ResolversTypes['BatchPayout']>, ParentType, ContextType, RequireFields<QueryBatchPayoutArgs, 'id'>>;
  batchPayouts?: Resolver<Array<ResolversTypes['BatchPayout']>, ParentType, ContextType, RequireFields<QueryBatchPayoutsArgs, 'organizationId'>>;
  checkoutConversionPolicies?: Resolver<Array<ResolversTypes['CheckoutConversionPolicy']>, ParentType, ContextType, RequireFields<QueryCheckoutConversionPoliciesArgs, 'organizationId'>>;
  customerSwap?: Resolver<Maybe<ResolversTypes['CustomerSwap']>, ParentType, ContextType, RequireFields<QueryCustomerSwapArgs, 'id' | 'organizationId'>>;
  customerSwaps?: Resolver<ResolversTypes['CustomerSwapConnection'], ParentType, ContextType, RequireFields<QueryCustomerSwapsArgs, 'organizationId'>>;
  customerSwapsExport?: Resolver<Array<ResolversTypes['CustomerSwap']>, ParentType, ContextType, RequireFields<QueryCustomerSwapsExportArgs, 'organizationId'>>;
  gasTopupQuote?: Resolver<ResolversTypes['GasTopupQuote'], ParentType, ContextType, RequireFields<QueryGasTopupQuoteArgs, 'chain' | 'organizationId'>>;
  getBatchPayoutBalances?: Resolver<Array<ResolversTypes['BatchPayoutTokenBalance']>, ParentType, ContextType, RequireFields<QueryGetBatchPayoutBalancesArgs, 'chain' | 'isTestnet' | 'organizationId'>>;
  getBatchPayoutWallet?: Resolver<ResolversTypes['BatchPayoutWallet'], ParentType, ContextType, RequireFields<QueryGetBatchPayoutWalletArgs, 'chain' | 'isTestnet' | 'organizationId'>>;
  getCheckoutDepositAddresses?: Resolver<ResolversTypes['CheckoutDepositAddressList'], ParentType, ContextType, RequireFields<QueryGetCheckoutDepositAddressesArgs, 'organizationId'>>;
  getCheckoutPenaltyDetail?: Resolver<ResolversTypes['CheckoutPenaltyDetail'], ParentType, ContextType, RequireFields<QueryGetCheckoutPenaltyDetailArgs, 'mainWalletTransactionId' | 'organizationId'>>;
  getCheckoutSettlementDetail?: Resolver<ResolversTypes['CheckoutSettlementDetail'], ParentType, ContextType, RequireFields<QueryGetCheckoutSettlementDetailArgs, 'mainWalletTransactionId' | 'organizationId'>>;
  getCheckoutSwapEligibility?: Resolver<ResolversTypes['CheckoutSwapEligibility'], ParentType, ContextType, RequireFields<QueryGetCheckoutSwapEligibilityArgs, 'checkoutId' | 'organizationId'>>;
  getCheckoutsWithSessions?: Resolver<ResolversTypes['CheckoutList'], ParentType, ContextType, RequireFields<QueryGetCheckoutsWithSessionsArgs, 'organizationId'>>;
  getCustomer?: Resolver<ResolversTypes['Customer'], ParentType, ContextType, RequireFields<QueryGetCustomerArgs, 'customerId'>>;
  getCustomerLedger?: Resolver<ResolversTypes['CustomerLedgerPagination'], ParentType, ContextType, RequireFields<QueryGetCustomerLedgerArgs, 'customerId' | 'hideSmall' | 'kind' | 'limit' | 'organizationId' | 'page'>>;
  getCustomerLifetimeTotals?: Resolver<Array<ResolversTypes['CustomerLifetimeTotal']>, ParentType, ContextType, RequireFields<QueryGetCustomerLifetimeTotalsArgs, 'customerId'>>;
  getCustomerTransactions?: Resolver<ResolversTypes['CustomerTransactionsPagination'], ParentType, ContextType, RequireFields<QueryGetCustomerTransactionsArgs, 'customerId' | 'hideSmall' | 'limit' | 'organizationId' | 'page'>>;
  getCustomerWallets?: Resolver<Maybe<Array<ResolversTypes['CustomerWallet']>>, ParentType, ContextType, RequireFields<QueryGetCustomerWalletsArgs, 'customerId'>>;
  getCustomerWithdrawals?: Resolver<ResolversTypes['CustomerWithdrawalPagination'], ParentType, ContextType, RequireFields<QueryGetCustomerWithdrawalsArgs, 'customerId' | 'hideSmall' | 'limit' | 'organizationId' | 'page'>>;
  getCustomers?: Resolver<ResolversTypes['CustomersPagination'], ParentType, ContextType, RequireFields<QueryGetCustomersArgs, 'limit' | 'organizationId' | 'page'>>;
  getCustomersTransactions?: Resolver<ResolversTypes['CustomerTransactionsPagination'], ParentType, ContextType, RequireFields<QueryGetCustomersTransactionsArgs, 'hideSmall' | 'limit' | 'organizationId' | 'page' | 'purpose'>>;
  getEthGasOwed?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryGetEthGasOwedArgs, 'organizationId'>>;
  getFlaggedCheckouts?: Resolver<ResolversTypes['CheckoutFlagReviewList'], ParentType, ContextType, RequireFields<QueryGetFlaggedCheckoutsArgs, 'organizationId'>>;
  getFlaggedDepositResolutions?: Resolver<ResolversTypes['FlaggedDepositResolutionsPagination'], ParentType, ContextType, RequireFields<QueryGetFlaggedDepositResolutionsArgs, 'limit' | 'organizationId' | 'page'>>;
  getFlaggedDeposits?: Resolver<ResolversTypes['FlaggedDepositsPagination'], ParentType, ContextType, RequireFields<QueryGetFlaggedDepositsArgs, 'limit' | 'organizationId' | 'page'>>;
  getFundedCustomers?: Resolver<ResolversTypes['FundedCustomersPagination'], ParentType, ContextType, RequireFields<QueryGetFundedCustomersArgs, 'limit' | 'organizationId' | 'page'>>;
  getGasTransactions?: Resolver<ResolversTypes['GasTransactionsPagination'], ParentType, ContextType, RequireFields<QueryGetGasTransactionsArgs, 'hideSmall' | 'limit' | 'organizationId' | 'page'>>;
  getGasWallets?: Resolver<Array<ResolversTypes['GasWallet']>, ParentType, ContextType, RequireFields<QueryGetGasWalletsArgs, 'organizationId'>>;
  getInvoice?: Resolver<Maybe<ResolversTypes['Invoice']>, ParentType, ContextType, RequireFields<QueryGetInvoiceArgs, 'id' | 'organizationId'>>;
  getInvoices?: Resolver<ResolversTypes['InvoiceList'], ParentType, ContextType, RequireFields<QueryGetInvoicesArgs, 'organizationId'>>;
  getMainWalletBalancesByPurpose?: Resolver<Array<ResolversTypes['MainWalletPurposeBalance']>, ParentType, ContextType, RequireFields<QueryGetMainWalletBalancesByPurposeArgs, 'organizationId'>>;
  getMainWalletTransactions?: Resolver<ResolversTypes['MainWalletTransactionsPagination'], ParentType, ContextType, RequireFields<QueryGetMainWalletTransactionsArgs, 'hideSmall' | 'limit' | 'organizationId' | 'page' | 'purpose'>>;
  getMints?: Resolver<Array<ResolversTypes['Mint']>, ParentType, ContextType, RequireFields<QueryGetMintsArgs, 'organizationId' | 'surface'>>;
  getOrganization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<QueryGetOrganizationArgs, 'organizationId'>>;
  getPlatformBillSummary?: Resolver<Array<ResolversTypes['PlatformBillSummaryBucket']>, ParentType, ContextType, RequireFields<QueryGetPlatformBillSummaryArgs, 'organizationId'>>;
  getPlatformBillUsdDue?: Resolver<ResolversTypes['PlatformBillUsdDue'], ParentType, ContextType, RequireFields<QueryGetPlatformBillUsdDueArgs, 'organizationId'>>;
  getPlayerBalances?: Resolver<ResolversTypes['PlayerBalances'], ParentType, ContextType, RequireFields<QueryGetPlayerBalancesArgs, 'organizationId'>>;
  getProduct?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType, RequireFields<QueryGetProductArgs, 'organizationId' | 'productId'>>;
  getProducts?: Resolver<ResolversTypes['ProductList'], ParentType, ContextType, RequireFields<QueryGetProductsArgs, 'organizationId'>>;
  getPurposeWalletTransfers?: Resolver<ResolversTypes['PurposeWalletTransfersPagination'], ParentType, ContextType, RequireFields<QueryGetPurposeWalletTransfersArgs, 'limit' | 'organizationId' | 'page'>>;
  getTerminalDevices?: Resolver<Array<ResolversTypes['TerminalDevice']>, ParentType, ContextType, RequireFields<QueryGetTerminalDevicesArgs, 'organizationId'>>;
  getTerminalOperators?: Resolver<Array<ResolversTypes['TerminalOperator']>, ParentType, ContextType, RequireFields<QueryGetTerminalOperatorsArgs, 'organizationId'>>;
  getTestWebhookEventTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  getTransactionsToApprove?: Resolver<ResolversTypes['MainWalletTransactionsPagination'], ParentType, ContextType, RequireFields<QueryGetTransactionsToApproveArgs, 'limit' | 'organizationId' | 'page' | 'purpose'>>;
  getUser?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  getUsersOfOrganization?: Resolver<ResolversTypes['getUsersOfOrganization'], ParentType, ContextType, RequireFields<QueryGetUsersOfOrganizationArgs, 'limit' | 'organizationId'>>;
  getWallets?: Resolver<Array<ResolversTypes['OrganizationWallet']>, ParentType, ContextType, RequireFields<QueryGetWalletsArgs, 'organizationId' | 'purpose'>>;
  getWalletsCustomers?: Resolver<ResolversTypes['GetWalletsCustomersResponse'], ParentType, ContextType, RequireFields<QueryGetWalletsCustomersArgs, 'limit' | 'organizationId' | 'page'>>;
  getWalletsGas?: Resolver<Array<ResolversTypes['WalletBasic']>, ParentType, ContextType, RequireFields<QueryGetWalletsGasArgs, 'organizationId'>>;
  getWalletsMain?: Resolver<Array<ResolversTypes['MainWallet']>, ParentType, ContextType, RequireFields<QueryGetWalletsMainArgs, 'organizationId' | 'purpose'>>;
  getWebhookIFrameUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryGetWebhookIFrameUrlArgs, 'organizationId'>>;
  getWhitelist?: Resolver<Array<ResolversTypes['Whitelist']>, ParentType, ContextType, RequireFields<QueryGetWhitelistArgs, 'organizationId'>>;
  getWithdrawThreshold?: Resolver<ResolversTypes['WithdrawThreshold'], ParentType, ContextType, RequireFields<QueryGetWithdrawThresholdArgs, 'organizationId'>>;
  listPlatformBillPayments?: Resolver<ResolversTypes['PlatformBillPaymentList'], ParentType, ContextType, RequireFields<QueryListPlatformBillPaymentsArgs, 'organizationId'>>;
  listPlatformBills?: Resolver<ResolversTypes['PlatformBillList'], ParentType, ContextType, RequireFields<QueryListPlatformBillsArgs, 'organizationId'>>;
  nearIntent?: Resolver<Maybe<ResolversTypes['NearIntent']>, ParentType, ContextType, RequireFields<QueryNearIntentArgs, 'intentId' | 'organizationId'>>;
  nearIntents?: Resolver<Array<ResolversTypes['NearIntent']>, ParentType, ContextType, RequireFields<QueryNearIntentsArgs, 'organizationId'>>;
  platformFeeRecipient?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryPlatformFeeRecipientArgs, 'chain'>>;
  purposeTransferSpendable?: Resolver<ResolversTypes['PurposeTransferSpendable'], ParentType, ContextType, RequireFields<QueryPurposeTransferSpendableArgs, 'mintId' | 'organizationId' | 'purpose'>>;
  reportingMonthlySummary?: Resolver<Array<ResolversTypes['ReportingMonthlySummary']>, ParentType, ContextType, RequireFields<QueryReportingMonthlySummaryArgs, 'organizationId' | 'purpose'>>;
  reportingSwaps?: Resolver<Array<ResolversTypes['SwapsReportingSwap']>, ParentType, ContextType, RequireFields<QueryReportingSwapsArgs, 'from' | 'organizationId' | 'to'>>;
  reportingSwapsMonthlySummary?: Resolver<Array<ResolversTypes['SwapsReportingMonthlySummary']>, ParentType, ContextType, RequireFields<QueryReportingSwapsMonthlySummaryArgs, 'organizationId'>>;
  reportingSwapsWindowedTotals?: Resolver<ResolversTypes['ReportingSwapsWindowedTotals'], ParentType, ContextType, RequireFields<QueryReportingSwapsWindowedTotalsArgs, 'organizationId' | 'timezone'>>;
  reportingTimeSeries?: Resolver<ResolversTypes['ReportingTimeSeries'], ParentType, ContextType, RequireFields<QueryReportingTimeSeriesArgs, 'from' | 'granularity' | 'organizationId' | 'purpose' | 'timezone' | 'to'>>;
  reportingTransactions?: Resolver<Array<ResolversTypes['ReportingTransaction']>, ParentType, ContextType, RequireFields<QueryReportingTransactionsArgs, 'from' | 'organizationId' | 'purpose' | 'to'>>;
  reportingWindowedTotals?: Resolver<ResolversTypes['ReportingWindowedTotals'], ParentType, ContextType, RequireFields<QueryReportingWindowedTotalsArgs, 'organizationId' | 'purpose' | 'timezone'>>;
  treasuryMintPolicies?: Resolver<Array<ResolversTypes['TreasuryMintPolicy']>, ParentType, ContextType, RequireFields<QueryTreasuryMintPoliciesArgs, 'organizationId'>>;
  valiantMints?: Resolver<Array<ResolversTypes['ValiantMint']>, ParentType, ContextType, RequireFields<QueryValiantMintsArgs, 'organizationId'>>;
  valiantSwap?: Resolver<Maybe<ResolversTypes['ValiantSwap']>, ParentType, ContextType, RequireFields<QueryValiantSwapArgs, 'organizationId' | 'swapId'>>;
  valiantSwappableAssets?: Resolver<Array<ResolversTypes['ValiantSwappableAsset']>, ParentType, ContextType, RequireFields<QueryValiantSwappableAssetsArgs, 'organizationId'>>;
  valiantSwaps?: Resolver<Array<ResolversTypes['ValiantSwap']>, ParentType, ContextType, RequireFields<QueryValiantSwapsArgs, 'organizationId'>>;
  valiantWhitelistedAddresses?: Resolver<Array<ResolversTypes['ValiantWhitelistedAddress']>, ParentType, ContextType, RequireFields<QueryValiantWhitelistedAddressesArgs, 'organizationId'>>;
  withdrawableBalance?: Resolver<ResolversTypes['WithdrawableBalance'], ParentType, ContextType, RequireFields<QueryWithdrawableBalanceArgs, 'mintId' | 'organizationId' | 'purpose'>>;
  withdrawalApprovalEmails?: Resolver<Array<ResolversTypes['WithdrawalApprovalEmail']>, ParentType, ContextType, RequireFields<QueryWithdrawalApprovalEmailsArgs, 'organizationId'>>;
  withdrawalSwapDestinations?: Resolver<Array<ResolversTypes['WithdrawalSwapDestination']>, ParentType, ContextType, RequireFields<QueryWithdrawalSwapDestinationsArgs, 'chain' | 'organizationId'>>;
  withdrawalSwapQuote?: Resolver<ResolversTypes['WithdrawalSwapQuote'], ParentType, ContextType, RequireFields<QueryWithdrawalSwapQuoteArgs, 'amount' | 'destinationAssetId' | 'mintId' | 'organizationId' | 'purpose' | 'whitelistId'>>;
};

export type ReportingCountUsdResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportingCountUsd'] = ResolversParentTypes['ReportingCountUsd']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  usdValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportingMetricStableWindowsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportingMetricStableWindows'] = ResolversParentTypes['ReportingMetricStableWindows']> = {
  lifetimeToYesterday?: Resolver<ResolversTypes['ReportingCountUsd'], ParentType, ContextType>;
  monthToYesterday?: Resolver<ResolversTypes['ReportingCountUsd'], ParentType, ContextType>;
  priorSixDays?: Resolver<ResolversTypes['ReportingCountUsd'], ParentType, ContextType>;
  yesterday?: Resolver<ResolversTypes['ReportingCountUsd'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportingMetricTodayWindowResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportingMetricTodayWindow'] = ResolversParentTypes['ReportingMetricTodayWindow']> = {
  today?: Resolver<ResolversTypes['ReportingCountUsd'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportingMetricWindowedTotalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportingMetricWindowedTotals'] = ResolversParentTypes['ReportingMetricWindowedTotals']> = {
  metric?: Resolver<ResolversTypes['KpiFlowMetric'], ParentType, ContextType>;
  stable?: Resolver<ResolversTypes['ReportingMetricStableWindows'], ParentType, ContextType>;
  today?: Resolver<ResolversTypes['ReportingMetricTodayWindow'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportingMonthlySummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportingMonthlySummary'] = ResolversParentTypes['ReportingMonthlySummary']> = {
  depositsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  depositsUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fundingCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  fundingUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  paymentsUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payoutsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  payoutsUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refundsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  refundsUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  withdrawalsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  withdrawalsUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  yearMonth?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportingSwapWindowBucketResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportingSwapWindowBucket'] = ResolversParentTypes['ReportingSwapWindowBucket']> = {
  swapsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  volumeUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportingSwapsStableWindowsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportingSwapsStableWindows'] = ResolversParentTypes['ReportingSwapsStableWindows']> = {
  lifetimeToYesterday?: Resolver<ResolversTypes['ReportingSwapWindowBucket'], ParentType, ContextType>;
  monthToYesterday?: Resolver<ResolversTypes['ReportingSwapWindowBucket'], ParentType, ContextType>;
  priorSixDays?: Resolver<ResolversTypes['ReportingSwapWindowBucket'], ParentType, ContextType>;
  yesterday?: Resolver<ResolversTypes['ReportingSwapWindowBucket'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportingSwapsTodayWindowResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportingSwapsTodayWindow'] = ResolversParentTypes['ReportingSwapsTodayWindow']> = {
  today?: Resolver<ResolversTypes['ReportingSwapWindowBucket'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportingSwapsWindowedTotalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportingSwapsWindowedTotals'] = ResolversParentTypes['ReportingSwapsWindowedTotals']> = {
  stable?: Resolver<ResolversTypes['ReportingSwapsStableWindows'], ParentType, ContextType>;
  timezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  today?: Resolver<ResolversTypes['ReportingSwapsTodayWindow'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportingTimeSeriesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportingTimeSeries'] = ResolversParentTypes['ReportingTimeSeries']> = {
  buckets?: Resolver<Array<ResolversTypes['ReportingTimeSeriesBucket']>, ParentType, ContextType>;
  granularity?: Resolver<ResolversTypes['TimeSeriesGranularity'], ParentType, ContextType>;
  purpose?: Resolver<ResolversTypes['MainWalletPurpose'], ParentType, ContextType>;
  rangeTotals?: Resolver<ResolversTypes['ReportingTimeSeriesRangeTotals'], ParentType, ContextType>;
  timezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportingTimeSeriesBucketResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportingTimeSeriesBucket'] = ResolversParentTypes['ReportingTimeSeriesBucket']> = {
  bucketStart?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  depositsUsd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salesUsd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uniqueBuyers?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uniqueDepositors?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uniqueWithdrawers?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  withdrawalsUsd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportingTimeSeriesRangeTotalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportingTimeSeriesRangeTotals'] = ResolversParentTypes['ReportingTimeSeriesRangeTotals']> = {
  depositsUsd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salesUsd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uniqueBuyers?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uniqueDepositors?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uniqueWithdrawers?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  withdrawalsUsd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportingTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportingTransaction'] = ResolversParentTypes['ReportingTransaction']> = {
  batchLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chain?: Resolver<ResolversTypes['Chain'], ParentType, ContextType>;
  confirmedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  counterparty?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  explorerUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  metric?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TransactionStatus'], ParentType, ContextType>;
  toAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tokenAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tokenSymbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usdPrice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  usdValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  usdValueMissing?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportingWindowedTotalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportingWindowedTotals'] = ResolversParentTypes['ReportingWindowedTotals']> = {
  metrics?: Resolver<Array<ResolversTypes['ReportingMetricWindowedTotals']>, ParentType, ContextType>;
  purpose?: Resolver<ResolversTypes['MainWalletPurpose'], ParentType, ContextType>;
  timezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResolutionActorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResolutionActor'] = ResolversParentTypes['ResolutionActor']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['ResolutionActorKind'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RotatePlayerBalanceWebhookSecretPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RotatePlayerBalanceWebhookSecretPayload'] = ResolversParentTypes['RotatePlayerBalanceWebhookSecretPayload']> = {
  secret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetupTwoFactorAuthResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetupTwoFactorAuthResponse'] = ResolversParentTypes['SetupTwoFactorAuthResponse']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  has2fa?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  receiveNotifications?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  recoveryCodes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SwapMintRefResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwapMintRef'] = ResolversParentTypes['SwapMintRef']> = {
  chain?: Resolver<ResolversTypes['Chain'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SwapsReportingMonthlySummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwapsReportingMonthlySummary'] = ResolversParentTypes['SwapsReportingMonthlySummary']> = {
  feesUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  swapsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  volumeUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  yearMonth?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SwapsReportingSwapResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwapsReportingSwap'] = ResolversParentTypes['SwapsReportingSwap']> = {
  confirmedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  depositExplorerUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  depositTxid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  explorerUrls?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  fee?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feeBps?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  feeUsd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fromTokenSymbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  toAmountHuman?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toTokenSymbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txHashes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  volumeUsd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  volumeUsdMissing?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TerminalDeviceResolvers<ContextType = any, ParentType extends ResolversParentTypes['TerminalDevice'] = ResolversParentTypes['TerminalDevice']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastSeenAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pairedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  revokedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TerminalDeviceStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TerminalOperatorResolvers<ContextType = any, ParentType extends ResolversParentTypes['TerminalOperator'] = ResolversParentTypes['TerminalOperator']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TerminalOperatorStatus'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TerminalPairingCodeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['TerminalPairingCodeResult'] = ResolversParentTypes['TerminalPairingCodeResult']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreasuryMintPolicyResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreasuryMintPolicy'] = ResolversParentTypes['TreasuryMintPolicy']> = {
  autoPrefundFromSolUsdc?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  autoSwapToSolUsdc?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  eligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ineligibilityCode?: Resolver<Maybe<ResolversTypes['TreasuryMintPolicyIneligibility']>, ParentType, ContextType>;
  ineligibilityReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  prefundEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  prefundIneligibilityCode?: Resolver<Maybe<ResolversTypes['TreasuryMintPrefundIneligibility']>, ParentType, ContextType>;
  prefundIneligibilityReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  has2fa?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  organizations?: Resolver<Array<ResolversTypes['Organization']>, ParentType, ContextType>;
  receiveNotifications?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValiantMintResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValiantMint'] = ResolversParentTypes['ValiantMint']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  decimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  displayDecimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValiantSwapResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValiantSwap'] = ResolversParentTypes['ValiantSwap']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  depositRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  depositStage?: Resolver<ResolversTypes['SwapDepositStage'], ParentType, ContextType>;
  depositTxid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  earmarkedAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  failureReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromMint?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  overallStatus?: Resolver<ResolversTypes['SwapOverallStatus'], ParentType, ContextType>;
  swapId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  swapStage?: Resolver<ResolversTypes['SwapStage'], ParentType, ContextType>;
  toAmountHuman?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toMint?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  txHashes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  whitelistedAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  whitelistedAddressId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  whitelistedChain?: Resolver<ResolversTypes['Chain'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValiantSwappableAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValiantSwappableAsset'] = ResolversParentTypes['ValiantSwappableAsset']> = {
  availableBalance?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  availableBalanceHuman?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cheddarMint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  nativeFeeCapPerGas?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valiantMintId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValiantWhitelistedAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValiantWhitelistedAddress'] = ResolversParentTypes['ValiantWhitelistedAddress']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WalletBasicResolvers<ContextType = any, ParentType extends ResolversParentTypes['WalletBasic'] = ResolversParentTypes['WalletBasic']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WhitelistResolvers<ContextType = any, ParentType extends ResolversParentTypes['Whitelist'] = ResolversParentTypes['Whitelist']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chain?: Resolver<ResolversTypes['Chain'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WithdrawThresholdResolvers<ContextType = any, ParentType extends ResolversParentTypes['WithdrawThreshold'] = ResolversParentTypes['WithdrawThreshold']> = {
  customers?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  main?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WithdrawableBalanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['WithdrawableBalance'] = ResolversParentTypes['WithdrawableBalance']> = {
  balance?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  maxWithdrawable?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  networkFeeReserve?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WithdrawalApprovalEmailResolvers<ContextType = any, ParentType extends ResolversParentTypes['WithdrawalApprovalEmail'] = ResolversParentTypes['WithdrawalApprovalEmail']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WithdrawalSwapAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['WithdrawalSwapAsset'] = ResolversParentTypes['WithdrawalSwapAsset']> = {
  assetId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chain?: Resolver<ResolversTypes['Chain'], ParentType, ContextType>;
  decimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WithdrawalSwapDestinationResolvers<ContextType = any, ParentType extends ResolversParentTypes['WithdrawalSwapDestination'] = ResolversParentTypes['WithdrawalSwapDestination']> = {
  assetId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chain?: Resolver<ResolversTypes['Chain'], ParentType, ContextType>;
  cheddarMintId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  decimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WithdrawalSwapFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['WithdrawalSwapFee'] = ResolversParentTypes['WithdrawalSwapFee']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WithdrawalSwapInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['WithdrawalSwapInfo'] = ResolversParentTypes['WithdrawalSwapInfo']> = {
  actualAmountOut?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationAssetId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  destinationChain?: Resolver<Maybe<ResolversTypes['Chain']>, ParentType, ContextType>;
  destinationDecimals?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  destinationSymbol?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationTxHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maxSlippageBps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  minAmountOut?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotedAmountOut?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recipientAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['WithdrawalSwapStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WithdrawalSwapQuoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['WithdrawalSwapQuote'] = ResolversParentTypes['WithdrawalSwapQuote']> = {
  deadline?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  destinationAsset?: Resolver<ResolversTypes['WithdrawalSwapAsset'], ParentType, ContextType>;
  minAmountOut?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quotedAmountOut?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quotedOutUsd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceUsd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  swapFee?: Resolver<ResolversTypes['WithdrawalSwapFee'], ParentType, ContextType>;
  withdrawalFee?: Resolver<ResolversTypes['WithdrawalSwapFee'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetUsersOfOrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['getUsersOfOrganization'] = ResolversParentTypes['getUsersOfOrganization']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Asset?: AssetResolvers<ContextType>;
  BatchPayout?: BatchPayoutResolvers<ContextType>;
  BatchPayoutActor?: BatchPayoutActorResolvers<ContextType>;
  BatchPayoutNetworkFee?: BatchPayoutNetworkFeeResolvers<ContextType>;
  BatchPayoutRecipient?: BatchPayoutRecipientResolvers<ContextType>;
  BatchPayoutTokenBalance?: BatchPayoutTokenBalanceResolvers<ContextType>;
  BatchPayoutWallet?: BatchPayoutWalletResolvers<ContextType>;
  ChainToken?: ChainTokenResolvers<ContextType>;
  CheckoutConversionPolicy?: CheckoutConversionPolicyResolvers<ContextType>;
  CheckoutDepositAddress?: CheckoutDepositAddressResolvers<ContextType>;
  CheckoutDepositAddressList?: CheckoutDepositAddressListResolvers<ContextType>;
  CheckoutFlagReview?: CheckoutFlagReviewResolvers<ContextType>;
  CheckoutFlagReviewList?: CheckoutFlagReviewListResolvers<ContextType>;
  CheckoutLineItemSummary?: CheckoutLineItemSummaryResolvers<ContextType>;
  CheckoutList?: CheckoutListResolvers<ContextType>;
  CheckoutPenaltyDetail?: CheckoutPenaltyDetailResolvers<ContextType>;
  CheckoutPenaltyRefund?: CheckoutPenaltyRefundResolvers<ContextType>;
  CheckoutSessionAmountSent?: CheckoutSessionAmountSentResolvers<ContextType>;
  CheckoutSessionSummary?: CheckoutSessionSummaryResolvers<ContextType>;
  CheckoutSessionSwap?: CheckoutSessionSwapResolvers<ContextType>;
  CheckoutSettlementCheckoutInfo?: CheckoutSettlementCheckoutInfoResolvers<ContextType>;
  CheckoutSettlementDeposit?: CheckoutSettlementDepositResolvers<ContextType>;
  CheckoutSettlementDetail?: CheckoutSettlementDetailResolvers<ContextType>;
  CheckoutSettlementNetworkFee?: CheckoutSettlementNetworkFeeResolvers<ContextType>;
  CheckoutSettlementPlatformFee?: CheckoutSettlementPlatformFeeResolvers<ContextType>;
  CheckoutSettlementSessionDetail?: CheckoutSettlementSessionDetailResolvers<ContextType>;
  CheckoutSummary?: CheckoutSummaryResolvers<ContextType>;
  CheckoutSwapEligibility?: CheckoutSwapEligibilityResolvers<ContextType>;
  Customer?: CustomerResolvers<ContextType>;
  CustomerDepositAddress?: CustomerDepositAddressResolvers<ContextType>;
  CustomerLedgerPagination?: CustomerLedgerPaginationResolvers<ContextType>;
  CustomerLedgerTransaction?: CustomerLedgerTransactionResolvers<ContextType>;
  CustomerLifetimeTotal?: CustomerLifetimeTotalResolvers<ContextType>;
  CustomerSwap?: CustomerSwapResolvers<ContextType>;
  CustomerSwapConnection?: CustomerSwapConnectionResolvers<ContextType>;
  CustomerSwapSummary?: CustomerSwapSummaryResolvers<ContextType>;
  CustomerTransactions?: CustomerTransactionsResolvers<ContextType>;
  CustomerTransactionsPagination?: CustomerTransactionsPaginationResolvers<ContextType>;
  CustomerWallet?: CustomerWalletResolvers<ContextType>;
  CustomerWallets?: CustomerWalletsResolvers<ContextType>;
  CustomerWithdrawalPagination?: CustomerWithdrawalPaginationResolvers<ContextType>;
  CustomersPagination?: CustomersPaginationResolvers<ContextType>;
  DepositFlagReason?: DepositFlagReasonResolvers<ContextType>;
  FlaggedDeposit?: FlaggedDepositResolvers<ContextType>;
  FlaggedDepositFailedAttempt?: FlaggedDepositFailedAttemptResolvers<ContextType>;
  FlaggedDepositResolution?: FlaggedDepositResolutionResolvers<ContextType>;
  FlaggedDepositResolutionsPagination?: FlaggedDepositResolutionsPaginationResolvers<ContextType>;
  FlaggedDepositsPagination?: FlaggedDepositsPaginationResolvers<ContextType>;
  FundedCustomer?: FundedCustomerResolvers<ContextType>;
  FundedCustomersPagination?: FundedCustomersPaginationResolvers<ContextType>;
  GasTopupQuote?: GasTopupQuoteResolvers<ContextType>;
  GasTopupRequestResult?: GasTopupRequestResultResolvers<ContextType>;
  GasTopupStatus?: GasTopupStatusResolvers<ContextType>;
  GasTransaction?: GasTransactionResolvers<ContextType>;
  GasTransactionsPagination?: GasTransactionsPaginationResolvers<ContextType>;
  GasWallet?: GasWalletResolvers<ContextType>;
  GetWalletsCustomersResponse?: GetWalletsCustomersResponseResolvers<ContextType>;
  InternalTransferThreshold?: InternalTransferThresholdResolvers<ContextType>;
  Invoice?: InvoiceResolvers<ContextType>;
  InvoiceLineItem?: InvoiceLineItemResolvers<ContextType>;
  InvoiceList?: InvoiceListResolvers<ContextType>;
  InvoiceSessionSummary?: InvoiceSessionSummaryResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  MainWallet?: MainWalletResolvers<ContextType>;
  MainWalletFailedTransaction?: MainWalletFailedTransactionResolvers<ContextType>;
  MainWalletPurposeBalance?: MainWalletPurposeBalanceResolvers<ContextType>;
  MainWalletTransaction?: MainWalletTransactionResolvers<ContextType>;
  MainWalletTransactionsPagination?: MainWalletTransactionsPaginationResolvers<ContextType>;
  Mint?: MintResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NearIntent?: NearIntentResolvers<ContextType>;
  Organization?: OrganizationResolvers<ContextType>;
  OrganizationWallet?: OrganizationWalletResolvers<ContextType>;
  PlatformBill?: PlatformBillResolvers<ContextType>;
  PlatformBillKindUsage?: PlatformBillKindUsageResolvers<ContextType>;
  PlatformBillLineItem?: PlatformBillLineItemResolvers<ContextType>;
  PlatformBillList?: PlatformBillListResolvers<ContextType>;
  PlatformBillPayment?: PlatformBillPaymentResolvers<ContextType>;
  PlatformBillPaymentCoveredBill?: PlatformBillPaymentCoveredBillResolvers<ContextType>;
  PlatformBillPaymentList?: PlatformBillPaymentListResolvers<ContextType>;
  PlatformBillPaymentResult?: PlatformBillPaymentResultResolvers<ContextType>;
  PlatformBillSummaryBucket?: PlatformBillSummaryBucketResolvers<ContextType>;
  PlatformBillUsdBreakdownRow?: PlatformBillUsdBreakdownRowResolvers<ContextType>;
  PlatformBillUsdDue?: PlatformBillUsdDueResolvers<ContextType>;
  PlatformFeeRate?: PlatformFeeRateResolvers<ContextType>;
  PlayerBalanceToken?: PlayerBalanceTokenResolvers<ContextType>;
  PlayerBalanceWebhookConfig?: PlayerBalanceWebhookConfigResolvers<ContextType>;
  PlayerBalances?: PlayerBalancesResolvers<ContextType>;
  Product?: ProductResolvers<ContextType>;
  ProductList?: ProductListResolvers<ContextType>;
  PurposeTransferSpendable?: PurposeTransferSpendableResolvers<ContextType>;
  PurposeWalletTransfer?: PurposeWalletTransferResolvers<ContextType>;
  PurposeWalletTransferResult?: PurposeWalletTransferResultResolvers<ContextType>;
  PurposeWalletTransfersPagination?: PurposeWalletTransfersPaginationResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  ReportingCountUsd?: ReportingCountUsdResolvers<ContextType>;
  ReportingMetricStableWindows?: ReportingMetricStableWindowsResolvers<ContextType>;
  ReportingMetricTodayWindow?: ReportingMetricTodayWindowResolvers<ContextType>;
  ReportingMetricWindowedTotals?: ReportingMetricWindowedTotalsResolvers<ContextType>;
  ReportingMonthlySummary?: ReportingMonthlySummaryResolvers<ContextType>;
  ReportingSwapWindowBucket?: ReportingSwapWindowBucketResolvers<ContextType>;
  ReportingSwapsStableWindows?: ReportingSwapsStableWindowsResolvers<ContextType>;
  ReportingSwapsTodayWindow?: ReportingSwapsTodayWindowResolvers<ContextType>;
  ReportingSwapsWindowedTotals?: ReportingSwapsWindowedTotalsResolvers<ContextType>;
  ReportingTimeSeries?: ReportingTimeSeriesResolvers<ContextType>;
  ReportingTimeSeriesBucket?: ReportingTimeSeriesBucketResolvers<ContextType>;
  ReportingTimeSeriesRangeTotals?: ReportingTimeSeriesRangeTotalsResolvers<ContextType>;
  ReportingTransaction?: ReportingTransactionResolvers<ContextType>;
  ReportingWindowedTotals?: ReportingWindowedTotalsResolvers<ContextType>;
  ResolutionActor?: ResolutionActorResolvers<ContextType>;
  RotatePlayerBalanceWebhookSecretPayload?: RotatePlayerBalanceWebhookSecretPayloadResolvers<ContextType>;
  SetupTwoFactorAuthResponse?: SetupTwoFactorAuthResponseResolvers<ContextType>;
  SwapMintRef?: SwapMintRefResolvers<ContextType>;
  SwapsReportingMonthlySummary?: SwapsReportingMonthlySummaryResolvers<ContextType>;
  SwapsReportingSwap?: SwapsReportingSwapResolvers<ContextType>;
  TerminalDevice?: TerminalDeviceResolvers<ContextType>;
  TerminalOperator?: TerminalOperatorResolvers<ContextType>;
  TerminalPairingCodeResult?: TerminalPairingCodeResultResolvers<ContextType>;
  TreasuryMintPolicy?: TreasuryMintPolicyResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  ValiantMint?: ValiantMintResolvers<ContextType>;
  ValiantSwap?: ValiantSwapResolvers<ContextType>;
  ValiantSwappableAsset?: ValiantSwappableAssetResolvers<ContextType>;
  ValiantWhitelistedAddress?: ValiantWhitelistedAddressResolvers<ContextType>;
  WalletBasic?: WalletBasicResolvers<ContextType>;
  Whitelist?: WhitelistResolvers<ContextType>;
  WithdrawThreshold?: WithdrawThresholdResolvers<ContextType>;
  WithdrawableBalance?: WithdrawableBalanceResolvers<ContextType>;
  WithdrawalApprovalEmail?: WithdrawalApprovalEmailResolvers<ContextType>;
  WithdrawalSwapAsset?: WithdrawalSwapAssetResolvers<ContextType>;
  WithdrawalSwapDestination?: WithdrawalSwapDestinationResolvers<ContextType>;
  WithdrawalSwapFee?: WithdrawalSwapFeeResolvers<ContextType>;
  WithdrawalSwapInfo?: WithdrawalSwapInfoResolvers<ContextType>;
  WithdrawalSwapQuote?: WithdrawalSwapQuoteResolvers<ContextType>;
  getUsersOfOrganization?: GetUsersOfOrganizationResolvers<ContextType>;
};

